webpackJsonp([1],{

/***/ 12:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(67);

var _assign2 = _interopRequireDefault(_assign);

var _stringify = __webpack_require__(89);

var _stringify2 = _interopRequireDefault(_stringify);

var _constant = __webpack_require__(88);

var _constant2 = _interopRequireDefault(_constant);

var _md = __webpack_require__(474);

var _md2 = _interopRequireDefault(_md);

var _bowser = __webpack_require__(90);

var _bowser2 = _interopRequireDefault(_bowser);

var _codemapper = __webpack_require__(31);

var _codemapper2 = _interopRequireDefault(_codemapper);

var _sm = __webpack_require__(207);

var _sm2 = _interopRequireDefault(_sm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PUB = '-----BEGIN PUBLIC KEY-----MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC5gsH+AA4XWONB5TDcUd+xCz7ejOFHZKlcZDx+pF1i7Gsvi1vjyJoQhRtRSn950x498VUkx7rUxg1/ScBVfrRxQOZ8xFBye3pjAzfb22+RCuYApSVpJ3OO3KsEuKExftz9oFBv3ejxPlYc5yq7YiBO8XlTnQN0Sa4R4qhPO3I2MQIDAQAB-----END PUBLIC KEY-----';

if (window.Worker) {
  try {
    var myworkertest = new Worker(URL.createObjectURL(new Blob()));
    myworkertest.onerror = function () {
      try {
        window.Worker = null;
      } catch (e) {}
    };
  } catch (e) {
    try {
      window.Worker = null;
    } catch (e) {}
  }
}
var cssTemplate = '.c-main>button{background:{mainColor} !important;}.c-main>a,.c-main>a:active,.c-main>a:hover,.c-main>strong{color:{mainColor} !important}.c-main.u-btn-sms>button{color:{mainColor} !important;background:#fff!important;border-left:1px solid #d0d0d0!important}.c-main .i-checkbox.checked{background-color:{mainColor} !important;}';
var commonMail = {
  'qq.com': 'https://mail.qq.com',
  'sina.com': 'https://mail.sina.com',
  'foxmail.com': 'http://mail.foxmail.com',
  'sohu.com': 'https://mail.sohu.com',
  'vip.qq.com': 'http://mail.vip.qq.com',
  'live.com': 'https://mail.live.com',
  '139.com': 'https://mail.139.com',
  'tom.com': 'http://mail.tom.com',
  'icloud.com': 'https://mail.icloud.com',
  'aliyun.com': 'https://mail.aliyun.com',
  'edu.tw': 'http://mail.edu.tw'
};

var NEEDSM = 1;

var sm4pubkey = 'BC60B8B9E4FFEFFA219E5AD77F11F9E2';

var capfailcount = 0;
var CAPCODEMAP = {
  '441': 1,
  '444': 4,
  '445': 5,
  '447': 6
};
exports.default = {
  filterMsg: function filterMsg(btntxt) {
    btntxt = btntxt.trim(/ /g, '');
    return '\u9A8C\u8BC1\u5931\u8D25\uFF0C\u8BF7\u518D\u6B21\u70B9\u51FB' + btntxt + '\u6309\u94AE';
  },
  getCodeMessage: function getCodeMessage(res, api) {
    var defaultTxt = '\u7F51\u7EDC\u5F02\u5E38\uFF0C\u8BF7\u7A0D\u540E\u518D\u8BD5';
    var code = res.ret || res;
    var dt = res.dt || '';
    var dtcode = code;
    var apicode = void 0;
    if (dt) {
      dtcode = code + '_' + dt;
    }
    apicode = api + '_' + dtcode;
    var txt = _codemapper2.default[apicode] || _codemapper2.default[code] || defaultTxt;
    return txt;
  },
  getCapFlagByCode: function getCapFlagByCode(code) {
    return CAPCODEMAP[code];
  },
  isMobile: function isMobile() {
    return !!_bowser2.default.mobile;
  },
  CapFailCount: function CapFailCount(add) {
    if (add) {
      capfailcount++;
    }
    return capfailcount >= 5;
  },
  createConfirm: function createConfirm(un) {
    return function () {
      un = encodeURIComponent(un);
      var promark = _constant2.default.promark;
      window.open('https://id.163.com/mail/login.html?promark=' + promark + '&username=' + un + '&curl=https%3A%2F%2Fid.163.com%2Fmail%2Fverify.html%23%2FbindMobile');
    };
  },
  createUnlock: function createUnlock(un) {
    return function () {
      un = encodeURIComponent(un);
      window.open('https://id.163.com/mail/unlock.html?username=' + un);
    };
  },
  createVerifyLink: function createVerifyLink(un) {
    return function () {
      var pkid = _constant2.default.promark;
      var pd = _constant2.default.product;
      window.open('https://id.163.com/mail/stable.html?username=' + un + '&source=zjlogin&product=' + pd + '&zj_promark=' + pkid);
    };
  },
  createLogoutConfirm: function createLogoutConfirm(un) {
    return function () {
      un = encodeURIComponent(un);
      window.open('https://id.163.com/mail/logoutQuery.html?username=' + un);
    };
  },
  createVipLinkConfirm: function createVipLinkConfirm(sign, product) {
    return function () {
      sign = encodeURIComponent(sign);
      window.open('https://vpay.vip.163.com/center/index.html?sign=' + sign + '&from=' + product + '&utm_source=' + product);
    };
  },
  createFindPwdConfirm: function createFindPwdConfirm(un) {
    return function () {
      un = encodeURIComponent(un);
      window.open('https://id.163.com/mail/retrievepassword?h5dl=1&username=' + un);
    };
  },
  createMailLinkHelp: function createMailLinkHelp() {
    return function () {
      window.open('https://hc.reg.163.com/webcomponentH5/doc.html?id=552&itemid=320');
    };
  },
  createMailLink: function createMailLink(url) {
    return function () {
      window.open(url);
    };
  },
  hasMailLink: function hasMailLink(un) {
    var suffix = un.split('@')[1];
    return commonMail[suffix];
  },
  insertFrame: function insertFrame(url, opd, loadfunc) {
    if (location.protocol === 'https:') {
      url = url.replace('http:', 'https:');
    }

    url = url + (url.indexOf('?') >= 0 ? '&' : '?') + 'opd=' + opd;
    url = this.tryAddSm(url).realurl;

    var iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.addEventListener('load', function () {
      loadfunc();
    });
    document.body.appendChild(iframe);

    window.setTimeout(function () {
      iframe.src = url;
    }, 0);
  },
  appendMainColor: function appendMainColor(mainColor) {
    if (!mainColor) {
      return;
    }
    var cssText = cssTemplate;
    cssText = cssText.replace(/\{mainColor\}/g, '#' + mainColor).replace(/[\s\r\n]+/gi, ' ');

    var sty = document.createElement('style');

    sty.textContent = cssText;

    document.head.appendChild(sty);
  },
  appendBackColor: function appendBackColor(color) {
    if (!color) {
      return;
    }
    var cssText = 'html{background:{color} !important;}';
    cssText = cssText.replace(/\{color\}/g, '#' + color).replace(/[\s\r\n]+/gi, ' ');

    var sty = document.createElement('style');

    sty.textContent = cssText;

    document.head.appendChild(sty);
  },
  merge: function merge(ori, src) {
    for (var key in src) {
      if (src.hasOwnProperty(key)) {
        ori[key] = src[key];
      }
    }
  },
  getUrlSearch: function getUrlSearch(name) {
    name = name.toLowerCase();
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
    var r = window.location.search.substr(1).match(reg);
    if (r != undefined) {
      try {
        return decodeURIComponent(r[2]);
      } catch (_e) {
        return null;
      }
    }
    return null;
  },
  isTypeOf: function isTypeOf(_data, _type) {
    try {
      _type = _type.toLowerCase();
      if (_data === null) return _type === 'null';
      if (_data === undefined) return _type === 'undefined';
      return Object.prototype.toString.call(_data).toLowerCase() === '[object ' + _type + ']';
    } catch (e) {
      return !1;
    }
  },
  isFunction: function isFunction(_data) {
    return this.isTypeOf(_data, 'function');
  },
  isData: function isData(_data) {
    return this.isTypeOf(_data, 'date');
  },
  isArray: function isArray(_data) {
    return this.isTypeOf(_data, 'array');
  },
  isObject: function isObject(_data) {
    return this.isTypeOf(_data, 'object');
  },
  encrypt: function encrypt(t1, t2) {
    var key = window.RSA.getPublicKey(PUB);
    return window.RSA.encrypt(t1 + '`' + t2, key);
  },
  encrypt2: function encrypt2(t1) {
    var key = window.RSA.getPublicKey(PUB);
    return window.RSA.encrypt(t1, key);
  },
  getCookie: function getCookie(name) {
    var arr,
        reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');

    if (arr = document.cookie.match(reg)) {
      return decodeURIComponent(arr[2]);
    } else {
      return undefined;
    }
  },
  setCookie: function setCookie(opt) {
    var cookieText = encodeURIComponent(opt.name) + '=' + encodeURIComponent(opt.value);
    if (this.isData(opt.expires)) {
      cookieText += ' ; expires=' + opt.expires.toGMTString();
    }
    if (opt.path) {
      cookieText += ' ; path=' + opt.path;
    }
    if (opt.domain) {
      cookieText += ' ; domain=' + opt.domain;
    }
    if (opt.secure) {
      cookieText += ' ; secure';
    }
    document.cookie = cookieText;
  },
  getRtid: function getRtid() {
    var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz',
        size = 32,
        arr = [];
    while (size-- > 0) {
      arr[size] = chars.charAt(Math.random() * chars.length);
    }
    return arr.join('');
  },
  getUtid: function getUtid() {
    var utid = this.getCookie('utid');
    if (utid === undefined) {
      utid = this.getRtid();
      var date = new Date();

      date.setTime(date.getTime() + 10 * 365 * 24 * 60 * 60 * 1000);
      this.setCookie({
        name: 'utid',
        value: utid,
        expires: date,
        path: '/'
      });
    }
    return utid;
  },

  _doFlLog: function () {
    var _infoList = ['device_name', 'user_agent', 'language', 'color_depth', 'pixel_ratio', 'hardware_concurrency', 'computer_screen', 'browser_window_size', 'timezone_offset', 'regular_plugins', 'js_fonts', 'webgl_vendor', 'touch_support', 'canvas', 'webgl', 'HTTP_ACCEPT_Headers'];
    var _infoList2 = ['dn', 'ua', 'la', 'cd', 'pr', 'hc', 'cs', 'bws', 'tzo', 'plg', 'jsf', 'wv', 'ts', 'ca', 'wgl', 'hah'];
    var _formatDi = function _formatDi(_fpobj) {
      var _di, _plg;
      if (_fpobj && _fpobj.di) {
        _di = JSON.parse(_fpobj.di);
        if (_di.plg) {
          _plg = _di.plg;
          for (var i = 0, l = _plg.length, item; i < l; i++) {
            item = _plg[i];
            item = item.split(':')[0];
            _plg[i] = item;
          }
        }
        _di.plg = _plg;
        _fpobj.di = (0, _stringify2.default)(_di);
      }
      return _fpobj;
    };
    var _sendPF = function _sendPF(_fpobj) {
      _fpobj.src = 'WEBZJ';
      _fpobj.time = new Date().getTime();
      var _src = '//fl.reg.163.com/urs/__utm.gif?';
      if (window.$NEEDV6) {
        _src = '//fl-v6.reg.163.com/urs/__utm.gif?';
      }
      var _tempArr = [];
      _fpobj = _formatDi(_fpobj);
      for (var _o in _fpobj) {
        _tempArr.push(encodeURIComponent(_o) + '=' + encodeURIComponent(_fpobj[_o]));
      }
      _src = _src + _tempArr.join('&');
      var _img = document.createElement('img');
      _img.style.position = 'absolute';
      _img.style.height = '0px';
      _img.style.width = '0px';
      document.body.appendChild(_img);
      _img.src = _src;

      setTimeout(function () {
        document.body.removeChild(_img);
      }, 10000);
    };
    var _getBrowserInfo2 = function _getBrowserInfo2(_utid, _rtid) {
      var _fpobj = {};
      var _di = {
        'page': 2
      };
      _di['from'] = 'webzj-h5dl';
      _fpobj.di = (0, _stringify2.default)(_di);
      _fpobj.utid = _utid;
      _fpobj.rtid = _rtid;
      _sendPF(_fpobj);
    };
    var _getBrowserInfo = function _getBrowserInfo(_utid, _rtid, that) {
      try {
        var _fp = new Fingerprint2();
        _fp.get(function (result, components) {
          var _di = {},
              _temp = {},
              _fpobj = {},
              _jsf,
              _jsfList = [];
          _di['from'] = 'webzj-h5dl';
          var _ursfp = that.getCookie('NTES_WEB_FP');
          if (_ursfp) {
            result = _ursfp || '';
          } else {
            var date = new Date();

            date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000);
            that.setCookie({
              name: 'NTES_WEB_FP',
              value: result || '',
              expires: date,
              path: '/'
            });
          }
          _di['fp'] = result || '';

          for (var _i = 0, _item; _i < components.length; _i++) {
            _item = components[_i];
            _temp[_item.key] = _item.value;
          }
          for (var i = 0, _item1, _item2, l = _infoList.length; i < l; i++) {
            _item1 = _infoList[i];
            _item2 = _infoList2[i];
            _di[_item2] = _temp[_item1] || '';
          }
          _jsf = _di['jsf'];
          _jsfList = [];
          for (var _k = 0, _j; _k < _jsf.length; _k++) {
            _j = _jsf[_k];
            var _fj = _j.substring(0, 1);
            _jsfList.push(_fj);
          }
          _jsf = _jsfList.join('');
          _di['jsf'] = _jsf.length + '-' + (0, _md2.default)(_jsf);
          _di['ca'] = _fp.x64hash128(_di['ca']);
          _di['wgl'] = _fp.x64hash128(_di['wgl']);
          _di.page = 1;
          _di = (0, _stringify2.default)(_di);
          _fpobj.di = _di;
          _fpobj.utid = _utid;
          _fpobj.rtid = _rtid;
          _sendPF(_fpobj);
        });
      } catch (e) {
        _getBrowserInfo2(_utid, _rtid);
      }
    };
    return function (_utid, _rtid) {
      var that = this;
      setTimeout(function () {
        _getBrowserInfo(_utid, _rtid, that);
      }, 200);
    };
  }(),
  sendZwlog: function sendZwlog(_index) {
    var img = document.createElement('img');
    img.src = 'https://pr.nss.netease.com/sentry/passive?uapi=h5maildl&dataTime=0&clusterName=urs-webzj-static-passive&modelName=webzj_response_h5maildl&one=1&url=' + _index;
  },
  getSmState: function getSmState() {
    return NEEDSM;
  },
  doSm4: function doSm4(data) {
    return {
      encParams: _sm2.default.encrypt(data, sm4pubkey)
    };
  },
  objToParams: function objToParams(object) {
    var list = [];
    for (var key in object) {
      if (Object.hasOwnProperty.call(object, key)) {
        var element = object[key] || '';
        list.push(key + '=' + element);
      }
    }
    return list.join('&');
  },
  getImgUrl: function getImgUrl(opd, un) {
    var host = '/dl';
    var data = {
      pd: _constant2.default.product,
      pkid: _constant2.default.promark,
      opd: opd,
      rtid: this.getRtid()
    };
    if (un) {
      data.un = un;
    }
    var time = new Date().getTime();
    if (NEEDSM) {
      data.channel = 0;
      data = (0, _stringify2.default)(data);
      var newData = this.doSm4(data);
      newData.nocache = time;

      host = '/dl/zj/mail';

      return host + '/cp?' + this.objToParams(newData);
    } else {
      data.nocache = time;

      return host + '/cp?' + this.objToParams(data);
    }
  },
  isCanSmUrl: function isCanSmUrl(url) {
    var path = url.split('?')[0] || '';
    return (/\/dl\/common\/setCookie$/.test(path)
    );
  },
  tryAddSm: function tryAddSm(_url) {
    var _search, _path, _urlList, _paramobj, _tempurl, _encParams;
    if (this.getSmState() && this.isCanSmUrl(_url)) {
      _urlList = _url.split('?');
      _path = _urlList[0] || '';
      _search = _urlList[1] || '';
      if (_search) {
        _paramobj = {};
        _search = _search.split('&');
        _search.forEach(function (_item) {
          var _itemList = _item.split('=');
          if (_itemList[0]) {
            _paramobj[_itemList[0]] = _itemList[1] || '';
          }
        });
      }
      var _paramobjstr = (0, _stringify2.default)(_paramobj);
      _encParams = this.doSm4(_paramobjstr).encParams;
      _tempurl = _search ? _path + '?encParams=' + _encParams : _path;
      return {
        realurl: _tempurl,
        paramobj: _paramobj
      };
    } else {
      return {
        realurl: _url
      };
    }
  },
  hasPuzzle: function hasPuzzle(data) {
    return data && data.args && data.args.puzzle;
  },
  getParams: function getParams(obj, splitstr) {
    var paramsArray = [];
    for (var key in obj) {
      var param = key + '=' + obj[key];
      paramsArray.push(param);
    }
    return paramsArray.join(splitstr);
  },
  doNssLog: function doNssLog() {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var params = {
      clusterName: 'urs-webzj-static-passive',
      modelName: 'webzj_response_h5maildl',
      one: 1,
      dataTime: new Date().getTime()
    };
    var allParams = (0, _assign2.default)({}, params, obj);
    for (var key in allParams) {
      if (allParams[key] === 0) {
        allParams[key] = '0';
      }
    }
    var paramStr = this.getParams(allParams, '&');

    try {
      var img = document.createElement('img');
      img.src = 'https://pr.nss.netease.com/sentry/passive?' + paramStr;
    } catch (e) {}
  },


  doNgLog: function doNgLog() {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    try {
      var allParams = (0, _assign2.default)({}, obj);
      var paramStr = this.getParams(allParams, '&');

      var img = new Image();
      img.src = '//dl.reg.163.com/UA1435545636633/__utm.gif?' + paramStr;
      img.style.display = 'none';
      document.body.appendChild(img);
      setTimeout(function () {
        document.body.removeChild(img);
      }, 800);
    } catch (e) {}
  }
};

/***/ }),

/***/ 176:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(528);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(477);

var _App2 = _interopRequireDefault(_App);

var _Login = __webpack_require__(485);

var _Login2 = _interopRequireDefault(_Login);

var _Verify = __webpack_require__(492);

var _Verify2 = _interopRequireDefault(_Verify);

var _Uinput = __webpack_require__(491);

var _Uinput2 = _interopRequireDefault(_Uinput);

var _Pwdinput = __webpack_require__(487);

var _Pwdinput2 = _interopRequireDefault(_Pwdinput);

var _Button = __webpack_require__(478);

var _Button2 = _interopRequireDefault(_Button);

var _Suggest = __webpack_require__(489);

var _Suggest2 = _interopRequireDefault(_Suggest);

var _MbInput = __webpack_require__(486);

var _MbInput2 = _interopRequireDefault(_MbInput);

var _Capture = __webpack_require__(479);

var _Capture2 = _interopRequireDefault(_Capture);

var _Loading = __webpack_require__(484);

var _Loading2 = _interopRequireDefault(_Loading);

var _Verifymb = __webpack_require__(494);

var _Verifymb2 = _interopRequireDefault(_Verifymb);

var _Verifyopt = __webpack_require__(495);

var _Verifyopt2 = _interopRequireDefault(_Verifyopt);

var _Verifyluo = __webpack_require__(493);

var _Verifyluo2 = _interopRequireDefault(_Verifyluo);

var _SmsUp = __webpack_require__(488);

var _SmsUp2 = _interopRequireDefault(_SmsUp);

var _Verifyppc = __webpack_require__(496);

var _Verifyppc2 = _interopRequireDefault(_Verifyppc);

var _Toast = __webpack_require__(490);

var _Toast2 = _interopRequireDefault(_Toast);

var _Confirm = __webpack_require__(480);

var _Confirm2 = _interopRequireDefault(_Confirm);

var _ErrorPage = __webpack_require__(481);

var _ErrorPage2 = _interopRequireDefault(_ErrorPage);

var _Form = __webpack_require__(482);

var _Form2 = _interopRequireDefault(_Form);

var _FormItem = __webpack_require__(483);

var _FormItem2 = _interopRequireDefault(_FormItem);

var _preAccount = __webpack_require__(501);

var _preAccount2 = _interopRequireDefault(_preAccount);

var _jumploading = __webpack_require__(498);

var _jumploading2 = _interopRequireDefault(_jumploading);

var _mode = __webpack_require__(499);

var _mode2 = _interopRequireDefault(_mode);

var _util = __webpack_require__(12);

var _util2 = _interopRequireDefault(_util);

var _iconfont = __webpack_require__(206);

var _iconfont2 = _interopRequireDefault(_iconfont);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

String.prototype.trim = function () {
    return this.replace(/(^\s*)|(\s*$)/g, '');
};
_vue2.default.config.productionTip = false;

_vue2.default.component('login', _Login2.default);
_vue2.default.component('urs-input', _Uinput2.default);
_vue2.default.component('urs-pwdinput', _Pwdinput2.default);
_vue2.default.component('urs-button', _Button2.default);
_vue2.default.component('verify', _Verify2.default);
_vue2.default.component('verifymb', _Verifymb2.default);
_vue2.default.component('verifyopt', _Verifyopt2.default);
_vue2.default.component('suggest', _Suggest2.default);
_vue2.default.component('urs-mbinput', _MbInput2.default);
_vue2.default.component('urs-capture', _Capture2.default);
_vue2.default.component('loading', _Loading2.default);
_vue2.default.component('verifyluo', _Verifyluo2.default);
_vue2.default.component('smsup', _SmsUp2.default);
_vue2.default.component('verifyppc', _Verifyppc2.default);
_vue2.default.component('toast', _Toast2.default);
_vue2.default.component('confirm', _Confirm2.default);
_vue2.default.component('errorpage', _ErrorPage2.default);
_vue2.default.component('form-item', _FormItem2.default);
_vue2.default.component('Form', _Form2.default);
_vue2.default.component('pre-account', _preAccount2.default);
_vue2.default.component('jumploading', _jumploading2.default);
_vue2.default.component('mode', _mode2.default);

new _vue2.default({
    el: '#app',
    template: '<App/>',
    components: { App: _App2.default }
});

window.Loading = new _vue2.default({
    el: '#loading',
    template: '<loading :loading="loading" />',
    data: {
        loading: true
    }
});

window.jumpLoading = new _vue2.default({
    el: '#jumpLoading',
    template: '<jumploading :loading="loading" />',
    data: {
        loading: false
    }
});

window.Toast = new _vue2.default({
    el: '#toast',
    template: '<toast ref="toast" />',
    methods: {
        show: function show(cnt, time) {
            this.$refs.toast.show(cnt);
        }
    }
});

window.Confirm = new _vue2.default({
    el: '#confirm',
    template: '<confirm ref="confirm"/>',
    methods: {
        show: function show(options) {
            this.$refs.confirm.show(options);
        }
    }
});

window.showError = function (cnt) {
    if (!cnt) {
        window.Toast.show('未知错误，请刷新页面重试');
        return;
    }

    if (_util2.default.isTypeOf(cnt, 'string')) {
        window.Toast.show(cnt);
        return;
    }

    if (_util2.default.isObject(cnt)) {
        if (!cnt.type) return;
        switch (cnt.type) {
            case 'toast':
                if (!cnt.msg) break;
                window.Toast.show(cnt.msg);
                break;
            case 'confirm':
                if (!cnt.opt) break;
                window.Confirm.show(cnt.opt);
                break;
            default:
                window.Toast.show('未知错误');
                break;
        }
    }
};

/***/ }),

/***/ 178:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _util = __webpack_require__(12);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'app',
    data: function data() {
        return {
            currentView: 'login',
            un: '',
            errMsg: '未知错误',
            modeData: {},
            toUrl: ''
        };
    },

    watch: {
        currentView: function currentView(val, oldVal) {
            if (val !== 'login') {
                window.Loading.loading = true;
            }
        }
    },

    created: function created() {
        this.showPage();
    },


    methods: {
        changeToVerify: function changeToVerify(opts) {
            this.currentView = 'verify';
            this.un = opts.un;
            this.ppdata = opts.data;
        },
        changeToLogin: function changeToLogin(data) {
            this.currentView = 'login';
            if (!!data.autoLogin) {
                this.$refs.login.getTicket();
            }
            if (data.errMsg) {
                if (data.ret === '454') {
                    data.errMsg.opt.confirm = _util2.default.createConfirm(data.un);
                }
                if (data.ret === '452') {
                    data.errMsg.opt.confirm = _util2.default.createLogoutConfirm(data.un);
                }
                window.showError(data.errMsg);
            }
        },
        changeToError: function changeToError(errMsg) {
            this.currentView = 'error';
            this.errMsg = errMsg;
        },
        changeToMode: function changeToMode(mode, toUrl) {
            this.currentView = 'mode';
            this.modeData = mode;
            this.toUrl = toUrl;
        },
        showPage: function showPage() {
            try {
                window.addEventListener('pageshow', function (event) {
                    if (event && event.persisted || window.performance && window.performance.navigation && window.performance.navigation.type === 2) {
                        location.reload();
                    }
                }, false);
            } catch (e) {}
        }
    }
};

/***/ }),

/***/ 179:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'urs-button',
  props: {
    enableTip: {
      type: String,
      default: '下一步'
    },
    countingTip: {
      type: String,
      default: '[count]s'
    },
    defaultState: {
      type: String,
      default: 'enable'
    },
    enableLoading: {
      type: Boolean,
      default: true
    },
    loading_clazz: {
      type: String,
      default: 'i-icon i-icon-loading'
    },
    count: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      state: this.defaultState,
      countNum: this.count,
      disabled: false
    };
  },

  computed: {
    tip: function tip() {
      switch (this.state) {
        case 'counting':
          return this.countingTip.replace('[count]', this.countNum);
        default:
          return this.enableTip;
      }
    },
    showLoading: function showLoading() {
      return this.enableLoading && this.state == 'loading';
    }
  },
  watch: {
    state: function state(val) {
      this.disabled = !(val === 'enable');
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.sto) {
      window.clearTimeout(this.sto);
    }
  },

  methods: {
    setState: function setState(state, tip) {
      this.state = state;
      if (tip) {
        this.tip = tip;
      }
    },
    onClick: function onClick(event) {
      this.$emit('click');
    },
    countDown: function countDown() {
      var _this = this;

      if (this.count == 0) {
        return;
      }
      this.setState('counting');
      this.sto = window.setTimeout(function () {
        _this.countNum--;
        if (_this.countNum < 0) {
          window.clearTimeout(_this.sto);
          _this.countNum = _this.count;
          _this.setState('enable');
          return;
        }
        _this.countDown();
      }, 1000);
    }
  }
};

/***/ }),

/***/ 180:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = __webpack_require__(67);

var _assign2 = _interopRequireDefault(_assign);

var _util = __webpack_require__(12);

var _util2 = _interopRequireDefault(_util);

var _config = __webpack_require__(204);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getWidth = function getWidth() {
    var _w = 375;
    _w = document.body.clientWidth ? document.body.clientWidth - 50 * 0.8 - 2 : 375;
    return _w >= 450 || _w <= 0 ? 450 : _w;
};

var regimg = /^\w{1,12}$/;
var regimgRight = /^\w{4}$/;

var capConfig = (0, _assign2.default)({
    popupStyles: {
        capBarHeight: 40,
        capPadding: 45,
        width: 450,
        top: "auto"
    },
    mode: "bind"
}, _config.AICAPCONF);

exports.default = {
    name: 'urs-capture',
    props: {
        capType: {
            type: Number,
            default: 0
        },
        opd: String,
        capKey: String,
        aiCapKey: String,
        mail: {
            type: String,
            default: ""
        },
        aicapbtn: {
            type: Object,
            default: function _default() {
                return {};
            }
        },
        autoVerify: {
            type: Boolean,
            default: false
        }
    },
    data: function data() {
        return {
            imgCapUrl: '',
            verifyFlag: 0,
            capValidate: undefined,
            cycleCount: 0
        };
    },
    mounted: function mounted() {
        this.initCap();
    },

    watch: {
        capType: function capType(val) {
            this.initCap();
        }
    },
    beforeDestroy: function beforeDestroy() {
        this.clearStl();
        this.destroyInstance();
    },

    methods: {
        imgcapInput: function imgcapInput() {
            if (regimgRight.test(this.$refs.capInput.currentValue)) {
                this.$emit('verify');
            }
        },
        initImage: function initImage() {
            var _this = this;

            var un = '';
            try {
                un = document.getElementsByName('account')[0].value;
            } catch (error) {}
            var imgCapUrl = _util2.default.getImgUrl(this.opd, un);
            if (document.referrer && !_util2.default.getSmState()) {
                imgCapUrl = imgCapUrl + '&topURL=' + encodeURIComponent(document.referrer.slice(0, 200));
            }
            this.imgCapUrl = imgCapUrl;

            this.$nextTick(function () {
                _this.$refs.capInput.currentValue = '';
            });
        },
        initCap: function initCap() {
            this.destroyInstance();

            if (this.capType === 1) {
                this.initImage();
            } else {
                this.loadCap();
            }
        },
        loadCap: function loadCap() {
            var _this2 = this;

            if (window.initNECaptcha) {
                this.clearStl();
                if (this.capType === 4 || this.capType === 5) {
                    this.initNormalCap();
                } else if (this.capType === 6) {
                    this.initAiCap();
                }
            } else {
                if (this.cycleCount >= 100) {
                    this.clearStl();
                    window.showError("加载失败，请刷新页面重试");
                } else {
                    this.stl = setTimeout(function () {
                        _this2.cycleCount++;
                        _this2.loadCap();
                    }, 200);
                }
            }
        },
        getAiCapKey: function getAiCapKey() {
            return capConfig.captchaId;
        },
        initNormalCap: function initNormalCap() {
            var opts = {
                element: this.$refs.sCaptcha,
                captchaType: this.capType - 2,
                captchaId: this.capKey,
                width: getWidth(),
                protocol: 'https',
                mode: 'float',
                wmServerConfig: {
                    "configServer": "webzjac.reg.163.com",
                    "apiServer": "webzjac.reg.163.com",
                    "staticServer": "acstatic-dun.126.net"
                },
                apiServer: ['webzjcaptcha.reg.163.com', 'c.dun.163yun.com'],
                onVerify: this.verifyCallback.bind(this)
            };
            opts = this.confV6(opts);
            opts.extraData = this.getExtraData.bind(this);
            initNECaptcha(opts, this.initCallback.bind(this), this.initErrorHandler.bind(this));
        },
        initAiCap: function initAiCap() {
            if (!this.aiCapKey) {
                window.showError('加载失败，请刷新页面重试');

                this.$emit('doAiClose');
                return;
            }
            capConfig = this.confV6(capConfig);
            capConfig.captchaId = this.aiCapKey;
            capConfig.onVerify = this.verifyCallback.bind(this);
            capConfig.extraData = this.getExtraData.bind(this);
            capConfig.element = this.aicapbtn.$refs.mybutton;
            if (_util2.default.isMobile()) {
                var capWidth = Math.floor(document.body.clientWidth * 0.8);
                var normalWidth = 240;
                capWidth = capWidth >= normalWidth || capWidth <= 0 ? normalWidth : capWidth;
                capConfig.popupStyles.width = "" + capWidth;
                capConfig.popupStyles.capPadding = 10;
            }
            capConfig.onClose = this.onClose.bind(this);
            capConfig.onReady = this.initCallback.bind(this);
            window.initNECaptcha(capConfig, function () {}, this.initErrorHandler.bind(this));
        },
        clearStl: function clearStl() {
            if (this.stl) {
                this.stl = clearTimeout(this.stl);
            }
        },
        destroyInstance: function destroyInstance() {
            this.verifyFlag = 0;
            this.capValidate = undefined;
            if (this.myCaptcha) {
                this.myCaptcha = null;
            }
        },
        onClose: function onClose() {
            setTimeout(function () {
                if (this.verifyFlag !== 1) {
                    this.$emit('doAiClose');
                }
            }.bind(this), 200);
        },
        confV6: function confV6(opts) {
            if (window.$NEEDV6) {
                opts.ipv6 = true;

                opts.wmServerConfig = {
                    "configServer": "webzjac-v6.reg.163.com",
                    "apiServer": "webzjac-v6.reg.163.com",
                    "staticServer": "acstatic-dun-v6.126.net"
                };
                opts.staticServer = ['cstaticdun-v6.126.net'];
                opts.apiServer = ['webzjcaptcha-v6.reg.163.com', 'c-v6.dun.163yun.com'];
            }
            return opts;
        },
        refreshCap: function refreshCap() {
            if (this.capType === 1) {
                this.initImage();
            } else {
                this.verifyFlag = 0;
                if (this.myCaptcha) {
                    this.myCaptcha.refresh();
                }
            }
        },
        verifyCallback: function verifyCallback(err, data) {
            if (data && data.validate) {
                this.capValidate = data.validate;
                this.verifyFlag = 1;
                if (this.capType === 6) {
                    this.$emit('doVerify');
                } else {
                    this.$emit('verify');
                }
            } else {
                this.verifyFlag = 0;
            }
        },
        initCallback: function initCallback(instance) {
            this.myCaptcha = instance;
            this.$emit('initSucc');
            if (this.autoVerify && this.capType === 6) {
                this.$emit('autoVerify');
            }
        },
        initErrorHandler: function initErrorHandler(data) {
            this.$emit('initError');
        },
        validate: function validate() {
            var msg = {
                errorMsg: '',
                status: true
            };
            switch (this.capType) {
                case 1:
                    if (!regimg.test(this.$refs.capInput.currentValue)) {
                        window.showError('请输入图片验证码');
                        msg.status = false;
                    }
                    break;
                case 4:
                    if (!this.verifyFlag) {
                        window.showError('请先拖动滑块进行安全验证');
                        msg.status = false;
                    }
                    break;
                case 5:
                    if (!this.verifyFlag) {
                        window.showError('请先进行验证');
                        msg.status = false;
                    }
                    break;
                case 6:
                    if (!this.verifyFlag) {
                        if (this.myCaptcha) {
                            this.$emit('doVerifyLoading');
                            this.myCaptcha.verify();
                        } else {
                            window.showError('加载失败，请刷新页面重试');
                        }
                        msg.status = false;
                    }
                    break;
            }
            return msg;
        },
        getPwd: function getPwd() {
            if (this.capType === 1) {
                return this.$refs.capInput.currentValue;
            } else {
                return this.capValidate;
            }
        },
        getExtraData: function getExtraData() {
            return this.mail;
        }
    }
};

/***/ }),

/***/ 181:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      confirmCnt: '',
      confirmTxt: '确定',
      close: function close() {},
      confirm: function confirm() {}
    };
  },

  methods: {
    show: function show(options) {
      for (var key in options) {
        if (options.hasOwnProperty(key)) {
          this[key] = options[key];
        }
      }
    },
    onClose: function onClose() {
      this.confirmCnt = '';
      this.close();
    },
    onConfirm: function onConfirm() {
      this.confirmCnt = '';
      this.confirm();
    }
  }
};

/***/ }),

/***/ 182:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    errMsg: String
  },
  data: function data() {
    return {
      showError: this.errMsg
    };
  },
  mounted: function mounted() {
    window.Loading.loading = false;
  }
};

/***/ }),

/***/ 183:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'Form'
};

/***/ }),

/***/ 184:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    name: 'form-item',
    props: {
        error: String
    },
    data: function data() {
        return {
            validateStatus: '',
            validateMessage: ''
        };
    },

    methods: {
        clearValidate: function clearValidate() {
            this.validateStatus = '';
            this.validateMessage = '';
        },
        setMsg: function setMsg(msg) {
            this.validateMessage = msg;
            this.validateState = msg ? 'error' : '';
        }
    }
};

/***/ }),

/***/ 185:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    loading: {
      type: Boolean,
      default: true
    }
  }
};

/***/ }),

/***/ 186:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _request = __webpack_require__(39);

var _request2 = _interopRequireDefault(_request);

var _constant = __webpack_require__(88);

var _constant2 = _interopRequireDefault(_constant);

var _codemapper = __webpack_require__(31);

var _codemapper2 = _interopRequireDefault(_codemapper);

var _util = __webpack_require__(12);

var _util2 = _interopRequireDefault(_util);

var _cookie = __webpack_require__(205);

var _cookie2 = _interopRequireDefault(_cookie);

var _powerCap = __webpack_require__(500);

var _powerCap2 = _interopRequireDefault(_powerCap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var loginCode = {
    '804': '加载失败，请稍后再试',
    '803': '加载失败，请稍后再试',
    '805': '加载失败，请稍后再试',
    '806': '加载失败，请稍后再试',
    '413': '账号或密码错误',
    '409': '您登录过于频繁,请稍后再试',
    '402': '当前网络异常，请检查您的网络环境',
    '403': {
        type: 'confirm',
        opt: {
            confirmCnt: '账号存在风险，请先进行验证',
            confirmTxt: '前往验证'
        }
    },
    '416': '您的IP登录过于频繁,请稍后再试',
    '424': {
        type: 'confirm',
        opt: {
            confirmCnt: '该靓号服务已到期，请续费后使用',
            confirmTxt: '去续费',
            closeTxt: '取消',
            confirm: function confirm() {
                location.href = 'https://haoma.163.com/renewal.html?pd=ursmaillogin&pkid=dDiOfyc#/reinfo';
            }
        }
    },
    '421': {
        type: 'confirm',
        opt: { confirmCnt: '账号存在高危风险，请前往<br/>id.163.com修改密码' }
    },
    '425': {
        type: 'confirm',
        opt: {
            confirmCnt: '该账号尚未激活，请到已注册的邮箱激活账号',
            confirmTxt: '激活账号',
            closeTxt: '取消'
        }
    },
    '426': '该账号未及时激活，请重新注册',
    '428': {
        type: 'confirm',
        opt: { confirmCnt: '账号存在高危风险，请前往<br/>id.163.com修改密码' }
    },
    '602': {
        type: 'confirm',
        opt: {
            confirmCnt: '邮箱服务已到期，请立即续费',
            confirmTxt: '立即续费',
            closeTxt: '取消',
            confirm: function confirm() {
                location.href = 'https://vpay.vip.163.com/center/index.html?sign={{sign}}&from={{product}}&utm_source={{product}}';
            }
        }
    },
    '413-01-confirm': {
        type: 'confirm',
        opt: {
            confirmCnt: '密码错误次数过多，请稍后再试',
            confirmTxt: '找回密码？',
            closeTxt: '取消'
        }
    },
    '413-01': '您登录密码错误次数过多，请稍后再试',
    '412-01': '您登录错误次数过多，请稍后再试',
    '418-01': '您登录成功次数过多,请稍后再试',
    '419-01': '您登录过于频繁,请稍后再试',
    '413-03': '您的IP登录密码错误次数过多，请稍后再试',
    '414-01': '您的IP登录错误次数过多，请稍后再试',
    '417-01': '您的IP登录成功次数过多，请稍后再试',
    '419-02': '您的IP登录过于频繁,请稍后再试'
};
_util2.default.merge(loginCode, _codemapper2.default);

var ppCode = {
    '430': '此次登录不需要进行密保验证'
};
_util2.default.merge(ppCode, _codemapper2.default);

var RrlRegExp = '^http[s]?://[^?/#]*\\.(((163|16163|126|188|netease|youdao|yodao|lofter|leihuo|lede|lmlc|yunyan|yunyanzx|163yun|arthome163|tryfun|youdaozhixue)\\.com)|(fc18\\.com\\.cn)|((yeah|leihuo)\\.net)|(126\\.am)|((blizzard|yixingame)\\.cn)|(icourse163\\.org)|((netease|yixin)\\.im))((/|\\?|#)\\S*|$)';

var regMail = /^[\w-\.]+@(?:[\w-]+\.)+[a-z]{2,6}$/;

var LOADIFRAME_TIME = 5000;
var pwdErrCountMap = {};
exports.default = {
    name: 'login',

    components: {
        PowerCap: _powerCap2.default
    },

    props: {},
    data: function data() {
        return {
            capType: 0,
            initFlag: 0,
            showSuggest: true,
            capVerifyFlag: false,
            options: _constant2.default,
            opd: '',
            zcUrl: '',
            checked: false,
            preAccount: [],
            initialValue: '',
            repairlink: '',
            aqGuideFlag: 0,
            autoVerify: false,
            nextbtntxt: '登录',
            errorTip: '',
            requirePower: false,
            powerData: '',
            pVInfo: '',
            waitPower: false,
            needAutoPowerSubmit: false,
            need805AutoPowerSubmit: false,
            need806AutoPowerSubmit: false,
            hasAuto805Flag: false,
            hasAuto806Flag: false,
            getingPowerInfo: false,
            waitGetPower: false,
            pvSid: ''
        };
    },

    computed: {
        capclazz: function capclazz() {
            if (this.capType === 4 || this.capType === 5) {
                return 'cap-s g-pd';
            }
            if (this.capType === 6) {
                return 'f-dn';
            }
            return '';
        },
        aiCapBtn: function aiCapBtn() {
            return this.$refs.submitBtn;
        },
        getFullMail: function getFullMail() {
            return this.$refs.account.getValue();
        },
        unLoginTime: function unLoginTime() {
            return this.options.needUnLogin === 1 ? 10 : this.options.needUnLogin;
        },
        mailUrl: function mailUrl() {
            var url = 'https://mail.163.com/?dv=pc';
            var host = window.location.host;

            if (host.indexOf('126') !== -1) {
                url = 'https://mail.126.com/?dv=pc';
            } else if (host.indexOf('yeah') !== -1) {
                url = 'https://mail.yeah.net/?dv=pc';
            }
            return url;
        }
    },
    mounted: function mounted() {
        if (!this.getUrlParams()) {
            return;
        }

        this.zcUrl = 'https://zc.reg.163.com/m/regInitialized?pd=ursh5mailreg&pkid=KQxvAWV&pkht=id.163.com&' + 'curl=' + encodeURIComponent(this.toUrl);
        this.init();
    },
    beforeDestroy: function beforeDestroy() {
        if (this.vfloadsto) {
            this.vfloadsto = clearTimeout(this.vfloadsto);
        }
        if (this.sto) {
            window.clearTimeout(this.sto);
        }
    },

    methods: {
        getUserName: function getUserName() {
            var account = this.$refs.account.getValue();
            account = account.trim();
            return account;
        },
        onCheckBox: function onCheckBox() {
            this.checked = !this.checked;
        },
        getUrlParams: function getUrlParams() {
            window.$NEEDV6 = _util2.default.getUrlSearch('v6') || '';
            this.options.proLogo = window.$NEEDV6 ? '//urswebzj-v6.nosdn.127.net/dl/ner_logo.png' : '//ursdoccdn.nosdn.127.net/dl/ner_logo.png';

            var opd = _util2.default.getUrlSearch('product') || '';

            if (opd && /^[a-z\d_]{1,25}$/.test(opd)) {
                this.opd = opd;
            } else {
                this.$emit('changeToError', '缺少或非法的product参数');
                return false;
            }

            var _toUrl = _util2.default.getUrlSearch('curl');
            if (_toUrl) {
                this.toUrl = _toUrl;
            } else {
                this.$emit('changeToError', '缺少curl参数或参数非法');
                return false;
            }

            var _mainColor = _util2.default.getUrlSearch('mc') || '';

            if (/^[0-9a-zA-Z]{6}$/.test(_mainColor)) {
                _util2.default.appendMainColor(_mainColor);
            }

            var _backColor = _util2.default.getUrlSearch('bc') || '';

            if (/^[0-9a-zA-Z]{6}$/.test(_backColor)) {
                _util2.default.appendBackColor(_backColor);
            }

            var _pdConf = _util2.default.getUrlSearch('pdconf') || '';

            if (/^[0-9a-z_]{1,25}$/.test(_pdConf)) {
                this.pdConf = _pdConf;
            } else {
                this.pdConf = 'yddl_urs_conf';
            }

            var preAccount = _util2.default.getUrlSearch('preAccount') || '';
            if (preAccount) {
                this.preAccount = preAccount.split(',').slice(0, 5);
            }
            return true;
        },
        validatePreAccount: function validatePreAccount(account) {
            if (!regMail.test(account)) {
                return false;
            }

            var suffix = account.match(/@(?:[\w-]+\.)+[a-z]{2,6}/g).join();
            if (this.options.suffixDomains.indexOf(suffix) === -1) {
                return false;
            }

            return true;
        },
        doPreAccout: function doPreAccout() {
            var name = localStorage.getItem('urs_h5_dlpage_account');
            if (name && this.validatePreAccount(name)) {
                this.fillAccount(name);
            }
        },
        init: function init() {
            var _this = this;

            window.$RTID = _util2.default.getRtid();

            var data = {
                pkht: _constant2.default.pkht,
                pdconf: this.pdConf,
                re: 1
            };

            (0, _request2.default)({
                url: '/ini',
                method: 'GET',
                noToast: 1,
                data: data,
                success: function success(data) {

                    _this.aiCapKey = data.capId || '';

                    if (data.pdConf) {
                        try {
                            var conf = JSON.parse(data.pdConf);
                            var zcUrlParams = conf.zcUrlParams || '';
                            if (zcUrlParams) {
                                if (/(^curl=)|(&curl=)/i.test(zcUrlParams)) {
                                    _this.$emit('changeToError', '配置中出现非法参数curl');
                                    return;
                                }
                                _this.zcUrl = 'https://zc.reg.163.com/m/regInitialized?' + zcUrlParams + '&curl=' + encodeURIComponent(_this.toUrl);
                            }
                            if (window.$NEEDV6 && conf && conf.proLogo && conf.proLogo.indexOf('ursdoccdn.nosdn.127.net') > -1) {
                                conf.proLogo = conf.proLogo.replace('ursdoccdn.nosdn.127.net', 'urswebzj-v6.nosdn.127.net');
                            }

                            _util2.default.merge(_this.options, conf);

                            _this.checked = _this.options.defaultUnLogin;

                            _this.aqGuideFlag = _this.options.aqGuideFlag || 0;
                        } catch (error) {}
                    }

                    _this.capType = data.capFlag || 0;

                    if (_this.capType == 0 || _this.capType == 1) {
                        _this.initFlag = 1;
                    }
                    var res = [];
                    _this.preAccount.forEach(function (item) {
                        if (!regMail.test(item)) {
                            return;
                        }
                        var suffix = item.match(/@(?:[\w-]+\.)+[a-z]{2,6}/g).join();
                        if (_this.options.suffixDomains.indexOf(suffix) !== -1 && res.indexOf(item) === -1) {
                            res.push(item);
                        }
                    });
                    _this.preAccount = res;

                    if (_this.preAccount.length === 1) {
                        _this.initialValue = _this.preAccount[0];

                        _this.$refs.pwd.focusInput();
                    }

                    if (!_this.preAccount.length) {
                        _this.doPreAccout();
                    }

                    try {
                        var regExp = new RegExp(data.regExp || RrlRegExp);
                        if (!regExp.test(_this.toUrl)) {
                            _this.$emit('changeToError', 'curl参数非法');
                        }
                    } catch (error) {
                        _this.toUrl = 'https://id.163.com/mail/mailaq/index.html';
                    }

                    window.Loading.loading = false;

                    if (!!data.pv) {
                        _this.getPowerInfo();
                    }
                },
                error: function error(data) {
                    window.Loading.loading = false;
                    _this.initFlag = 1;

                    window.showError(_codemapper2.default[data.ret]);
                }
            });
        },
        getPowerInfo: function getPowerInfo() {
            var _this2 = this;

            this.getingPowerInfo = true;
            var url = '/powGetP';
            var data = {
                un: this.getUserName() || this.initialValue || '',
                pvSid: this.pvSid };
            (0, _request2.default)({
                url: url,
                method: 'GET',
                noToast: 1,
                data: data,
                success: function success(res) {
                    _this2.getingPowerInfo = false;

                    _this2.requirePower = res.pVInfo && res.pVInfo.needCheck || false;

                    var pVInfo = res.pVInfo;

                    if (_util2.default.hasPuzzle(pVInfo)) {
                        _this2.pVInfo = pVInfo;
                        _this2.pvSid = pVInfo.sid;
                    } else {
                        _this2.pVInfo = '';
                        _this2.pvSid = '';
                    }

                    _this2.doWebWorkerPower();

                    if (_this2.needAutoPowerSubmit) {
                        if (_this2.pVInfo) {
                            _this2.waitPower = true;

                            if (_this2.need805AutoPowerSubmit) {
                                _this2.hasAuto805Flag = true;
                            }

                            if (_this2.need806AutoPowerSubmit) {
                                _this2.hasAuto806Flag = true;
                            }
                            _this2.getTicket();
                        } else {
                            _this2.$refs.submitBtn.state = 'enable';
                            window.showError('加载失败，请稍后再试');
                        }

                        return;
                    }

                    if (_this2.waitGetPower) {
                        console && console.log('获取到了，请求');
                        _this2.waitGetPower = false;
                        _this2.getTicket();
                    }
                },
                error: function error(data) {
                    console && console.log('getPower error');
                    _this2.getingPowerInfo = false;
                    if (data.ret === '802') {
                        _this2.requirePower = false;
                    }
                    if (data.ret === '801') {
                        _this2.pVInfo = '';
                        _this2.requirePower = true;
                    }

                    if (_this2.needAutoPowerSubmit) {
                        _this2.$refs.submitBtn.state = 'enable';
                        window.showError('加载失败，请稍后再试');
                        _this2.clearAutoFlag();
                    }

                    if (_this2.waitGetPower) {
                        _this2.waitGetPower = false;
                        _this2.getTicket();
                    }
                }
            });
        },
        doWebWorkerPower: function doWebWorkerPower() {
            if (!_util2.default.hasPuzzle(this.pVInfo)) {
                return;
            }

            if (window.Worker) {
                this.$refs.powerCap.doWebWorkerPower(this.pVInfo);
            }
        },
        clearAutoFlag: function clearAutoFlag() {
            this.hasAuto805Flag = false;
            this.hasAuto806Flag = false;
        },
        handleCapError: function handleCapError(code) {
            var _this3 = this;

            var newType = 0;
            switch (code) {
                case '441':
                    window.showError('请输入图片验证码');
                    newType = 1;
                    break;
                case '444':
                    newType = 4;
                    window.showError('请先拖动滑块进行安全验证');
                    break;
                case '445':
                    newType = 5;
                    window.showError('请先进行验证');
                    break;
                case '447':
                    newType = 6;
                    break;
                default:
                    break;
            }

            if (newType === this.capType) {
                this.doRefreshCap(false);
            } else {
                this.capType = 0;
                this.$nextTick(function () {
                    _this3.changeCapFlag(newType);
                });
            }
        },
        onLogoError: function onLogoError() {
            this.options.proLogo = window.$NEEDV6 ? '//urswebzj-v6.nosdn.127.net/dl/ner_logo.png' : '//ursdoccdn.nosdn.127.net/dl/ner_logo.png';
            this.options.logoSize = 'width:auto;height:40px';
        },
        onCapInit: function onCapInit(state) {
            var _this4 = this;

            this.sto = window.setTimeout(function () {
                window.Loading.loading = false;
                _this4.initFlag = 1;
            }, 50);
            if (state == 1) {
                return;
            }

            window.showError('加载失败，请刷新页面重试');
        },
        goFindPwd: function goFindPwd() {
            var un = this.$refs.account.getValue();
            if (regMail.test(un)) {
                location.href = 'https://id.163.com/mail/retrievepassword?username=' + un;
            } else {
                location.href = 'https://id.163.com/mail/retrievepassword';
            }
        },
        onLogin: function onLogin() {
            this.errorTip = '';
            if (_util2.default.CapFailCount()) {
                window.showError(_codemapper2.default['fail5']);
                return;
            }
            if (this.validate(this.$refs, ['account', 'pwd'])) {
                this.$refs.submitBtn.state = 'loading';
                this.getTicket();
            }
        },
        validate: function validate(refs, array) {
            var children = this.$refs.form.$children,
                props = [];
            children.forEach(function (item) {
                if (item.$options.name == 'form-item') {
                    props.push(item);
                }
            });
            var errorStatus = true,
                msg = void 0;
            for (var i = 0, item; i < props.length; i++) {
                item = props[i];
                msg = item.$children[0].validate();
                if (!msg.status) {
                    errorStatus = false;
                    item.setMsg(msg.errorMsg);
                    break;
                }
            }

            return errorStatus;
        },
        getVerifyOpt: function getVerifyOpt(type) {
            var opt = {
                url: '/vfcp',
                method: 'GET',
                contentType: 'application/json',
                data: {
                    un: this.$refs.account.getValue()
                }
            };
            switch (type) {
                case 1:
                    opt.method = 'POST';
                    opt.contentType = 'application/x-www-form-urlencoded';
                    opt.data.cap = this.$refs.capture.getPwd();

                    break;
                case 4:
                    opt.url = '/vftcp';
                    opt.data.cap = this.$refs.capture.getPwd();
                    opt.data.capkey = this.options.capKey;
                    break;
                case 5:
                    opt.url = '/vfccp';
                    opt.data.cap = this.$refs.capture.getPwd();
                    opt.data.capkey = this.options.capKey;
                    break;
                case 6:
                    opt.url = '/vfscp';
                    opt.data.cap = this.$refs.capture.getPwd();
                    break;
                default:
                    break;
            }

            return opt;
        },
        verifyCapture: function verifyCapture() {
            var _this5 = this;

            var opt = this.getVerifyOpt(this.capType);

            (0, _request2.default)({
                url: opt.url,
                method: opt.method,
                contentType: opt.contentType,
                data: opt.data,
                success: function success(data) {
                    if (_this5.capType === 6) {
                        _this5.onLogin();
                    }
                },
                error: function error(data) {
                    _this5.$refs.submitBtn.state = 'enable';
                    if (_util2.default.CapFailCount(true)) {
                        window.showError(_codemapper2.default['fail5']);
                        return;
                    }

                    if (['441', '444', '445', '447'].indexOf(data.ret) !== -1) {
                        _this5.handleCapError(data.ret);
                        return;
                    } else {
                        _this5.doRefreshCap(false);

                        window.showError(_codemapper2.default[data.ret]);
                    }
                }
            });
        },
        doRefreshCap: function doRefreshCap(ischangeed, noshowerr) {
            if (this.capType === 6) {
                if (!ischangeed && !noshowerr) {
                    this.errorTip = _util2.default.filterMsg(this.nextbtntxt);
                }
                this.refreshAiCap(ischangeed);
            } else if (this.capType !== 0) {
                this.$refs.capture.refreshCap();
            }
        },
        getTicket: function getTicket() {
            if (this.getingPowerInfo) {
                this.waitGetPower = true;
                return;
            }

            if (this.requirePower && this.pVInfo && !this.powerData) {
                this.waitPower = true;
                if (!window.Worker) {
                    console && console.log('同步计算一次');
                    this.$refs.powerCap.doSyncCompute(this.pVInfo);
                }
            } else {
                this.waitPower = false;
                this.getRealTicket();
            }
        },
        getRealTicket: function getRealTicket() {
            var _this6 = this;

            var url = '/gt';
            var data = {
                un: this.$refs.account.getValue()
            };
            if (this.stodelay) {
                this.stodelay = clearTimeout(this.stodelay);
            }

            this.stodelay = setTimeout(function () {
                (0, _request2.default)({
                    url: url,
                    method: 'GET',
                    data: data,
                    success: function success(data) {
                        _this6.doLogin(data.tk);
                    },
                    error: function error(data) {
                        _this6.$refs.submitBtn.state = 'enable';

                        if (_this6.capType !== 0) {
                            _this6.doRefreshCap(false, 'noshowerr');
                        }

                        window.showError(_codemapper2.default[data.ret]);
                    }
                });
            }, 200);
        },

        setDomains: function (urls, endfunc) {
            var count = 0;
            return function (urls, endfunc) {
                var _this7 = this;

                if (typeof urls === 'string') {
                    _util2.default.insertFrame(urls, this.opd, function () {
                        endfunc();
                    });
                } else if (urls.length > 0) {
                    count = urls.length;
                    this.sto = window.setTimeout(function () {
                        endfunc();
                    }, LOADIFRAME_TIME);
                    for (var i = 0; i < urls.length; i++) {
                        _util2.default.insertFrame(urls[i], this.opd, function () {
                            count--;
                            if (count === 0) {
                                endfunc();
                                window.clearTimeout(_this7.sto);
                            }
                        });
                    }
                } else {
                    endfunc();
                }
            };
        }(),
        checkMode: function checkMode(data) {
            var _this8 = this;

            if (data.nextUrls) {
                this.setDomains(data.nextUrls, function () {
                    _this8.showMode(data.mode, _this8.toUrl);
                });
            } else {
                this.showMode(data.mode, this.toUrl);
            }
        },
        loginSuccess: function loginSuccess(data) {
            var _this9 = this;

            this.$refs.submitBtn.state = 'enable';
            if (data.mode) {
                this.checkMode(data);
                return;
            }

            if (!data.nextUrls) {
                window.jumpLoading.loading = true;
                location.href = this.toUrl;
                return;
            }

            this.setDomains(data.nextUrls, function () {
                window.jumpLoading.loading = true;
                location.href = _this9.toUrl;
            });
        },
        showMode: function showMode(data, toUrl) {
            data.opd = this.opd;
            var _img = void 0;
            if (data.img0) {
                _img = data.img0;
                _img = _img.replace('ursdoccdn.nosdn.127.net', 'urswebzj.nosdn.127.net');
            }
            if (_img && window.$NEEDV6 && _img.indexOf('urswebzj.nosdn.127.net') > -1) {
                data.img0 = this.changeImgtoIPV6(_img);
            }
            this.$emit('changeToMode', data, toUrl);
        },
        changeImgtoIPV6: function changeImgtoIPV6(_url) {
            return _url.replace(/\/\/([^\/]+:?)\//, function ($1, $2) {
                var _host = $2;
                _host = _host.replace(/([^\.]+:?)\./, function ($3, $4) {
                    return $4 + '-v6.';
                });
                return '//' + _host + '/';
            });
        },
        onClearMsg: function onClearMsg() {
            this.repairlink = '';
        },
        powerSuccess: function powerSuccess(data) {
            this.powerData = data;
            if (this.waitPower) {
                this.waitPower = false;
                this.getRealTicket();
            }
        },
        doLogin: function doLogin(tk) {
            this.onClearMsg();
            var data = {
                un: this.$refs.account.getValue(),
                tk: tk,
                pw: _util2.default.encrypt2(this.$refs.pwd.getValue()),
                domains: this.options.cookieDomains
            };

            if (this.options.needUnLogin && this.checked) {
                data.l = 1;
                data.d = this.unLoginTime;
            }

            if (this.powerData) {
                data.pVParam = this.powerData;
                this.powerData = '';
                this.pVInfo = null;
            }

            this.doRealLogin(data);
        },
        doRealLogin: function doRealLogin(param) {
            var _this10 = this;

            var url = '/l';
            (0, _request2.default)({
                url: url,
                method: 'POST',
                data: param,
                success: function success(data) {
                    localStorage.setItem('urs_h5_dlpage_account', param.un);
                    _this10.clearAutoFlag();
                    _this10.loginSuccess(data);
                },
                error: function error(data) {
                    _this10.$refs.submitBtn.state = 'enable';


                    _this10.needAutoPowerSubmit = false;

                    if (data.ret === '805' && !_this10.hasAuto805Flag) {
                        _this10.needAutoPowerSubmit = true;
                        _this10.need805AutoPowerSubmit = true;
                    }

                    if (data.ret === '806' && !_this10.hasAuto806Flag) {
                        _this10.needAutoPowerSubmit = true;
                        _this10.need806AutoPowerSubmit = true;
                    }

                    if (['804', '803'].indexOf(data.ret) > -1) {
                        if (!_this10.requirePower || !_util2.default.hasPuzzle(_this10.pVInfo) && _this10.pVInfo !== null) {
                            _this10.needAutoPowerSubmit = true;
                        }
                    }

                    if (_this10.needAutoPowerSubmit) {
                        _this10.$refs.submitBtn.state = 'loading';
                    }

                    if (['805', '804', '803', '806'].indexOf(data.ret) > -1) {
                        if (!_this10.needAutoPowerSubmit) {
                            window.showError(loginCode[data.ret]);
                            _this10.clearAutoFlag();
                        }

                        _this10.getPowerInfo();
                        return;
                    }

                    _this10.clearAutoFlag();

                    if (_this10.requirePower) {
                        _this10.getPowerInfo();
                    }

                    if (data.mode) {
                        _this10.changeCapFlag(data.capFlag, 'noshowerr', 'forcenochangeed');
                        _this10.checkMode(data);
                        return;
                    }
                    _this10.repairlink = '';
                    if (_this10.aqGuideFlag === 1 && data.ret == '413' && !data.dt) {
                        var account = _this10.$refs.account.getValue();
                        if (pwdErrCountMap[account]) {
                            pwdErrCountMap[account] = ++pwdErrCountMap[account];
                        } else {
                            pwdErrCountMap[account] = 1;
                        }
                        if (pwdErrCountMap[account] && pwdErrCountMap[account] > 1) {
                            _this10.repairlink = 'https://id.163.com/mail/retrievepassword?username=' + encodeURIComponent(account);
                            if (data.capFlag) {
                                _this10.changeCapFlag(data.capFlag, 'noshowerr', 'forcenochangeed');
                            }
                            return;
                        }
                    }

                    if (data.ret == '423') {
                        localStorage.setItem('urs_h5_dlpage_account', param.un);
                        _this10.loginSuccess(data);
                        return;
                    }

                    if (['441', '444', '445', '447'].indexOf(data.ret) !== -1) {
                        _this10.handleCapError(data.ret);
                        return;
                    }

                    _this10.changeCapFlag(data.capFlag, 'noshowerr', 'forcenochangeed');

                    var ret = data.ret;
                    if (data.dt && ret !== '401') {
                        ret = ret + '-' + data.dt;
                    }

                    if (data.pp == '1' && (ret == '403' || ret == '429' || ret == '412-01' || ret == '413-01' || ret == '413-03' || ret == '414-01' || ret == '417-01' || ret == '418-01' || ret == '419-01' || ret == '419-02')) {
                        if (_this10.options.needpp) {
                            var _data = {
                                un: _this10.$refs.account.getValue()
                            };
                            (0, _request2.default)({
                                url: '/pp',
                                method: 'GET',
                                data: _data,
                                success: function success(data) {
                                    _this10.$emit('changeToVerify', {
                                        un: _this10.$refs.account.getValue(),
                                        data: data
                                    });
                                },
                                error: function error(data) {
                                    var ret = data.ret;
                                    var un = _this10.$refs.account.getValue();
                                    if (ret === '454') {
                                        ppCode[ret].opt.confirm = _util2.default.createConfirm(un);
                                    }
                                    if (ret === '452') {
                                        ppCode[ret].opt.confirm = _util2.default.createLogoutConfirm(un);
                                    }
                                    window.showError(ppCode[ret]);
                                }
                            });
                            return;
                        }
                    }
                    var un = _this10.$refs.account.getValue();
                    if (data.guideFindPassword && ret === '413-01') {
                        var confirm41301 = '413-01-confirm';
                        loginCode[confirm41301].opt.confirm = _util2.default.createFindPwdConfirm(un);
                        window.showError(loginCode[confirm41301]);
                        return;
                    }
                    if (ret === '425') {
                        var maillink = _util2.default.hasMailLink(un);
                        if (maillink) {
                            loginCode[ret].opt.confirm = _util2.default.createMailLink(maillink);
                        } else {
                            loginCode[ret].opt.confirm = _util2.default.createMailLinkHelp(maillink);
                        }
                    }
                    if (ret === '403') {
                        loginCode[ret].opt.confirm = _util2.default.createVerifyLink(un);
                    }
                    if (ret === '454') {
                        loginCode[ret].opt.confirm = _util2.default.createConfirm(un);
                    }
                    if (ret === '452') {
                        loginCode[ret].opt.confirm = _util2.default.createLogoutConfirm(un);
                    }
                    if (ret === '602') {
                        loginCode[ret].opt.confirm = _util2.default.createVipLinkConfirm(data.sign, _this10.opd);
                    }
                    if (ret === '422') {
                        loginCode[ret].opt.confirm = _util2.default.createUnlock(un);
                    }
                    window.showError(loginCode[ret]);
                }
            });
        },
        fillAccount: function fillAccount(val) {
            this.$refs.pwd.focusInput();
            this.initialValue = val;
        },
        closeModal: function closeModal() {
            this.$refs.account.focusInput();
        },

        doAiClose: function doAiClose() {
            this.$refs.submitBtn.state = 'enable';
        },
        doVerifyLoading: function doVerifyLoading() {
            if (this.vfloadsto) {
                this.vfloadsto = clearTimeout(this.vfloadsto);
            }
            this.$refs.submitBtn.state = 'loading';
        },
        doVerify: function doVerify() {
            this.verifyCapture();
        },
        changeCapFlag: function changeCapFlag(capFlag, noshowerr, forcenochangeed) {
            var _this11 = this;

            if (capFlag && capFlag !== this.capType) {
                this.capType = capFlag;
                var changeed = forcenochangeed ? false : true;
                this.$nextTick(function () {
                    _this11.doRefreshCap(changeed, noshowerr);
                });
            } else if (this.capType !== 0) {
                this.doRefreshCap(false, noshowerr);
            }
        },
        refreshAiCap: function refreshAiCap(autoVerify) {
            var _this12 = this;

            this.capType = 0;
            this.autoVerify = autoVerify || false;
            if (this.autoVerify) {
                this.$refs.submitBtn.state = 'loading';
            }
            this.$nextTick(function () {
                _this12.capType = 6;
            });
        },
        doAutoVerify: function doAutoVerify() {
            this.onLogin();
        }
    }
};

/***/ }),

/***/ 187:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _country = __webpack_require__(203);

var _country2 = _interopRequireDefault(_country);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'urs-mbinput',
    props: {
        name: String,
        placeholder: String,
        disabled: Boolean,
        newUp: Boolean,
        del_icon_clazz: {
            type: String,
            default: 'i-icon i-icon-delete'
        },
        old_clazz: {
            type: String,
            default: 'u-ipt-mob'
        },
        newup_clazz: {
            type: String,
            default: 'u-ipt-mob newup-clazz'
        },
        size: {
            type: String,
            default: 'large'
        }
    },
    data: function data() {
        return {
            type: 'text',
            selected: {
                flag: 'flag-CN',
                code: '86'
            },
            common: _country2.default.common,
            other: _country2.default.other,
            open: false
        };
    },

    computed: {
        value: function value() {
            if (this.selected.code == '86') {
                return this.$refs.input.currentValue;
            } else {
                return this.selected.code + '-' + this.$refs.input.currentValue;
            }
        }
    },
    methods: {
        onTogle: function onTogle(event) {
            this.open = true;
        },
        onChooseC: function onChooseC(event) {
            var select = event.target.dataset.code;
            if (!!select) {
                this.selected = {
                    code: select,
                    flag: event.target.className
                };
            }
            this.open = false;
        },
        validate: function validate() {
            var val = this.$refs.input.currentValue,
                msg = {
                errorMsg: '',
                status: true
            };

            if (this.selected.code == '86' && !/^(13|14|15|16|17|18|19)\d{9}$/.test(val) || this.selected.code !== '86' && !(val.indexOf('00') !== 0 && /^\d{3,19}$/.test(this.selected.code + val))) {
                msg.status = false;
                msg.errorMsg = '手机号码格式错误，请更换后重试';
            }
            return msg;
        },
        onFocus: function onFocus() {
            var parent = this.$parent;
            if (parent && parent.$options.name == 'form-item') {
                parent.setMsg('');
            }
        }
    }
};

/***/ }),

/***/ 188:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'urs-pwdinput',
  props: {
    name: String,
    placeholder: String,
    disabled: Boolean,
    eye_open_icontype: {
      type: String,
      default: '#icon-ic-openEye'
    },
    eye_close_icontype: {
      type: String,
      default: '#icon-ic-closeEye'
    },
    del_icon_clazz: {
      type: String,
      default: 'i-icon i-icon-delete'
    },
    eye_open_icon_clazz: {
      type: String,
      default: 'i-icon i-icon-password-cipher'
    },
    eye_close_icon_clazz: {
      type: String,
      default: 'i-icon i-icon-password-clear'
    },
    size: {
      type: String,
      default: 'large'
    },
    needEye: {
      type: Number,
      default: 1
    }
  },
  data: function data() {
    return {
      showPass: false,
      type: 'password'
    };
  },

  watch: {
    showPass: function showPass(val) {
      this.type = val === true ? 'text' : 'password';
    }
  },
  methods: {
    onEye: function onEye(event) {
      this.showPass = !this.showPass;
    },
    validate: function validate() {
      var val = this.$refs.input.currentValue,
          msg = {
        errorMsg: '',
        status: true
      };;
      if (val === '') {
        msg.errorMsg = "请输入密码";
        msg.status = false;
      }
      return msg;
    },
    getValue: function getValue() {
      return this.$refs.input.currentValue;
    },
    onFocus: function onFocus() {
      var parent = this.$parent;
      if (parent.$options.name == 'form-item') {
        parent.setMsg('');
        this.$emit('focus');
      }
    },
    onDelete: function onDelete() {
      this.$emit('delete');
    },
    focusInput: function focusInput() {
      this.$refs.input.focus();
    }
  }
};

/***/ }),

/***/ 189:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(67);

var _assign2 = _interopRequireDefault(_assign);

var _bowser = __webpack_require__(90);

var _bowser2 = _interopRequireDefault(_bowser);

var _request = __webpack_require__(39);

var _request2 = _interopRequireDefault(_request);

var _util = __webpack_require__(12);

var _util2 = _interopRequireDefault(_util);

var _codemapper = __webpack_require__(31);

var _codemapper2 = _interopRequireDefault(_codemapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TIME = 3000;

var vfmbsmsCodeTemp = {
  '431': "请求错误，请您稍后再试",
  '412': "验证码错误次数过多，请明天再试",
  '413': "当日尝试次数过多，请明天再试",
  '443': "系统未收到短信或短信内容错误",
  '430': "此次登录不需要进行密保验证",
  '415': "请获取短信验证码",
  '409': '系统未收到短信或短信内容错误'
};

var vfsmsCodeTemp = {
  '431': "请求错误，请您稍后再试",
  '410': "超过IP限制，请稍候再试",
  '412': "验证码错误次数过多，请明天再试",
  '413': "当日尝试次数过多，请明天再试",
  '443': "系统未收到短信或短信内容错误",
  '453': "账号未关联手机号",
  '454': "账号关联手机未验证",
  '430': "此次登录不需要进行密保验证",
  '415': "请获取短信验证码",
  '409': '系统未收到短信或短信内容错误'
};
var vfmbsmsCode = (0, _assign2.default)({}, _codemapper2.default, vfmbsmsCodeTemp);
var vfsmsCode = (0, _assign2.default)({}, _codemapper2.default, vfsmsCodeTemp);

exports.default = {
  props: {
    options: Object
  },
  data: function data() {
    return {
      fromluo: this.options.fromluo,
      smsCount: 29,
      showUp: '',
      receiveCode: this.options.receiveCode,
      mobile: this.options.mobile,
      receiveCode1: this.options.receiveCode1,
      receiveCode2: this.options.receiveCode2,
      receiveCode3: this.options.receiveCode3,
      smscnt: _bowser2.default.ios ? this.options.smscnt : 'javascript:void(0)'
    };
  },
  mounted: function mounted() {
    this.ajaxList = [];
    window.Loading.loading = false;
  },
  beforeDestroy: function beforeDestroy() {
    if (this.sto) {
      this.sto = clearTimeout(this.sto);
    }
    this.ajaxList.forEach(function (item) {
      item && item.abort();
    });
    this.ajaxList = [];
  },

  methods: {
    checkSmsUp: function checkSmsUp() {
      if (this.fromluo) {
        this.checkSmsUpLuo();
      } else {
        this.checkSmsUpMb();
      }
    },
    checkSmsUpMb: function checkSmsUpMb() {
      var _this = this;

      var data = {
        un: this.options.un,
        mb: this.mobile,
        n: 1
      };
      this.$refs.submitBtn.state = 'loading';
      this.sto = setTimeout(function () {
        var ajax = (0, _request2.default)({
          url: '/vfsms',
          method: 'POST',
          contentType: 'application/x-www-form-urlencoded',
          data: data,
          success: function success(data) {
            _this.$refs.submitBtn.state = 'enable';
            _this.$emit('changeToLogin', { autoLogin: 1 });
          },
          error: function error(data) {
            _this.$refs.submitBtn.state = 'enable';

            if (data.ret == '415') {
              _this.changeMobile(vfmbsmsCode[data.ret], 'verifymb');
              return;
            }
            if (data.ret == '430' || data.ret === '434' || data.ret === '435' || data.ret === '436' || data.ret === '437' || data.ret === '413' || data.ret === '412') {
              _this.$emit('changeToLogin', { errMsg: vfsmsCode[data.ret] });
              return;
            }

            window.showError(vfsmsCode[data.ret]);
          }
        });
        ajax && _this.ajaxList.push(ajax);
      }, TIME);
    },
    checkSmsUpLuo: function checkSmsUpLuo() {
      var _this2 = this;

      this.$refs.submitBtn.state = 'loading';
      var data = {
        un: this.options.un,
        mb: this.mobile,
        n: 1
      };
      this.sto = setTimeout(function () {
        var ajax = (0, _request2.default)({
          url: '/vfmbsms',
          method: 'POST',
          contentType: 'application/x-www-form-urlencoded',
          data: data,
          success: function success(data) {
            _this2.$refs.submitBtn.state = 'enable';
            _this2.$emit('changeToLogin', { autoLogin: 1 });
          },
          error: function error(data) {
            _this2.$refs.submitBtn.state = 'enable';
            if (_this2.ignore) {
              return;
            }

            if (data.ret === '401' && data.dt === '09') {
              window.showError('手机号格式错误');
              return;
            }
            if (data.ret === '401' && data.dt === '10') {
              window.showError('账号格式错误');
              return;
            }

            if (data.ret == '430' || data.ret === '434' || data.ret === '435' || data.ret === '436' || data.ret === '437') {
              _this2.$emit('changeToLogin', { errMsg: vfmbsmsCode[data.ret] });
              return;
            }

            window.showError(vfmbsmsCode[data.ret]);
          }
        });
        ajax && _this2.ajaxList.push(ajax);
      }, TIME);
    },
    changeMobile: function changeMobile(txt, target) {
      this.ignore = true;

      target = target || 'verifyluo';
      this.$emit('changeModule', { module: target, newUp: true, receiveCode: this.receiveCode, errMsg: txt });
    },
    gosms: function gosms() {
      if (!_bowser2.default.ios) {
        var iframe = document.createElement('iframe');
        iframe.src = this.options.smscnt;
        iframe.style = "display:none;border:none;background:none;height:0;width:0;";
        document.body.appendChild(iframe);
        setTimeout(function () {
          try {
            document.body.removeChild(iframe);
          } catch (e) {}
        }, 800);
      }
    }
  }
};

/***/ }),

/***/ 190:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


var generatePrompt = function generatePrompt(suffix, val, set) {
  var temp = suffix.split(',');
  var filterTemp = [];
  var pre = val.split('@')[0];
  var suf = val.split('@')[1];

  if (set == 1 && suf !== '') {
    for (var i = 0; i < temp.length; i++) {
      var treg = new RegExp('^@' + suf);

      if (treg.test(temp[i])) {
        filterTemp.push(pre + temp[i]);
      }
    }
  } else {
    for (var _i = 0; _i < temp.length; _i++) {
      filterTemp.push(pre + temp[_i]);
    }
  }
  return filterTemp;
};

var regemail = /^[\w-\.]+@(?:[\w-]+\.)+[a-z]{2,6}$/;
var regprefix = /^[\w-\.@]+$/;
exports.default = {
  name: 'suggest',
  props: {
    placeholder: String,
    name: String,
    suffix: String,
    initialValue: String
  },
  data: function data() {
    return {
      items: [],
      value: ''
    };
  },

  computed: {
    showSuggest: function showSuggest() {
      return this.suffix.split(',').length > 1;
    },
    open: function open() {
      return this.items.length > 0;
    },
    singleSuffix: function singleSuffix() {
      if (this.suffix.indexOf(',') === -1) {
        return this.suffix;
      }
      return '';
    }
  },
  watch: {
    open: function open(val) {
      if (val) {
        document.getElementsByTagName('html')[0].style = 'height:100%;overflow:hidden;';
        document.getElementsByTagName('body')[0].style = 'height:100%;overflow:hidden;';
      } else {
        document.getElementsByTagName('html')[0].style = 'overflow:auto;';
        document.getElementsByTagName('body')[0].style = 'overflow:auto;';
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.sto) {
      window.clearTimeout(this.sto);
    }
  },

  methods: {
    onShow: function onShow(val) {
      val = val.trim();
      var set = val.match(/@/g) ? val.match(/@/g).length : 0;
      if (val && regprefix.test(val) && set <= 1) {
        this.items = generatePrompt(this.suffix, val, set);
      } else {
        this.items = [];
      }
    },
    onBlur: function onBlur(val) {
      var _this = this;

      this.$refs.input.setCurrentValue(val.trim());
      this.sto = window.setTimeout(function () {
        _this.items = [];
      }, 34);
    },
    onSelect: function onSelect(event) {
      var item = event.target;
      this.$refs.input.setCurrentValue(item.innerText);
      this.$refs.input.blur();
      this.items = [];
    },
    onDelete: function onDelete(event) {
      this.items = [];
      this.$refs.input.focus();
    },
    getValue: function getValue() {
      var val = this.$refs.input.currentValue.trim();
      if (!this.showSuggest && val !== '') {
        if (val.indexOf(this.singleSuffix) === -1) {
          val += this.singleSuffix;
        }
      }
      return val;
    },
    onFocus: function onFocus(val, flag) {
      var parent = this.$parent;
      if (parent && parent.$options.name == 'form-item') {
        parent.setMsg('');
        this.$emit('focus');
      }
    },
    focusInput: function focusInput() {
      this.$refs.input.focus();
    },
    preFilter: function preFilter() {
      if (this.initialValue) {
        return this.initialValue.split('@')[0];
      }
    },
    validate: function validate() {
      var val = this.$refs.input.currentValue.trim(),
          msg = {
        errorMsg: '',
        status: true
      };
      if (val === '') {
        msg.errorMsg = '请输入账号';
        msg.status = false;

        return msg;
      }

      if (!this.showSuggest) {
        if (val.indexOf(this.singleSuffix) === -1) {
          val += this.singleSuffix;
        }
      }
      if (!regemail.test(val)) {
        msg.errorMsg = '账号格式错误';
        msg.status = false;
      }
      return msg;
    }
  }
};

/***/ }),

/***/ 191:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


var DefaultTime = 3000;

exports.default = {
  data: function data() {
    return {
      toastCnt: ''
    };
  },
  beforeDestroy: function beforeDestroy() {
    if (this.sto) {
      window.clearTimeout(this.sto);
    }
  },

  methods: {
    show: function show(cnt) {
      var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DefaultTime;

      if (this.sto) {
        window.clearTimeout(this.sto);
      }
      this.toastCnt = cnt;
      this.sto = window.setTimeout(function () {
        this.hide();
      }.bind(this), time);
    },
    hide: function hide() {
      window.clearTimeout(this.sto);
      this.toastCnt = '';
    }
  }
};

/***/ }),

/***/ 192:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'urs-input',

  props: {
    placeholder: String,
    icontype: {
      type: String,
      default: 'icon-ic-clear'
    },
    type: {
      type: String,
      default: 'text'
    },
    name: String,
    disabled: Boolean,
    initialValue: {
      type: String,
      default: ''
    },
    maxlength: {
      type: Number,
      default: undefined
    },
    del_icon_clazz: {
      type: String,
      default: 'i-icon i-icon-delete'
    },
    size: {
      type: String,
      default: 'large'
    },
    validate: {
      type: Function,
      default: function _default() {
        return 1;
      }
    }
  },
  data: function data() {
    return {
      currentValue: this.initialValue
    };
  },

  watch: {
    initialValue: function initialValue(val) {
      this.currentValue = this.initialValue;
    }
  },
  methods: {
    focus: function focus() {
      this.$refs.input.focus();
    },
    blur: function blur() {
      this.$refs.input.blur();
    },
    setCurrentValue: function setCurrentValue(value) {
      if (value === this.currentValue) return;
      this.currentValue = value;
    },
    onInput: function onInput(event) {
      var value = event.target.value;
      this.setCurrentValue(value);

      this.$emit('input', value);
    },
    onBlur: function onBlur(event) {
      this.$emit('blur', this.currentValue);
    },
    onFocus: function onFocus(event) {
      var parent = this.$parent;
      if (parent && parent.$options.name == 'form-item') {
        parent.setMsg('');
      }
      this.$emit('focus', this.currentValue);
    },
    onDelete: function onDelete(event) {
      this.setCurrentValue('');
      this.$emit('delete');
    }
  }
};

/***/ }),

/***/ 193:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _request = __webpack_require__(39);

var _request2 = _interopRequireDefault(_request);

var _codemapper = __webpack_require__(31);

var _codemapper2 = _interopRequireDefault(_codemapper);

var _util = __webpack_require__(12);

var _util2 = _interopRequireDefault(_util);

var _bowser = __webpack_require__(90);

var _bowser2 = _interopRequireDefault(_bowser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'verify',
  props: {
    un: String,
    ppdata: Object
  },
  data: function data() {
    return {
      currentView: '',
      options: { un: this.un }
    };
  },
  mounted: function mounted() {
    this.changeView(this.ppdata);
  },

  methods: {
    changeView: function changeView(data) {
      switch (data.yz) {
        case '1':
          this.currentView = 'verifymb';
          this.options.mb = data.mb;
          break;
        case '2':
          this.currentView = 'verifyopt';
          break;
        case '3':
          this.currentView = 'verifyppc';
          this.options.cos = data.cos;
          break;
        case '4':
          this.options.receiveCode = data.receiveCode || '';
          this.options.newUp = data.receiveCode ? true : false;
          this.currentView = 'verifyluo';
          break;
        default:
          break;
      }
    },
    change: function change(data) {
      this.$emit('changeToLogin', data);
    },
    smsLink: function smsLink(_code, _number) {
      var agent = window.navigator.userAgent,
          joinStr = void 0;
      if (_bowser2.default.ios) {
        if (agent.match(/UcBrowser/i)) {
          return;
        }
        joinStr = '&';
      } else {
        joinStr = '?';
      }
      return 'sms:' + _code + joinStr + "body=" + _number;
    },
    changeModule: function changeModule(data) {
      this.currentView = data.module;
      if (this.currentView == 'smsup') {
        this.options.mobile = data.mobile;
        this.options.fromluo = data.fromluo || false;
        if (!!data.receiveCode) {
          var list = data.receiveCode.split(',');
          this.options.receiveCode = data.receiveCode;
          this.options.receiveCode1 = list[0];
          this.options.receiveCode2 = list[1];
          this.options.receiveCode3 = this.options.receiveCode2.replace(/(.{4})(?=.)/g, "$1 ");
          this.options.smscnt = this.smsLink(this.options.receiveCode2, this.options.receiveCode1);
        }
      } else if (this.currentView == 'verifyluo') {
        this.options.errMsg = data.errMsg || '';
        this.options.receiveCode = data.receiveCode || false;
        this.options.newUp = data.newUp || false;
      } else if (this.currentView == 'verifymb') {
        this.options.errMsg = data.errMsg || '';
      }
    }
  }
};

/***/ }),

/***/ 194:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _request = __webpack_require__(39);

var _request2 = _interopRequireDefault(_request);

var _util = __webpack_require__(12);

var _util2 = _interopRequireDefault(_util);

var _codemapper = __webpack_require__(31);

var _codemapper2 = _interopRequireDefault(_codemapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vfmbsmsCode = {
  '431': "请求错误，请您稍后再试",
  '412': "验证码错误次数过多，请明天再试",
  '413': "当日尝试次数过多，请明天再试",
  '443': "请输入正确的短信验证码",
  '430': "此次登录不需要进行密保验证"
};

_util2.default.merge(vfmbsmsCode, _codemapper2.default);

exports.default = {
  props: {
    options: Object
  },
  data: function data() {
    return {
      smsCount: 29,
      showUp: '',
      newUp: this.options.newUp,
      receiveCode: this.options.receiveCode || '',
      validateSms: function validateSms() {
        var val = this.currentValue,
            msg = {
          errorMsg: '',
          status: true
        };;
        var _regexp = /^[0-9]{6}$/;
        if (!_regexp.test(val)) {
          msg.errorMsg = '请输入正确的验证码';
          msg.status = false;
        }
        return msg;
      }
    };
  },
  mounted: function mounted() {
    window.Loading.loading = false;
    if (this.options.errMsg) {
      window.showError(this.options.errMsg);
    }
  },

  methods: {
    onSubmit: function onSubmit() {
      var _this = this;

      if (this.newUp) {
        if (this.validate(this.$refs, ['mbInput'])) {
          this.changeToNewSmsUp();
        }
      } else {
        if (this.validate(this.$refs, ['mbInput', 'smsInput'])) {
          this.$refs.submitBtn.state = 'loading';

          var data = {
            un: this.options.un,
            mb: this.$refs.mbInput.value,
            sms: this.$refs.smsInput.currentValue
          };

          (0, _request2.default)({
            url: '/vfmbsms',
            method: 'POST',
            contentType: 'application/x-www-form-urlencoded',
            data: data,
            success: function success(data) {
              _this.$refs.submitBtn.state = 'enable';
              _this.$emit('changeToLogin', { autoLogin: 1 });
            },
            error: function error(data) {
              _this.$refs.submitBtn.state = 'enable';

              if (data.ret === '401' && data.dt === '09') {
                window.showError('手机号格式错误');
                return;
              }
              if (data.ret === '401' && data.dt === '10') {
                data.ret = "40110";
                _this.$emit('changeToLogin', { errMsg: vfmbsmsCode[data.ret] });
                return;
              }

              if (data.ret == '430' || data.ret === '434' || data.ret === '435' || data.ret === '436' || data.ret === '437') {
                _this.$emit('changeToLogin', { errMsg: vfmbsmsCode[data.ret] });
                return;
              }

              window.showError(vfmbsmsCode[data.ret]);
            }
          });
        }
      }
    },
    validate: function validate(refs, array) {
      var children = this.$refs.form.$children,
          props = [];
      children.forEach(function (item) {
        if (item.$options.name == 'form-item') {
          props.push(item);
        }
      });
      var errorStatus = true,
          msg = void 0;
      props.forEach(function (item) {
        msg = item.$children[0].validate();
        if (!msg.status) {
          errorStatus = false;
          item.setMsg(msg.errorMsg);
        }
      });
      return errorStatus;
    },
    onGetSms: function onGetSms() {
      var _this2 = this;

      if (this.$refs.mbInput.validate()) {
        var data = {
          un: this.options.un,
          mb: this.$refs.mbInput.value
        };
        this.$refs.smsBtn.state = 'disable';

        (0, _request2.default)({
          url: '/mbsm',
          method: 'GET',
          data: data,
          success: function success(data) {
            _this2.$refs.smsBtn.state = 'enable';
            _this2.$refs.smsBtn.countDown();
            _this2.showUp = '';
          },
          error: function error(data) {
            _this2.$refs.smsBtn.state = 'enable';

            if (data.ret === '411') {
              var dt = data.dt;
              if (dt === '02') {
                if (_this2.$refs.mbInput.value.indexOf('-') > -1) {
                  window.showError('请刷新页面重试');
                  return;
                }
                _this2.receiveCode = data.receiveCode || '';
                _this2.changeToNewSmsUp();
              } else {
                _this2.showUp = '请用以上手机编辑短信 <strong>' + (data.receiveCode.split(',')[0] || '验证') + '</strong> 发送到 <strong>' + (data.receiveCode.split(',')[1] || '1069 8163 0163 331') + '</strong> 之后将获取到的验证码填入输入框';
              }
              return;
            }

            if (data.ret === '401' && data.dt === '09') {
              window.showError('手机号格式错误');
              return;
            }
            if (data.ret === '401' && data.dt === '10') {
              data.ret = '40110';
              _this2.$emit('changeToLogin', { errMsg: vfmbsmsCode[data.ret] });
            }

            if (data.ret == '430' || data.ret === '434' || data.ret === '435' || data.ret === '436' || data.ret === '437') {
              _this2.$emit('changeToLogin', { errMsg: vfmbsmsCode[data.ret] });
              return;
            }

            window.showError(vfmbsmsCode[data.ret]);
          }
        });
      }
    },
    changeToNewSmsUp: function changeToNewSmsUp() {
      this.$emit('changeModule', { module: 'smsup', mobile: this.$refs.mbInput.value, receiveCode: this.receiveCode, fromluo: true, newUp: true });
    }
  }
};

/***/ }),

/***/ 195:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _request = __webpack_require__(39);

var _request2 = _interopRequireDefault(_request);

var _util = __webpack_require__(12);

var _util2 = _interopRequireDefault(_util);

var _codemapper = __webpack_require__(31);

var _codemapper2 = _interopRequireDefault(_codemapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vfsmsCode = {
  '431': "请求错误，请您稍后再试",
  '410': "超过IP限制，请稍候再试",
  '412': "验证码错误次数过多，请明天再试",
  '413': "当日尝试次数过多，请明天再试",
  '443': "请输入正确的短信验证码",
  '453': "账号未关联手机号",
  '454': "账号关联手机未验证",
  '430': "此次登录不需要进行密保验证",
  '506': "短信发送失败，请稍后再试",
  '458': "短信发送过于频繁，请稍后再试"
};

_util2.default.merge(vfsmsCode, _codemapper2.default);

exports.default = {
  props: {
    options: Object
  },
  data: function data() {
    var _this = this;
    return {
      mb: this.options.mb,
      smsCount: 29,
      showUp: '',
      validateSms: function validateSms() {
        var val = this.currentValue;
        var _regexp = /^[0-9]{6}$/;
        if (val === '' || !_regexp.test(val)) {
          _this.$refs.smsValidate.setMsg('请输入正确的验证码');
          return false;
        }
        return true;
      }
    };
  },
  mounted: function mounted() {
    window.Loading.loading = false;
    if (this.options.errMsg) {
      window.showError(this.options.errMsg);
    }
  },

  methods: {
    onSubmit: function onSubmit() {
      var _this2 = this;

      if (this.$refs.smsInput.validate()) {
        this.$refs.submitBtn.state = 'loading';

        var data = {
          un: this.options.un,
          mb: this.mb,
          sms: this.$refs.smsInput.currentValue
        };
        if (this.newUp) {
          data.n = 1;
        }
        (0, _request2.default)({
          url: '/vfsms',
          method: 'POST',
          contentType: 'application/x-www-form-urlencoded',
          data: data,
          success: function success(data) {
            _this2.$refs.submitBtn.state = 'enable';
            _this2.$emit('changeToLogin', { autoLogin: 1 });
          },
          error: function error(data) {
            _this2.$refs.submitBtn.state = 'enable';

            if (data.ret == '430' || data.ret === '434' || data.ret === '435' || data.ret === '436' || data.ret === '437' || data.ret === '413' || data.ret === '412') {
              _this2.$emit('changeToLogin', { errMsg: vfsmsCode[data.ret] });
              return;
            }
            if (data.ret === '401' && data.dt === '10') {
              data.ret = '40110';
              _this2.$emit('changeToLogin', { errMsg: vfsmsCode[data.ret] });
              return;
            }

            window.showError(vfsmsCode[data.ret]);
          }
        });
      }
    },
    onGetSms: function onGetSms() {
      var _this3 = this;

      var data = {
        un: this.options.un
      };
      this.$refs.smsBtn.state = 'disable';
      (0, _request2.default)({
        url: '/sm',
        method: 'GET',
        data: data,
        success: function success(data) {
          _this3.$refs.smsBtn.state = 'enable';
          _this3.$refs.smsBtn.countDown();

          _this3.showUp = '';
          if (data.dt === '02') {
            _this3.newUp = true;
          }
        },
        error: function error(data) {
          _this3.$refs.smsBtn.state = 'enable';

          if (data.ret == '411') {
            var dt = data.dt;
            if (dt === '02') {
              _this3.newUp = true;
              _this3.$emit('changeModule', { module: 'smsup', mobile: _this3.mb, receiveCode: data.receiveCode });
            } else {
              _this3.showUp = '请用以上手机编辑短信 <strong>' + (data.receiveCode.split(',')[0] || '验证') + '</strong> 发送到 <strong>' + (data.receiveCode.split(',')[1] || '1069 8163 0163 331') + '</strong> 之后将获取到的验证码填入验证码输入框';
            }
            return;
          }

          if (data.ret == '430' || data.ret === '434' || data.ret === '435' || data.ret === '436' || data.ret === '437' || data.ret === '413' || data.ret === '412') {
            _this3.$emit('changeToLogin', { errMsg: vfsmsCode[data.ret] });
            return;
          }

          window.showError(vfsmsCode[data.ret]);
        }
      });
    }
  }
};

/***/ }),

/***/ 196:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _request = __webpack_require__(39);

var _request2 = _interopRequireDefault(_request);

var _util = __webpack_require__(12);

var _util2 = _interopRequireDefault(_util);

var _codemapper = __webpack_require__(31);

var _codemapper2 = _interopRequireDefault(_codemapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vfoptCode = {
  '412': "将军令验证错误次数过多，请改天再试",
  '430': "此次登录不需要进行密保验证",
  '431': "请求错误，请您稍后再试",
  '480': "动态密码错误，请重试",
  '481': "尝试次数过多，请稍候再试",
  '484': "账号未绑定将军令"
};

_util2.default.merge(vfoptCode, _codemapper2.default);

var regopt = /^\d{6}$/;

exports.default = {
  props: {
    options: Object
  },
  data: function data() {
    var _this = this;
    return {
      validateOpt: function validateOpt() {
        var val = this.currentValue;
        if (!regopt.test(val)) {
          _this.$refs.optValidate.setMsg('动态密码格式错误');
          return false;
        }
        return true;
      }
    };
  },
  mounted: function mounted() {
    window.Loading.loading = false;
  },

  methods: {
    onSubmit: function onSubmit() {
      var _this2 = this;

      if (this.$refs.optInput.validate()) {
        this.$refs.submitBtn.state = 'loading';

        var data = {
          un: this.options.un,
          otppwd: this.$refs.optInput.currentValue
        };
        (0, _request2.default)({
          url: '/vfotp',
          method: 'POST',
          contentType: 'application/x-www-form-urlencoded',
          data: data,
          success: function success(data) {
            _this2.$refs.submitBtn.state = 'enable';
            _this2.$emit('changeToLogin', { autoLogin: 1 });
          },
          error: function error(data) {
            _this2.$refs.submitBtn.state = 'enable';

            if (data.ret === '480' || data.ret === '500' || data.ret === '501') {
              window.showError(vfoptCode[data.ret]);
              return;
            }
            if (data.ret === '401' && data.dt === '10') {
              data.ret = '40110';
            }

            _this2.$emit('changeToLogin', { errMsg: vfoptCode[data.ret], ret: data.ret, un: _this2.options.un });
          }
        });
      }
    }
  }
};

/***/ }),

/***/ 197:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _request = __webpack_require__(39);

var _request2 = _interopRequireDefault(_request);

var _util = __webpack_require__(12);

var _util2 = _interopRequireDefault(_util);

var _codemapper = __webpack_require__(31);

var _codemapper2 = _interopRequireDefault(_codemapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vfppcCode = {
  '412': "密保卡验证错误次数过多，请改天再试",
  '430': "此次登录不需要进行密保验证",
  '431': "请求错误，请您稍后再试",
  '492': "账号未绑定密保卡",
  '493': "验证码验证错误，请重新输入坐标对应数字",
  '494': "验证码验证错误，请重新输入坐标对应数字"
};

_util2.default.merge(vfppcCode, _codemapper2.default);

exports.default = {
  props: {
    options: Object
  },
  data: function data() {
    return {
      cos: this.options.cos
    };
  },

  computed: {
    cards: function cards() {
      return this.cos.split(';');
    }
  },
  mounted: function mounted() {
    window.Loading.loading = false;
  },

  methods: {
    clearError: function clearError(index) {
      this.$refs.cards[index].className = '';
    },
    onSubmit: function onSubmit() {
      var _this = this;

      var cards = this.$refs.cards;
      var ppcpwd = '';
      var flag = 1;
      for (var i = 0; i < cards.length; i++) {
        var value = cards[i].getElementsByTagName('input')[0].value;
        if (!/^\d{1,3}$/.test(value)) {
          window.showError('请正确输入密保卡上对应的数字');

          cards[i].className = 'error';
          flag = 0;
        }
        ppcpwd += value;
      }
      if (!flag) {
        return;
      }

      this.$refs.submitBtn.state = 'loading';

      var data = {
        cos: this.options.cos,
        ppcpwd: ppcpwd,
        un: this.options.un
      };
      (0, _request2.default)({
        url: '/vfppc',
        method: 'POST',
        contentType: 'application/x-www-form-urlencoded',
        data: data,
        success: function success(data) {
          _this.$refs.submitBtn.state = 'enable';
          _this.$emit('changeToLogin', { autoLogin: 1 });
        },
        error: function error(data) {
          _this.$refs.submitBtn.state = 'enable';

          if (data.ret === '493' || data.ret === '494' || data.ret === '500' || data.ret === '501') {
            if (!!data.cos) {
              _this.cos = data.cos;

              _this.$refs.form.reset();
            }
            window.showError(vfppcCode[data.ret]);
            return;
          }
          if (data.ret === '401' && data.dt === '10') {
            data.ret = '40110';
          }

          _this.$emit('changeToLogin', { errMsg: vfppcCode[data.ret], ret: data.ret, un: _this.options.un });
        }
      });
    }
  }
};

/***/ }),

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: "checkbox",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ""
    },
    name: {
      type: String
    }
  },
  data: function data() {
    return {
      currentChecked: this.value
    };
  },

  watch: {
    value: function value(val) {
      this.currentChecked = val;
    }
  },

  computed: {
    getClass: function getClass() {
      if (!this.currentChecked) {
        return "checkbox-inner  ";
      } else {
        return "checkbox-inner checkbox-inner-checked";
      }
    }
  },

  methods: {
    change: function change() {
      this.currentChecked = !this.currentChecked;
      this.$emit("input", this.currentChecked);
      this.$emit("change", this.currentChecked);
    },
    getValue: function getValue() {
      return this.currentChecked;
    }
  },
  mounted: function mounted() {}
};

/***/ }),

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  }
};

/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__(12);

var _util2 = _interopRequireDefault(_util);

var _bCheckBox = __webpack_require__(497);

var _bCheckBox2 = _interopRequireDefault(_bCheckBox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOADIFRAME_TIME = 5000;
exports.default = {
  name: 'mode',
  components: {
    bCheckbox: _bCheckBox2.default
  },
  props: {
    mode: {
      type: Object,
      default: {}
    },
    toUrl: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      checkStatus: false
    };
  },
  mounted: function mounted() {
    window.Loading.loading = false;
  },

  methods: {
    onClose: function onClose() {},
    modeClose: function modeClose() {
      var _this = this;

      var srcList = this.mode.srcList;
      if (this.mode.mode === 4 && srcList) {
        srcList.forEach(function (item, index) {
          var _ck = _this.checkStatus ? '1' : '0';
          srcList[index] += '&ck=' + _ck;
        });
      }
      if (srcList && this.mode.srcList.length > 0) {
        this.setDomains(this.mode.srcList, function () {
          _this.goBack();
        });
      } else {
        this.goBack();
      }
    },
    goBack: function goBack() {
      if (this.mode.mode === 1) {
        window.open(this.mode.btnLink0);
      } else if (this.mode.mode === 3 || this.mode.mode === 4 || this.mode.mode === 0) {
        window.jumpLoading.loading = true;
        location.href = this.toUrl;
      } else {
        this.$emit('backLogin', { autoLogin: false });
      }
    },
    onConfirm: function onConfirm() {
      location.href = this.mode.btnLink1;
    },

    setDomains: function (urls, endfunc) {
      var count = 0;
      return function (urls, endfunc) {
        var _this2 = this;

        if (typeof urls === 'string') {
          _util2.default.insertFrame(urls, this.mode.opd, function () {
            endfunc();
          });
        } else if (urls.length > 0) {
          count = urls.length;
          this.sto = window.setTimeout(function () {
            endfunc();
          }, LOADIFRAME_TIME);
          for (var i = 0; i < urls.length; i++) {
            _util2.default.insertFrame(urls[i], this.mode.opd, function () {
              count--;
              if (count === 0) {
                endfunc();
                window.clearTimeout(_this2.sto);
              }
            });
          }
        } else {
          endfunc();
        }
      };
    }()
  },
  beforeDestroy: function beforeDestroy() {
    if (this.sto) {
      window.clearTimeout(this.sto);
    }
  }
};

/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(89);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(214);

var _extends3 = _interopRequireDefault(_extends2);

var _jsSha = __webpack_require__(473);

var _bignumber = __webpack_require__(216);

var _bignumber2 = _interopRequireDefault(_bignumber);

var _util = __webpack_require__(12);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'PowerCap',

    props: {},

    data: function data() {
        return {};
    },
    mounted: function mounted() {},


    methods: {
        webWorkerCompute: function webWorkerCompute(data) {
            var _this = this;

            var jshash = '!function(){"use strict";function t(t,i){i?(d[0]=d[16]=d[1]=d[2]=d[3]=d[4]=d[5]=d[6]=d[7]=d[8]=d[9]=d[10]=d[11]=d[12]=d[13]=d[14]=d[15]=0,this.blocks=d):this.blocks=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],t?(this.h0=3238371032,this.h1=914150663,this.h2=812702999,this.h3=4144912697,this.h4=4290775857,this.h5=1750603025,this.h6=1694076839,this.h7=3204075428):(this.h0=1779033703,this.h1=3144134277,this.h2=1013904242,this.h3=2773480762,this.h4=1359893119,this.h5=2600822924,this.h6=528734635,this.h7=1541459225),this.block=this.start=this.bytes=this.hBytes=0,this.finalized=this.hashed=!1,this.first=!0,this.is224=t}function i(i,r,s){var e,n=typeof i;if("string"===n){var o,a=[],u=i.length,c=0;for(e=0;e<u;++e)(o=i.charCodeAt(e))<128?a[c++]=o:o<2048?(a[c++]=192|o>>6,a[c++]=128|63&o):o<55296||o>=57344?(a[c++]=224|o>>12,a[c++]=128|o>>6&63,a[c++]=128|63&o):(o=65536+((1023&o)<<10|1023&i.charCodeAt(++e)),a[c++]=240|o>>18,a[c++]=128|o>>12&63,a[c++]=128|o>>6&63,a[c++]=128|63&o);i=a}else{if("object"!==n)throw new Error(h);if(null===i)throw new Error(h);if(f&&i.constructor===ArrayBuffer)i=new Uint8Array(i);else if(!(Array.isArray(i)||f&&ArrayBuffer.isView(i)))throw new Error(h)}i.length>64&&(i=new t(r,!0).update(i).array());var y=[],p=[];for(e=0;e<64;++e){var l=i[e]||0;y[e]=92^l,p[e]=54^l}t.call(this,r,s),this.update(p),this.oKeyPad=y,this.inner=!0,this.sharedMemory=s}var h="input is invalid type",r="object"==typeof window,s=r?window:{};s.JS_SHA256_NO_WINDOW&&(r=!1);var e=!r&&"object"==typeof self,n=!s.JS_SHA256_NO_NODE_JS&&"object"==typeof process&&process.versions&&process.versions.node;n?s=global:e&&(s=self);var o=!s.JS_SHA256_NO_COMMON_JS&&"object"==typeof module&&module.exports,a="function"==typeof define&&define.amd,f=!s.JS_SHA256_NO_ARRAY_BUFFER&&"undefined"!=typeof ArrayBuffer,u="0123456789abcdef".split(""),c=[-2147483648,8388608,32768,128],y=[24,16,8,0],p=[1116352408,1899447441,3049323471,3921009573,961987163,1508970993,2453635748,2870763221,3624381080,310598401,607225278,1426881987,1925078388,2162078206,2614888103,3248222580,3835390401,4022224774,264347078,604807628,770255983,1249150122,1555081692,1996064986,2554220882,2821834349,2952996808,3210313671,3336571891,3584528711,113926993,338241895,666307205,773529912,1294757372,1396182291,1695183700,1986661051,2177026350,2456956037,2730485921,2820302411,3259730800,3345764771,3516065817,3600352804,4094571909,275423344,430227734,506948616,659060556,883997877,958139571,1322822218,1537002063,1747873779,1955562222,2024104815,2227730452,2361852424,2428436474,2756734187,3204031479,3329325298],l=["hex","array","digest","arrayBuffer"],d=[];!s.JS_SHA256_NO_NODE_JS&&Array.isArray||(Array.isArray=function(t){return"[object Array]"===Object.prototype.toString.call(t)}),!f||!s.JS_SHA256_NO_ARRAY_BUFFER_IS_VIEW&&ArrayBuffer.isView||(ArrayBuffer.isView=function(t){return"object"==typeof t&&t.buffer&&t.buffer.constructor===ArrayBuffer});var A=function(i,h){return function(r){return new t(h,!0).update(r)[i]()}},w=function(i){var h=A("hex",i);n&&(h=b(h,i)),h.create=function(){return new t(i)},h.update=function(t){return h.create().update(t)};for(var r=0;r<l.length;++r){var s=l[r];h[s]=A(s,i)}return h},b=function(t,i){var r=eval("require(\'crypto\')"),s=eval("require(\'buffer\').Buffer"),e=i?"sha224":"sha256",n=function(i){if("string"==typeof i)return r.createHash(e).update(i,"utf8").digest("hex");if(null===i||void 0===i)throw new Error(h);return i.constructor===ArrayBuffer&&(i=new Uint8Array(i)),Array.isArray(i)||ArrayBuffer.isView(i)||i.constructor===s?r.createHash(e).update(new s(i)).digest("hex"):t(i)};return n},v=function(t,h){return function(r,s){return new i(r,h,!0).update(s)[t]()}},_=function(t){var h=v("hex",t);h.create=function(h){return new i(h,t)},h.update=function(t,i){return h.create(t).update(i)};for(var r=0;r<l.length;++r){var s=l[r];h[s]=v(s,t)}return h};t.prototype.update=function(t){if(!this.finalized){var i,r=typeof t;if("string"!==r){if("object"!==r)throw new Error(h);if(null===t)throw new Error(h);if(f&&t.constructor===ArrayBuffer)t=new Uint8Array(t);else if(!(Array.isArray(t)||f&&ArrayBuffer.isView(t)))throw new Error(h);i=!0}for(var s,e,n=0,o=t.length,a=this.blocks;n<o;){if(this.hashed&&(this.hashed=!1,a[0]=this.block,a[16]=a[1]=a[2]=a[3]=a[4]=a[5]=a[6]=a[7]=a[8]=a[9]=a[10]=a[11]=a[12]=a[13]=a[14]=a[15]=0),i)for(e=this.start;n<o&&e<64;++n)a[e>>2]|=t[n]<<y[3&e++];else for(e=this.start;n<o&&e<64;++n)(s=t.charCodeAt(n))<128?a[e>>2]|=s<<y[3&e++]:s<2048?(a[e>>2]|=(192|s>>6)<<y[3&e++],a[e>>2]|=(128|63&s)<<y[3&e++]):s<55296||s>=57344?(a[e>>2]|=(224|s>>12)<<y[3&e++],a[e>>2]|=(128|s>>6&63)<<y[3&e++],a[e>>2]|=(128|63&s)<<y[3&e++]):(s=65536+((1023&s)<<10|1023&t.charCodeAt(++n)),a[e>>2]|=(240|s>>18)<<y[3&e++],a[e>>2]|=(128|s>>12&63)<<y[3&e++],a[e>>2]|=(128|s>>6&63)<<y[3&e++],a[e>>2]|=(128|63&s)<<y[3&e++]);this.lastByteIndex=e,this.bytes+=e-this.start,e>=64?(this.block=a[16],this.start=e-64,this.hash(),this.hashed=!0):this.start=e}return this.bytes>4294967295&&(this.hBytes+=this.bytes/4294967296<<0,this.bytes=this.bytes%4294967296),this}},t.prototype.finalize=function(){if(!this.finalized){this.finalized=!0;var t=this.blocks,i=this.lastByteIndex;t[16]=this.block,t[i>>2]|=c[3&i],this.block=t[16],i>=56&&(this.hashed||this.hash(),t[0]=this.block,t[16]=t[1]=t[2]=t[3]=t[4]=t[5]=t[6]=t[7]=t[8]=t[9]=t[10]=t[11]=t[12]=t[13]=t[14]=t[15]=0),t[14]=this.hBytes<<3|this.bytes>>>29,t[15]=this.bytes<<3,this.hash()}},t.prototype.hash=function(){var t,i,h,r,s,e,n,o,a,f=this.h0,u=this.h1,c=this.h2,y=this.h3,l=this.h4,d=this.h5,A=this.h6,w=this.h7,b=this.blocks;for(t=16;t<64;++t)i=((s=b[t-15])>>>7|s<<25)^(s>>>18|s<<14)^s>>>3,h=((s=b[t-2])>>>17|s<<15)^(s>>>19|s<<13)^s>>>10,b[t]=b[t-16]+i+b[t-7]+h<<0;for(a=u&c,t=0;t<64;t+=4)this.first?(this.is224?(e=300032,w=(s=b[0]-1413257819)-150054599<<0,y=s+24177077<<0):(e=704751109,w=(s=b[0]-210244248)-1521486534<<0,y=s+143694565<<0),this.first=!1):(i=(f>>>2|f<<30)^(f>>>13|f<<19)^(f>>>22|f<<10),r=(e=f&u)^f&c^a,w=y+(s=w+(h=(l>>>6|l<<26)^(l>>>11|l<<21)^(l>>>25|l<<7))+(l&d^~l&A)+p[t]+b[t])<<0,y=s+(i+r)<<0),i=(y>>>2|y<<30)^(y>>>13|y<<19)^(y>>>22|y<<10),r=(n=y&f)^y&u^e,A=c+(s=A+(h=(w>>>6|w<<26)^(w>>>11|w<<21)^(w>>>25|w<<7))+(w&l^~w&d)+p[t+1]+b[t+1])<<0,i=((c=s+(i+r)<<0)>>>2|c<<30)^(c>>>13|c<<19)^(c>>>22|c<<10),r=(o=c&y)^c&f^n,d=u+(s=d+(h=(A>>>6|A<<26)^(A>>>11|A<<21)^(A>>>25|A<<7))+(A&w^~A&l)+p[t+2]+b[t+2])<<0,i=((u=s+(i+r)<<0)>>>2|u<<30)^(u>>>13|u<<19)^(u>>>22|u<<10),r=(a=u&c)^u&y^o,l=f+(s=l+(h=(d>>>6|d<<26)^(d>>>11|d<<21)^(d>>>25|d<<7))+(d&A^~d&w)+p[t+3]+b[t+3])<<0,f=s+(i+r)<<0;this.h0=this.h0+f<<0,this.h1=this.h1+u<<0,this.h2=this.h2+c<<0,this.h3=this.h3+y<<0,this.h4=this.h4+l<<0,this.h5=this.h5+d<<0,this.h6=this.h6+A<<0,this.h7=this.h7+w<<0},t.prototype.hex=function(){this.finalize();var t=this.h0,i=this.h1,h=this.h2,r=this.h3,s=this.h4,e=this.h5,n=this.h6,o=this.h7,a=u[t>>28&15]+u[t>>24&15]+u[t>>20&15]+u[t>>16&15]+u[t>>12&15]+u[t>>8&15]+u[t>>4&15]+u[15&t]+u[i>>28&15]+u[i>>24&15]+u[i>>20&15]+u[i>>16&15]+u[i>>12&15]+u[i>>8&15]+u[i>>4&15]+u[15&i]+u[h>>28&15]+u[h>>24&15]+u[h>>20&15]+u[h>>16&15]+u[h>>12&15]+u[h>>8&15]+u[h>>4&15]+u[15&h]+u[r>>28&15]+u[r>>24&15]+u[r>>20&15]+u[r>>16&15]+u[r>>12&15]+u[r>>8&15]+u[r>>4&15]+u[15&r]+u[s>>28&15]+u[s>>24&15]+u[s>>20&15]+u[s>>16&15]+u[s>>12&15]+u[s>>8&15]+u[s>>4&15]+u[15&s]+u[e>>28&15]+u[e>>24&15]+u[e>>20&15]+u[e>>16&15]+u[e>>12&15]+u[e>>8&15]+u[e>>4&15]+u[15&e]+u[n>>28&15]+u[n>>24&15]+u[n>>20&15]+u[n>>16&15]+u[n>>12&15]+u[n>>8&15]+u[n>>4&15]+u[15&n];return this.is224||(a+=u[o>>28&15]+u[o>>24&15]+u[o>>20&15]+u[o>>16&15]+u[o>>12&15]+u[o>>8&15]+u[o>>4&15]+u[15&o]),a},t.prototype.toString=t.prototype.hex,t.prototype.digest=function(){this.finalize();var t=this.h0,i=this.h1,h=this.h2,r=this.h3,s=this.h4,e=this.h5,n=this.h6,o=this.h7,a=[t>>24&255,t>>16&255,t>>8&255,255&t,i>>24&255,i>>16&255,i>>8&255,255&i,h>>24&255,h>>16&255,h>>8&255,255&h,r>>24&255,r>>16&255,r>>8&255,255&r,s>>24&255,s>>16&255,s>>8&255,255&s,e>>24&255,e>>16&255,e>>8&255,255&e,n>>24&255,n>>16&255,n>>8&255,255&n];return this.is224||a.push(o>>24&255,o>>16&255,o>>8&255,255&o),a},t.prototype.array=t.prototype.digest,t.prototype.arrayBuffer=function(){this.finalize();var t=new ArrayBuffer(this.is224?28:32),i=new DataView(t);return i.setUint32(0,this.h0),i.setUint32(4,this.h1),i.setUint32(8,this.h2),i.setUint32(12,this.h3),i.setUint32(16,this.h4),i.setUint32(20,this.h5),i.setUint32(24,this.h6),this.is224||i.setUint32(28,this.h7),t},i.prototype=new t,i.prototype.finalize=function(){if(t.prototype.finalize.call(this),this.inner){this.inner=!1;var i=this.array();t.call(this,this.is224,this.sharedMemory),this.update(this.oKeyPad),this.update(i),t.prototype.finalize.call(this)}};var B=w();B.sha256=B,B.sha224=w(!0),B.sha256.hmac=_(),B.sha224.hmac=_(!0),o?module.exports=B:(s.sha256=B.sha256,s.sha224=B.sha224,a&&define(function(){return B}))}();';

            var bignumjs = '!function(e){"use strict";var r,n=/^-?(?:\\d+(?:\\.\\d*)?|\\.\\d+)(?:e[+-]?\\d+)?$/i,t=Math.ceil,i=Math.floor,o="[BigNumber Error] ",s=o+"Number primitive has more than 15 significant digits: ",f=1e14,u=14,l=9007199254740991,c=[1,10,100,1e3,1e4,1e5,1e6,1e7,1e8,1e9,1e10,1e11,1e12,1e13],a=1e7,h=1e9;function g(e){var r=0|e;return e>0||e===r?r:r-1}function p(e){for(var r,n,t=1,i=e.length,o=e[0]+"";t<i;){for(r=e[t++]+"",n=u-r.length;n--;r="0"+r);o+=r}for(i=o.length;48===o.charCodeAt(--i););return o.slice(0,i+1||1)}function w(e,r){var n,t,i=e.c,o=r.c,s=e.s,f=r.s,u=e.e,l=r.e;if(!s||!f)return null;if(n=i&&!i[0],t=o&&!o[0],n||t)return n?t?0:-f:s;if(s!=f)return s;if(n=s<0,t=u==l,!i||!o)return t?0:!i^n?1:-1;if(!t)return u>l^n?1:-1;for(f=(u=i.length)<(l=o.length)?u:l,s=0;s<f;s++)if(i[s]!=o[s])return i[s]>o[s]^n?1:-1;return u==l?0:u>l^n?1:-1}function d(e,r,n,t){if(e<r||e>n||e!==i(e))throw Error(o+(t||"Argument")+("number"==typeof e?e<r||e>n?" out of range: ":" not an integer: ":" not a primitive number: ")+String(e))}function m(e){var r=e.c.length-1;return g(e.e/u)==r&&e.c[r]%2!=0}function v(e,r){return(e.length>1?e.charAt(0)+"."+e.slice(1):e)+(r<0?"e":"e+")+r}function N(e,r,n){var t,i;if(r<0){for(i=n+".";++r;i+=n);e=i+e}else if(++r>(t=e.length)){for(i=n,r-=t;--r;i+=n);e+=i}else r<t&&(e=e.slice(0,r)+"."+e.slice(r));return e}r=function e(r){var O,y,b,E,A,S,R,_,B,D,P=z.prototype={constructor:z,toString:null,valueOf:null},x=new z(1),L=20,U=4,I=-7,T=21,C=-1e7,M=1e7,G=!1,k=1,F=0,q={prefix:"",groupSize:3,secondaryGroupSize:0,groupSeparator:",",decimalSeparator:".",fractionGroupSize:0,fractionGroupSeparator:" ",suffix:""},j="0123456789abcdefghijklmnopqrstuvwxyz",$=!0;function z(e,r){var t,o,f,c,a,h,g,p,w=this;if(!(w instanceof z))return new z(e,r);if(null==r){if(e&&!0===e._isBigNumber)return w.s=e.s,void(!e.c||e.e>M?w.c=w.e=null:e.e<C?w.c=[w.e=0]:(w.e=e.e,w.c=e.c.slice()));if((h="number"==typeof e)&&0*e==0){if(w.s=1/e<0?(e=-e,-1):1,e===~~e){for(c=0,a=e;a>=10;a/=10,c++);return void(c>M?w.c=w.e=null:(w.e=c,w.c=[e]))}p=String(e)}else{if(!n.test(p=String(e)))return b(w,p,h);w.s=45==p.charCodeAt(0)?(p=p.slice(1),-1):1}(c=p.indexOf("."))>-1&&(p=p.replace(".","")),(a=p.search(/e/i))>0?(c<0&&(c=a),c+=+p.slice(a+1),p=p.substring(0,a)):c<0&&(c=p.length)}else{if(d(r,2,j.length,"Base"),10==r&&$)return X(w=new z(e),L+w.e+1,U);if(p=String(e),h="number"==typeof e){if(0*e!=0)return b(w,p,h,r);if(w.s=1/e<0?(p=p.slice(1),-1):1,z.DEBUG&&p.replace(/^0\\.0*|\\./,"").length>15)throw Error(s+e)}else w.s=45===p.charCodeAt(0)?(p=p.slice(1),-1):1;for(t=j.slice(0,r),c=a=0,g=p.length;a<g;a++)if(t.indexOf(o=p.charAt(a))<0){if("."==o){if(a>c){c=g;continue}}else if(!f&&(p==p.toUpperCase()&&(p=p.toLowerCase())||p==p.toLowerCase()&&(p=p.toUpperCase()))){f=!0,a=-1,c=0;continue}return b(w,String(e),h,r)}h=!1,(c=(p=y(p,r,10,w.s)).indexOf("."))>-1?p=p.replace(".",""):c=p.length}for(a=0;48===p.charCodeAt(a);a++);for(g=p.length;48===p.charCodeAt(--g););if(p=p.slice(a,++g)){if(g-=a,h&&z.DEBUG&&g>15&&(e>l||e!==i(e)))throw Error(s+w.s*e);if((c=c-a-1)>M)w.c=w.e=null;else if(c<C)w.c=[w.e=0];else{if(w.e=c,w.c=[],a=(c+1)%u,c<0&&(a+=u),a<g){for(a&&w.c.push(+p.slice(0,a)),g-=u;a<g;)w.c.push(+p.slice(a,a+=u));a=u-(p=p.slice(a)).length}else a-=g;for(;a--;p+="0");w.c.push(+p)}}else w.c=[w.e=0]}function H(e,r,n,t){var i,o,s,f,u;if(null==n?n=U:d(n,0,8),!e.c)return e.toString();if(i=e.c[0],s=e.e,null==r)u=p(e.c),u=1==t||2==t&&(s<=I||s>=T)?v(u,s):N(u,s,"0");else if(o=(e=X(new z(e),r,n)).e,f=(u=p(e.c)).length,1==t||2==t&&(r<=o||o<=I)){for(;f<r;u+="0",f++);u=v(u,o)}else if(r-=s,u=N(u,o,"0"),o+1>f){if(--r>0)for(u+=".";r--;u+="0");}else if((r+=o-f)>0)for(o+1==f&&(u+=".");r--;u+="0");return e.s<0&&i?"-"+u:u}function V(e,r){for(var n,t=1,i=new z(e[0]);t<e.length;t++){if(!(n=new z(e[t])).s){i=n;break}r.call(i,n)&&(i=n)}return i}function W(e,r,n){for(var t=1,i=r.length;!r[--i];r.pop());for(i=r[0];i>=10;i/=10,t++);return(n=t+n*u-1)>M?e.c=e.e=null:n<C?e.c=[e.e=0]:(e.e=n,e.c=r),e}function X(e,r,n,o){var s,l,a,h,g,p,w,d=e.c,m=c;if(d){e:{for(s=1,h=d[0];h>=10;h/=10,s++);if((l=r-s)<0)l+=u,a=r,w=(g=d[p=0])/m[s-a-1]%10|0;else if((p=t((l+1)/u))>=d.length){if(!o)break e;for(;d.length<=p;d.push(0));g=w=0,s=1,a=(l%=u)-u+1}else{for(g=h=d[p],s=1;h>=10;h/=10,s++);w=(a=(l%=u)-u+s)<0?0:g/m[s-a-1]%10|0}if(o=o||r<0||null!=d[p+1]||(a<0?g:g%m[s-a-1]),o=n<4?(w||o)&&(0==n||n==(e.s<0?3:2)):w>5||5==w&&(4==n||o||6==n&&(l>0?a>0?g/m[s-a]:0:d[p-1])%10&1||n==(e.s<0?8:7)),r<1||!d[0])return d.length=0,o?(r-=e.e+1,d[0]=m[(u-r%u)%u],e.e=-r||0):d[0]=e.e=0,e;if(0==l?(d.length=p,h=1,p--):(d.length=p+1,h=m[u-l],d[p]=a>0?i(g/m[s-a]%m[a])*h:0),o)for(;;){if(0==p){for(l=1,a=d[0];a>=10;a/=10,l++);for(a=d[0]+=h,h=1;a>=10;a/=10,h++);l!=h&&(e.e++,d[0]==f&&(d[0]=1));break}if(d[p]+=h,d[p]!=f)break;d[p--]=0,h=1}for(l=d.length;0===d[--l];d.pop());}e.e>M?e.c=e.e=null:e.e<C&&(e.c=[e.e=0])}return e}function Y(e){var r,n=e.e;return null===n?e.toString():(r=p(e.c),r=n<=I||n>=T?v(r,n):N(r,n,"0"),e.s<0?"-"+r:r)}return z.clone=e,z.ROUND_UP=0,z.ROUND_DOWN=1,z.ROUND_CEIL=2,z.ROUND_FLOOR=3,z.ROUND_HALF_UP=4,z.ROUND_HALF_DOWN=5,z.ROUND_HALF_EVEN=6,z.ROUND_HALF_CEIL=7,z.ROUND_HALF_FLOOR=8,z.EUCLID=9,z.config=z.set=function(e){var r,n;if(null!=e){if("object"!=typeof e)throw Error(o+"Object expected: "+e);if(e.hasOwnProperty(r="DECIMAL_PLACES")&&(d(n=e[r],0,h,r),L=n),e.hasOwnProperty(r="ROUNDING_MODE")&&(d(n=e[r],0,8,r),U=n),e.hasOwnProperty(r="EXPONENTIAL_AT")&&((n=e[r])&&n.pop?(d(n[0],-h,0,r),d(n[1],0,h,r),I=n[0],T=n[1]):(d(n,-h,h,r),I=-(T=n<0?-n:n))),e.hasOwnProperty(r="RANGE"))if((n=e[r])&&n.pop)d(n[0],-h,-1,r),d(n[1],1,h,r),C=n[0],M=n[1];else{if(d(n,-h,h,r),!n)throw Error(o+r+" cannot be zero: "+n);C=-(M=n<0?-n:n)}if(e.hasOwnProperty(r="CRYPTO")){if((n=e[r])!==!!n)throw Error(o+r+" not true or false: "+n);if(n){if("undefined"==typeof crypto||!crypto||!crypto.getRandomValues&&!crypto.randomBytes)throw G=!n,Error(o+"crypto unavailable");G=n}else G=n}if(e.hasOwnProperty(r="MODULO_MODE")&&(d(n=e[r],0,9,r),k=n),e.hasOwnProperty(r="POW_PRECISION")&&(d(n=e[r],0,h,r),F=n),e.hasOwnProperty(r="FORMAT")){if("object"!=typeof(n=e[r]))throw Error(o+r+" not an object: "+n);q=n}if(e.hasOwnProperty(r="ALPHABET")){if("string"!=typeof(n=e[r])||/^.?$|[+\\-.\\s]|(.).*\\1/.test(n))throw Error(o+r+" invalid: "+n);$="0123456789"==n.slice(0,10),j=n}}return{DECIMAL_PLACES:L,ROUNDING_MODE:U,EXPONENTIAL_AT:[I,T],RANGE:[C,M],CRYPTO:G,MODULO_MODE:k,POW_PRECISION:F,FORMAT:q,ALPHABET:j}},z.isBigNumber=function(e){if(!e||!0!==e._isBigNumber)return!1;if(!z.DEBUG)return!0;var r,n,t=e.c,s=e.e,l=e.s;e:if("[object Array]"=={}.toString.call(t)){if((1===l||-1===l)&&s>=-h&&s<=h&&s===i(s)){if(0===t[0]){if(0===s&&1===t.length)return!0;break e}if((r=(s+1)%u)<1&&(r+=u),String(t[0]).length==r){for(r=0;r<t.length;r++)if((n=t[r])<0||n>=f||n!==i(n))break e;if(0!==n)return!0}}}else if(null===t&&null===s&&(null===l||1===l||-1===l))return!0;throw Error(o+"Invalid BigNumber: "+e)},z.maximum=z.max=function(){return V(arguments,P.lt)},z.minimum=z.min=function(){return V(arguments,P.gt)},z.random=(E=9007199254740992,A=Math.random()*E&2097151?function(){return i(Math.random()*E)}:function(){return 8388608*(1073741824*Math.random()|0)+(8388608*Math.random()|0)},function(e){var r,n,s,f,l,a=0,g=[],p=new z(x);if(null==e?e=L:d(e,0,h),f=t(e/u),G)if(crypto.getRandomValues){for(r=crypto.getRandomValues(new Uint32Array(f*=2));a<f;)(l=131072*r[a]+(r[a+1]>>>11))>=9e15?(n=crypto.getRandomValues(new Uint32Array(2)),r[a]=n[0],r[a+1]=n[1]):(g.push(l%1e14),a+=2);a=f/2}else{if(!crypto.randomBytes)throw G=!1,Error(o+"crypto unavailable");for(r=crypto.randomBytes(f*=7);a<f;)(l=281474976710656*(31&r[a])+1099511627776*r[a+1]+4294967296*r[a+2]+16777216*r[a+3]+(r[a+4]<<16)+(r[a+5]<<8)+r[a+6])>=9e15?crypto.randomBytes(7).copy(r,a):(g.push(l%1e14),a+=7);a=f/7}if(!G)for(;a<f;)(l=A())<9e15&&(g[a++]=l%1e14);for(f=g[--a],e%=u,f&&e&&(l=c[u-e],g[a]=i(f/l)*l);0===g[a];g.pop(),a--);if(a<0)g=[s=0];else{for(s=-1;0===g[0];g.splice(0,1),s-=u);for(a=1,l=g[0];l>=10;l/=10,a++);a<u&&(s-=u-a)}return p.e=s,p.c=g,p}),z.sum=function(){for(var e=1,r=arguments,n=new z(r[0]);e<r.length;)n=n.plus(r[e++]);return n},y=function(){var e="0123456789";function r(e,r,n,t){for(var i,o,s=[0],f=0,u=e.length;f<u;){for(o=s.length;o--;s[o]*=r);for(s[0]+=t.indexOf(e.charAt(f++)),i=0;i<s.length;i++)s[i]>n-1&&(null==s[i+1]&&(s[i+1]=0),s[i+1]+=s[i]/n|0,s[i]%=n)}return s.reverse()}return function(n,t,i,o,s){var f,u,l,c,a,h,g,w,d=n.indexOf("."),m=L,v=U;for(d>=0&&(c=F,F=0,n=n.replace(".",""),h=(w=new z(t)).pow(n.length-d),F=c,w.c=r(N(p(h.c),h.e,"0"),10,i,e),w.e=w.c.length),l=c=(g=r(n,t,i,s?(f=j,e):(f=e,j))).length;0==g[--c];g.pop());if(!g[0])return f.charAt(0);if(d<0?--l:(h.c=g,h.e=l,h.s=o,g=(h=O(h,w,m,v,i)).c,a=h.r,l=h.e),d=g[u=l+m+1],c=i/2,a=a||u<0||null!=g[u+1],a=v<4?(null!=d||a)&&(0==v||v==(h.s<0?3:2)):d>c||d==c&&(4==v||a||6==v&&1&g[u-1]||v==(h.s<0?8:7)),u<1||!g[0])n=a?N(f.charAt(1),-m,f.charAt(0)):f.charAt(0);else{if(g.length=u,a)for(--i;++g[--u]>i;)g[u]=0,u||(++l,g=[1].concat(g));for(c=g.length;!g[--c];);for(d=0,n="";d<=c;n+=f.charAt(g[d++]));n=N(n,l,f.charAt(0))}return n}}(),O=function(){function e(e,r,n){var t,i,o,s,f=0,u=e.length,l=r%a,c=r/a|0;for(e=e.slice();u--;)f=((i=l*(o=e[u]%a)+(t=c*o+(s=e[u]/a|0)*l)%a*a+f)/n|0)+(t/a|0)+c*s,e[u]=i%n;return f&&(e=[f].concat(e)),e}function r(e,r,n,t){var i,o;if(n!=t)o=n>t?1:-1;else for(i=o=0;i<n;i++)if(e[i]!=r[i]){o=e[i]>r[i]?1:-1;break}return o}function n(e,r,n,t){for(var i=0;n--;)e[n]-=i,i=e[n]<r[n]?1:0,e[n]=i*t+e[n]-r[n];for(;!e[0]&&e.length>1;e.splice(0,1));}return function(t,o,s,l,c){var a,h,p,w,d,m,v,N,O,y,b,E,A,S,R,_,B,D=t.s==o.s?1:-1,P=t.c,x=o.c;if(!(P&&P[0]&&x&&x[0]))return new z(t.s&&o.s&&(P?!x||P[0]!=x[0]:x)?P&&0==P[0]||!x?0*D:D/0:NaN);for(O=(N=new z(D)).c=[],D=s+(h=t.e-o.e)+1,c||(c=f,h=g(t.e/u)-g(o.e/u),D=D/u|0),p=0;x[p]==(P[p]||0);p++);if(x[p]>(P[p]||0)&&h--,D<0)O.push(1),w=!0;else{for(S=P.length,_=x.length,p=0,D+=2,(d=i(c/(x[0]+1)))>1&&(x=e(x,d,c),P=e(P,d,c),_=x.length,S=P.length),A=_,b=(y=P.slice(0,_)).length;b<_;y[b++]=0);B=x.slice(),B=[0].concat(B),R=x[0],x[1]>=c/2&&R++;do{if(d=0,(a=r(x,y,_,b))<0){if(E=y[0],_!=b&&(E=E*c+(y[1]||0)),(d=i(E/R))>1)for(d>=c&&(d=c-1),v=(m=e(x,d,c)).length,b=y.length;1==r(m,y,v,b);)d--,n(m,_<v?B:x,v,c),v=m.length,a=1;else 0==d&&(a=d=1),v=(m=x.slice()).length;if(v<b&&(m=[0].concat(m)),n(y,m,b,c),b=y.length,-1==a)for(;r(x,y,_,b)<1;)d++,n(y,_<b?B:x,b,c),b=y.length}else 0===a&&(d++,y=[0]);O[p++]=d,y[0]?y[b++]=P[A]||0:(y=[P[A]],b=1)}while((A++<S||null!=y[0])&&D--);w=null!=y[0],O[0]||O.splice(0,1)}if(c==f){for(p=1,D=O[0];D>=10;D/=10,p++);X(N,s+(N.e=p+h*u-1)+1,l,w)}else N.e=h,N.r=+w;return N}}(),S=/^(-?)0([xbo])(?=\\w[\\w.]*$)/i,R=/^([^.]+)\\.$/,_=/^\\.([^.]+)$/,B=/^-?(Infinity|NaN)$/,D=/^\\s*\\+(?=[\\w.])|^\\s+|\\s+$/g,b=function(e,r,n,t){var i,s=n?r:r.replace(D,"");if(B.test(s))e.s=isNaN(s)?null:s<0?-1:1;else{if(!n&&(s=s.replace(S,(function(e,r,n){return i="x"==(n=n.toLowerCase())?16:"b"==n?2:8,t&&t!=i?e:r})),t&&(i=t,s=s.replace(R,"$1").replace(_,"0.$1")),r!=s))return new z(s,i);if(z.DEBUG)throw Error(o+"Not a"+(t?" base "+t:"")+" number: "+r);e.s=null}e.c=e.e=null},P.absoluteValue=P.abs=function(){var e=new z(this);return e.s<0&&(e.s=1),e},P.comparedTo=function(e,r){return w(this,new z(e,r))},P.decimalPlaces=P.dp=function(e,r){var n,t,i,o=this;if(null!=e)return d(e,0,h),null==r?r=U:d(r,0,8),X(new z(o),e+o.e+1,r);if(!(n=o.c))return null;if(t=((i=n.length-1)-g(this.e/u))*u,i=n[i])for(;i%10==0;i/=10,t--);return t<0&&(t=0),t},P.dividedBy=P.div=function(e,r){return O(this,new z(e,r),L,U)},P.dividedToIntegerBy=P.idiv=function(e,r){return O(this,new z(e,r),0,1)},P.exponentiatedBy=P.pow=function(e,r){var n,s,f,l,c,a,h,g,p=this;if((e=new z(e)).c&&!e.isInteger())throw Error(o+"Exponent not an integer: "+Y(e));if(null!=r&&(r=new z(r)),c=e.e>14,!p.c||!p.c[0]||1==p.c[0]&&!p.e&&1==p.c.length||!e.c||!e.c[0])return g=new z(Math.pow(+Y(p),c?2-m(e):+Y(e))),r?g.mod(r):g;if(a=e.s<0,r){if(r.c?!r.c[0]:!r.s)return new z(NaN);(s=!a&&p.isInteger()&&r.isInteger())&&(p=p.mod(r))}else{if(e.e>9&&(p.e>0||p.e<-1||(0==p.e?p.c[0]>1||c&&p.c[1]>=24e7:p.c[0]<8e13||c&&p.c[0]<=9999975e7)))return l=p.s<0&&m(e)?-0:0,p.e>-1&&(l=1/l),new z(a?1/l:l);F&&(l=t(F/u+2))}for(c?(n=new z(.5),a&&(e.s=1),h=m(e)):h=(f=Math.abs(+Y(e)))%2,g=new z(x);;){if(h){if(!(g=g.times(p)).c)break;l?g.c.length>l&&(g.c.length=l):s&&(g=g.mod(r))}if(f){if(0===(f=i(f/2)))break;h=f%2}else if(X(e=e.times(n),e.e+1,1),e.e>14)h=m(e);else{if(0===(f=+Y(e)))break;h=f%2}p=p.times(p),l?p.c&&p.c.length>l&&(p.c.length=l):s&&(p=p.mod(r))}return s?g:(a&&(g=x.div(g)),r?g.mod(r):l?X(g,F,U,undefined):g)},P.integerValue=function(e){var r=new z(this);return null==e?e=U:d(e,0,8),X(r,r.e+1,e)},P.isEqualTo=P.eq=function(e,r){return 0===w(this,new z(e,r))},P.isFinite=function(){return!!this.c},P.isGreaterThan=P.gt=function(e,r){return w(this,new z(e,r))>0},P.isGreaterThanOrEqualTo=P.gte=function(e,r){return 1===(r=w(this,new z(e,r)))||0===r},P.isInteger=function(){return!!this.c&&g(this.e/u)>this.c.length-2},P.isLessThan=P.lt=function(e,r){return w(this,new z(e,r))<0},P.isLessThanOrEqualTo=P.lte=function(e,r){return-1===(r=w(this,new z(e,r)))||0===r},P.isNaN=function(){return!this.s},P.isNegative=function(){return this.s<0},P.isPositive=function(){return this.s>0},P.isZero=function(){return!!this.c&&0==this.c[0]},P.minus=function(e,r){var n,t,i,o,s=this,l=s.s;if(r=(e=new z(e,r)).s,!l||!r)return new z(NaN);if(l!=r)return e.s=-r,s.plus(e);var c=s.e/u,a=e.e/u,h=s.c,p=e.c;if(!c||!a){if(!h||!p)return h?(e.s=-r,e):new z(p?s:NaN);if(!h[0]||!p[0])return p[0]?(e.s=-r,e):new z(h[0]?s:3==U?-0:0)}if(c=g(c),a=g(a),h=h.slice(),l=c-a){for((o=l<0)?(l=-l,i=h):(a=c,i=p),i.reverse(),r=l;r--;i.push(0));i.reverse()}else for(t=(o=(l=h.length)<(r=p.length))?l:r,l=r=0;r<t;r++)if(h[r]!=p[r]){o=h[r]<p[r];break}if(o&&(i=h,h=p,p=i,e.s=-e.s),(r=(t=p.length)-(n=h.length))>0)for(;r--;h[n++]=0);for(r=f-1;t>l;){if(h[--t]<p[t]){for(n=t;n&&!h[--n];h[n]=r);--h[n],h[t]+=f}h[t]-=p[t]}for(;0==h[0];h.splice(0,1),--a);return h[0]?W(e,h,a):(e.s=3==U?-1:1,e.c=[e.e=0],e)},P.modulo=P.mod=function(e,r){var n,t,i=this;return e=new z(e,r),!i.c||!e.s||e.c&&!e.c[0]?new z(NaN):!e.c||i.c&&!i.c[0]?new z(i):(9==k?(t=e.s,e.s=1,n=O(i,e,0,3),e.s=t,n.s*=t):n=O(i,e,0,k),(e=i.minus(n.times(e))).c[0]||1!=k||(e.s=i.s),e)},P.multipliedBy=P.times=function(e,r){var n,t,i,o,s,l,c,h,p,w,d,m,v,N,O,y=this,b=y.c,E=(e=new z(e,r)).c;if(!(b&&E&&b[0]&&E[0]))return!y.s||!e.s||b&&!b[0]&&!E||E&&!E[0]&&!b?e.c=e.e=e.s=null:(e.s*=y.s,b&&E?(e.c=[0],e.e=0):e.c=e.e=null),e;for(t=g(y.e/u)+g(e.e/u),e.s*=y.s,(c=b.length)<(w=E.length)&&(v=b,b=E,E=v,i=c,c=w,w=i),i=c+w,v=[];i--;v.push(0));for(N=f,O=a,i=w;--i>=0;){for(n=0,d=E[i]%O,m=E[i]/O|0,o=i+(s=c);o>i;)n=((h=d*(h=b[--s]%O)+(l=m*h+(p=b[s]/O|0)*d)%O*O+v[o]+n)/N|0)+(l/O|0)+m*p,v[o--]=h%N;v[o]=n}return n?++t:v.splice(0,1),W(e,v,t)},P.negated=function(){var e=new z(this);return e.s=-e.s||null,e},P.plus=function(e,r){var n,t=this,i=t.s;if(r=(e=new z(e,r)).s,!i||!r)return new z(NaN);if(i!=r)return e.s=-r,t.minus(e);var o=t.e/u,s=e.e/u,l=t.c,c=e.c;if(!o||!s){if(!l||!c)return new z(i/0);if(!l[0]||!c[0])return c[0]?e:new z(l[0]?t:0*i)}if(o=g(o),s=g(s),l=l.slice(),i=o-s){for(i>0?(s=o,n=c):(i=-i,n=l),n.reverse();i--;n.push(0));n.reverse()}for((i=l.length)-(r=c.length)<0&&(n=c,c=l,l=n,r=i),i=0;r;)i=(l[--r]=l[r]+c[r]+i)/f|0,l[r]=f===l[r]?0:l[r]%f;return i&&(l=[i].concat(l),++s),W(e,l,s)},P.precision=P.sd=function(e,r){var n,t,i,o=this;if(null!=e&&e!==!!e)return d(e,1,h),null==r?r=U:d(r,0,8),X(new z(o),e,r);if(!(n=o.c))return null;if(t=(i=n.length-1)*u+1,i=n[i]){for(;i%10==0;i/=10,t--);for(i=n[0];i>=10;i/=10,t++);}return e&&o.e+1>t&&(t=o.e+1),t},P.shiftedBy=function(e){return d(e,-9007199254740991,l),this.times("1e"+e)},P.squareRoot=P.sqrt=function(){var e,r,n,t,i,o=this,s=o.c,f=o.s,u=o.e,l=L+4,c=new z("0.5");if(1!==f||!s||!s[0])return new z(!f||f<0&&(!s||s[0])?NaN:s?o:1/0);if(0==(f=Math.sqrt(+Y(o)))||f==1/0?(((r=p(s)).length+u)%2==0&&(r+="0"),f=Math.sqrt(+r),u=g((u+1)/2)-(u<0||u%2),n=new z(r=f==1/0?"5e"+u:(r=f.toExponential()).slice(0,r.indexOf("e")+1)+u)):n=new z(f+""),n.c[0])for((f=(u=n.e)+l)<3&&(f=0);;)if(i=n,n=c.times(i.plus(O(o,i,l,1))),p(i.c).slice(0,f)===(r=p(n.c)).slice(0,f)){if(n.e<u&&--f,"9999"!=(r=r.slice(f-3,f+1))&&(t||"4999"!=r)){+r&&(+r.slice(1)||"5"!=r.charAt(0))||(X(n,n.e+L+2,1),e=!n.times(n).eq(o));break}if(!t&&(X(i,i.e+L+2,0),i.times(i).eq(o))){n=i;break}l+=4,f+=4,t=1}return X(n,n.e+L+1,U,e)},P.toExponential=function(e,r){return null!=e&&(d(e,0,h),e++),H(this,e,r,1)},P.toFixed=function(e,r){return null!=e&&(d(e,0,h),e=e+this.e+1),H(this,e,r)},P.toFormat=function(e,r,n){var t,i=this;if(null==n)null!=e&&r&&"object"==typeof r?(n=r,r=null):e&&"object"==typeof e?(n=e,e=r=null):n=q;else if("object"!=typeof n)throw Error(o+"Argument not an object: "+n);if(t=i.toFixed(e,r),i.c){var s,f=t.split("."),u=+n.groupSize,l=+n.secondaryGroupSize,c=n.groupSeparator||"",a=f[0],h=f[1],g=i.s<0,p=g?a.slice(1):a,w=p.length;if(l&&(s=u,u=l,l=s,w-=s),u>0&&w>0){for(s=w%u||u,a=p.substr(0,s);s<w;s+=u)a+=c+p.substr(s,u);l>0&&(a+=c+p.slice(s)),g&&(a="-"+a)}t=h?a+(n.decimalSeparator||"")+((l=+n.fractionGroupSize)?h.replace(new RegExp("\\\\d{"+l+"}\\\\B","g"),"$&"+(n.fractionGroupSeparator||"")):h):a}return(n.prefix||"")+t+(n.suffix||"")},P.toFraction=function(e){var r,n,t,i,s,f,l,a,h,g,w,d,m=this,v=m.c;if(null!=e&&(!(l=new z(e)).isInteger()&&(l.c||1!==l.s)||l.lt(x)))throw Error(o+"Argument "+(l.isInteger()?"out of range: ":"not an integer: ")+Y(l));if(!v)return new z(m);for(r=new z(x),h=n=new z(x),t=a=new z(x),d=p(v),s=r.e=d.length-m.e-1,r.c[0]=c[(f=s%u)<0?u+f:f],e=!e||l.comparedTo(r)>0?s>0?r:h:l,f=M,M=1/0,l=new z(d),a.c[0]=0;g=O(l,r,0,1),1!=(i=n.plus(g.times(t))).comparedTo(e);)n=t,t=i,h=a.plus(g.times(i=h)),a=i,r=l.minus(g.times(i=r)),l=i;return i=O(e.minus(n),t,0,1),a=a.plus(i.times(h)),n=n.plus(i.times(t)),a.s=h.s=m.s,w=O(h,t,s*=2,U).minus(m).abs().comparedTo(O(a,n,s,U).minus(m).abs())<1?[h,t]:[a,n],M=f,w},P.toNumber=function(){return+Y(this)},P.toPrecision=function(e,r){return null!=e&&d(e,1,h),H(this,e,r,2)},P.toString=function(e){var r,n=this,t=n.s,i=n.e;return null===i?t?(r="Infinity",t<0&&(r="-"+r)):r="NaN":(null==e?r=i<=I||i>=T?v(p(n.c),i):N(p(n.c),i,"0"):10===e&&$?r=N(p((n=X(new z(n),L+i+1,U)).c),n.e,"0"):(d(e,2,j.length,"Base"),r=y(N(p(n.c),i,"0"),10,e,t,!0)),t<0&&n.c[0]&&(r="-"+r)),r},P.valueOf=P.toJSON=function(){return Y(this)},P._isBigNumber=!0,null!=r&&z.set(r),z}(),r.default=r.BigNumber=r,"function"==typeof define&&define.amd?define((function(){return r})):"undefined"!=typeof module&&module.exports?module.exports=r:(e||(e="undefined"!=typeof self&&self?self:window),e.BigNumber=r)}(this);';

            var computeWorker = bignumjs + jshash + '\n                function sequFun(data) {\n                    var puzzle = data.args.puzzle; // \u9898\u76EE\n                    var str = data.args.target;\n                    var target = parseInt(str,16); // \u76EE\u6807\n                    var n = 0;\n                    var result = \'\';\n                    var startTime = new Date().getTime();\n                    var minResult = \'\';\n                    while(result === \'\' || parseInt(result,16) > target) {\n                        ++n;\n                        result = sha256(puzzle + \'\' + n);\n\n                        if (minResult === \'\' || (parseInt(result, 16) < parseInt(minResult, 16))) {\n                            minN = n;\n                            minResult = result;\n                        }\n                        var nowTime = new Date().getTime();\n                        if ( nowTime - startTime > data.maxTime) {\n                            n = minN;\n                            result = minResult;\n                            break;\n                        }\n                    }\n\n                    var time = new Date().getTime() - startTime; // \u8017\u65F6\n\n                    // \u8BA1\u7B97\u5B8C\u4E86\u5C31 \u53D1\u9001\u6D88\u606F\uFF0C\u6D88\u606F\u91CC\u9762\u628A\u9898\u76EE\u4E5F\u7ED9\u5E26\u4E0A\n                    postMessage({\n                        maxTime: data.maxTime,\n                        hashFunc: data.hashFunc,\n                        sid: data.sid,\n                        puzzle: data.args.puzzle,\n                        spendTime: time,\n                        runTimes: n,\n                        args: JSON.stringify({\n                            pow: result,\n                            n: n\n                        })\n                    })\n                }\n                function reduceFun(data) {\n                    var puzzle = data.args.puzzle; // \u9898\u76EE\n                    var str = data.args.target;\n                    var target = parseInt(str,16); // \u76EE\u6807\n                    var n = 0;\n                    var result = \'\';\n                    var startTime = new Date().getTime();\n                    var minResult = \'\';\n                    var n1 = \'\'; // \u4E0A\u4E00\u6B21\u8BA1\u7B97\u7ED3\u679C\n                    var n2 = \'\'; // \u4E0A\u4E0A\u6B21\u8BA1\u7B97\u7ED3\u679C\n                    var tmpResult = \'\';\n                    var minN1 = \'\';\n                    var minN2 = \'\';\n                    while(result === \'\' || parseInt(result,16) > target) {\n                        ++n;\n                        tmpResult = sha256(puzzle+\'\'+ result);\n                        n2 = n1;\n                        n1 = result;\n                        result = tmpResult;\n\n                        if(minResult === \'\' || (parseInt(result, 16) < parseInt(minResult, 16))) {\n                            minN1 = n1;\n                            minN2 = n2;\n                            minResult = result;\n                        }\n                        var nowTime = new Date().getTime();\n                        if ( nowTime - startTime > data.maxTime) {\n                            n1 = minN1;\n                            n2 = minN2;\n                            result = minResult;\n                            break;\n                        }\n                    }\n\n                    var time = new Date().getTime() - startTime; // \u8017\u65F6\n\n                    // \u8BA1\u7B97\u5B8C\u4E86\uFF0C\u8FD4\u56DE\u6D88\u606F\n                    postMessage({\n                        maxTime: data.maxTime,\n                        hashFunc: data.hashFunc,\n                        sid: data.sid,\n                        puzzle: data.args.puzzle,\n                        spendTime: time,\n                        runTimes: n,\n                        args: JSON.stringify({\n                            pow: result,\n                            n1: n1,\n                            n2: n2\n                        })\n                    });\n                }\n                function powSign(key, seed) {\n                    var remainder, bytes, h1, h1b, c1, c1b, c2, c2b, k1, i;\n                    remainder = key.length & 3;\n                    bytes = key.length - remainder;\n                    h1 = seed;\n                    c1 = 0xcc9e2d51;\n                    c2 = 0x1b873593;\n                    i = 0;\n                    while (i < bytes) {\n                        k1 =\n                        ((key.charCodeAt(i) & 0xff)) |\n                        ((key.charCodeAt(++i) & 0xff) << 8) |\n                        ((key.charCodeAt(++i) & 0xff) << 16) |\n                        ((key.charCodeAt(++i) & 0xff) << 24);\n                        ++i;\n                        k1 = ((((k1 & 0xffff) * c1) + ((((k1 >>> 16) * c1) & 0xffff) << 16))) & 0xffffffff;\n                        k1 = (k1 << 15) | (k1 >>> 17);\n                        k1 = ((((k1 & 0xffff) * c2) + ((((k1 >>> 16) * c2) & 0xffff) << 16))) & 0xffffffff;\n                        h1 ^= k1;\n                        h1 = (h1 << 13) | (h1 >>> 19);\n                        h1b = ((((h1 & 0xffff) * 5) + ((((h1 >>> 16) * 5) & 0xffff) << 16))) & 0xffffffff;\n                        h1 = (((h1b & 0xffff) + 0x6b64) + ((((h1b >>> 16) + 0xe654) & 0xffff) << 16));\n                    }\n                    k1 = 0;\n                    switch (remainder) {\n                        case 3: k1 ^= (key.charCodeAt(i + 2) & 0xff) << 16;\n                        case 2: k1 ^= (key.charCodeAt(i + 1) & 0xff) << 8;\n                        case 1: k1 ^= (key.charCodeAt(i) & 0xff);\n                        k1 = (((k1 & 0xffff) * c1) + ((((k1 >>> 16) * c1) & 0xffff) << 16)) & 0xffffffff;\n                        k1 = (k1 << 15) | (k1 >>> 17);\n                        k1 = (((k1 & 0xffff) * c2) + ((((k1 >>> 16) * c2) & 0xffff) << 16)) & 0xffffffff;\n                        h1 ^= k1;\n                    }\n                    h1 ^= key.length;\n                    h1 ^= h1 >>> 16;\n                    h1 = (((h1 & 0xffff) * 0x85ebca6b) + ((((h1 >>> 16) * 0x85ebca6b) & 0xffff) << 16)) & 0xffffffff;\n                    h1 ^= h1 >>> 13;\n                    h1 = ((((h1 & 0xffff) * 0xc2b2ae35) + ((((h1 >>> 16) * 0xc2b2ae35) & 0xffff) << 16))) & 0xffffffff;\n                    h1 ^= h1 >>> 16;\n                    return h1 >>> 0;\n                }\n                function vdfFun(data) {\n                        var puzzle = data.args.puzzle;\n                        var mod = data.args.mod;\n                        var x = data.args.x;\n                        var t = data.args.t;\n                        var startTime = new Date().getTime();\n                        var spendTime = 0;\n                        var bigx = new BigNumber(x, 16);\n                        var bigmod = new BigNumber(mod, 16);\n                        var count = 0;\n                        for(var i = 0; i < t || (new Date().getTime() - startTime < data.minTime); i++) {\n                            bigx = bigx.multipliedBy(bigx).mod(bigmod);\n                            count++;\n                            spendTime = i;\n                            var nowTime = new Date().getTime();\n                            if ( nowTime - startTime > data.maxTime) {\n                                break;\n                            }\n                        }\n                        var time = new Date().getTime() - startTime;\n                        var signObj = {\n                            runTimes: count,\n                            spendTime: time,\n                            t: count,\n                            x: bigx.toString(16)\n                        }\n                        var sortedParams = ["runTimes","spendTime","t","x"]\n                        var encodedParams = []\n                        for (var i = 0; i < sortedParams.length; i++) {\n                            var key = sortedParams[i]\n                            var value = signObj[key]\n                            encodedParams.push(encodeURIComponent(key) + \'=\' + encodeURIComponent(value))\n                        }\n                        encodedParams = encodedParams.join(\'&\')\n                        var sign = powSign(encodedParams,count)\n                        postMessage({\n                            maxTime: data.maxTime,\n                            puzzle: puzzle,\n                            spendTime: time,\n                            runTimes: count,\n                            sid: data.sid,\n                            args: JSON.stringify({\n                                x: bigx.toString(16),\n                                t: count,\n                                sign:sign\n                            })\n                        });\n                    }\n                addEventListener(\'message\', function(event) {\n                    if (event.data.hashFunc === \'RECUR_HASHCASH\') {\n                        self.reduceFun(event.data);\n                    } else if(event.data.hashFunc === \'VDF_FUNCTION\') {\n                        self.vdfFun(event.data);\n                    } else {\n                        self.sequFun(event.data);\n                    }\n                }, false);\n            ';
            var blob = new Blob([computeWorker]);
            var myworker = new Worker(window.URL.createObjectURL(blob));
            myworker.postMessage((0, _extends3.default)({}, data));

            myworker.onmessage = function (event) {
                var data = event.data;

                _this.onPowerDone(data, 'webworker');
                myworker.terminate();
            };
        },
        doWebWorkerPower: function doWebWorkerPower(data) {
            if (!(data && data.args.puzzle)) {
                return;
            }
            if (window.Worker) {
                this.webWorkerCompute(data);
            }
        },
        sequFun: function sequFun(data) {
            var puzzle = data.args.puzzle;
            var str = data.args.target;
            var target = parseInt(str, 16);
            var n = 0;
            var minN = 0;
            var result = '';
            var startTime = new Date().getTime();
            var minResult = '';
            while (result === '' || parseInt(result, 16) > target) {
                ++n;
                result = (0, _jsSha.sha256)(puzzle + '' + n);

                if (minResult === '' || parseInt(result, 16) < parseInt(minResult, 16)) {
                    minN = n;
                    minResult = result;
                }
                var nowTime = new Date().getTime();
                if (nowTime - startTime > data.maxTime) {
                    n = minN;
                    result = minResult;
                    break;
                }
            }

            var time = new Date().getTime() - startTime;
            return {
                maxTime: data.maxTime,
                hashFunc: data.hashFunc,
                sid: data.sid,
                puzzle: data.args.puzzle,
                spendTime: time,
                runTimes: n,
                args: (0, _stringify2.default)({
                    pow: result,
                    n: n
                })
            };
        },
        reduceFun: function reduceFun(data) {
            var puzzle = data.args.puzzle;
            var str = data.args.target;
            var target = parseInt(str, 16);
            var n = 0;
            var result = '';
            var startTime = new Date().getTime();
            var minResult = '';
            var n1 = '';
            var n2 = '';
            var tmpResult = '';

            var minN1 = '';
            var minN2 = '';
            while (result === '' || parseInt(result, 16) > target) {
                ++n;
                tmpResult = (0, _jsSha.sha256)(puzzle + '' + result);
                n2 = n1;
                n1 = result;
                result = tmpResult;

                if (minResult === '' || parseInt(result, 16) < parseInt(minResult, 16)) {
                    minN1 = n1;
                    minN2 = n2;
                    minResult = result;
                }
                var nowTime = new Date().getTime();
                if (nowTime - startTime > data.maxTime) {
                    n1 = minN1;
                    n2 = minN2;
                    result = minResult;
                    break;
                }
            }

            var time = new Date().getTime() - startTime;
            return {
                maxTime: data.maxTime,
                hashFunc: data.hashFunc,
                sid: data.sid,
                puzzle: data.args.puzzle,
                spendTime: time,
                runTimes: n,
                args: (0, _stringify2.default)({
                    pow: result,
                    n1: n1,
                    n2: n2
                })
            };
        },
        powSign: function powSign(key, seed) {
            var remainder, bytes, h1, h1b, c1, c1b, c2, c2b, k1, i;
            remainder = key.length & 3;
            bytes = key.length - remainder;
            h1 = seed;
            c1 = 0xcc9e2d51;
            c2 = 0x1b873593;
            i = 0;
            while (i < bytes) {
                k1 = key.charCodeAt(i) & 0xff | (key.charCodeAt(++i) & 0xff) << 8 | (key.charCodeAt(++i) & 0xff) << 16 | (key.charCodeAt(++i) & 0xff) << 24;
                ++i;
                k1 = (k1 & 0xffff) * c1 + (((k1 >>> 16) * c1 & 0xffff) << 16) & 0xffffffff;
                k1 = k1 << 15 | k1 >>> 17;
                k1 = (k1 & 0xffff) * c2 + (((k1 >>> 16) * c2 & 0xffff) << 16) & 0xffffffff;
                h1 ^= k1;
                h1 = h1 << 13 | h1 >>> 19;
                h1b = (h1 & 0xffff) * 5 + (((h1 >>> 16) * 5 & 0xffff) << 16) & 0xffffffff;
                h1 = (h1b & 0xffff) + 0x6b64 + (((h1b >>> 16) + 0xe654 & 0xffff) << 16);
            }
            k1 = 0;
            switch (remainder) {
                case 3:
                    k1 ^= (key.charCodeAt(i + 2) & 0xff) << 16;
                    break;
                case 2:
                    k1 ^= (key.charCodeAt(i + 1) & 0xff) << 8;
                    break;
                case 1:
                    k1 ^= key.charCodeAt(i) & 0xff;
                    k1 = (k1 & 0xffff) * c1 + (((k1 >>> 16) * c1 & 0xffff) << 16) & 0xffffffff;
                    k1 = k1 << 15 | k1 >>> 17;
                    k1 = (k1 & 0xffff) * c2 + (((k1 >>> 16) * c2 & 0xffff) << 16) & 0xffffffff;
                    h1 ^= k1;
                    break;
            }
            h1 ^= key.length;
            h1 ^= h1 >>> 16;
            h1 = (h1 & 0xffff) * 0x85ebca6b + (((h1 >>> 16) * 0x85ebca6b & 0xffff) << 16) & 0xffffffff;
            h1 ^= h1 >>> 13;
            h1 = (h1 & 0xffff) * 0xc2b2ae35 + (((h1 >>> 16) * 0xc2b2ae35 & 0xffff) << 16) & 0xffffffff;
            h1 ^= h1 >>> 16;
            return h1 >>> 0;
        },
        vdfFun: function vdfFun(data) {
            var puzzle = data.args.puzzle;
            var mod = data.args.mod;
            var x = data.args.x;
            var t = data.args.t;
            var startTime = new Date().getTime();

            var bigx = new _bignumber2.default(x, 16);
            var bigmod = new _bignumber2.default(mod, 16);
            var count = 0;
            for (var i = 0; i < t || new Date().getTime() - startTime < data.minTime; i++) {
                bigx = bigx.multipliedBy(bigx).mod(bigmod);
                count++;

                var nowTime = new Date().getTime();
                if (nowTime - startTime > data.maxTime) {
                    break;
                }
            }
            var time = new Date().getTime() - startTime;
            var signObj = {
                runTimes: count,
                spendTime: time,
                t: count,
                x: bigx.toString(16)
            };
            var sortedParams = ['runTimes', 'spendTime', 't', 'x'];
            var encodedParams = [];
            for (var _i = 0; _i < sortedParams.length; _i++) {
                var key = sortedParams[_i];
                var value = signObj[key];
                encodedParams.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
            }
            encodedParams = encodedParams.join('&');
            var sign = this.powSign(encodedParams, count);
            return {
                maxTime: data.maxTime,
                puzzle: puzzle,
                spendTime: time,
                runTimes: count,
                sid: data.sid,
                args: (0, _stringify2.default)({
                    x: bigx.toString(16),
                    t: count,
                    sign: sign
                })
            };
        },
        doSyncCompute: function doSyncCompute(data) {
            if (!(data && data.args.puzzle)) {
                return;
            }
            var result = '';
            if (data.hashFunc === 'RECUR_HASHCASH') {
                result = this.reduceFun(data);
            } else if (data.hashFunc === 'VDF_FUNCTION') {
                result = this.vdfFun(data);
            } else {
                result = this.sequFun(data);
            }
            this.onPowerDone(result, 'sync');
        },
        doPower: function doPower(data) {
            if (!data) {
                return;
            }

            if (window.Worker) {
                this.webWorkerCompute(data);
            } else {
                this.doSyncCompute(data);
            }
        },
        onPowerDone: function onPowerDone(data, type) {
            var filterData = (0, _extends3.default)({}, data);
            delete filterData.maxTime;
            delete filterData.hashFunc;
            this.$emit('sucess', filterData);

            var timeout = data.spendTime >= data.maxTime ? 1 : 0;
            _util2.default.doNssLog({
                name: 'webzj_power_h5maildlpage',
                sp: type === 'webworker' ? 1 : 0,
                timeout: timeout });

            _util2.default.doNgLog({
                mspm: 'webzj_power_h5maildlpage',
                sp: type === 'webworker' ? 1 : 0,
                st: data.spendTime,
                rt: data.runTimes,
                timeout: timeout,
                ua: window.navigator.userAgent
            });
        }
    }
};

/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: "preAccount",
  props: {
    account: Array
  },
  data: function data() {
    return {
      showModal: true
    };
  },

  methods: {
    closeModal: function closeModal($event) {
      this.showModal = false;
      this.$emit('closeModal', $event);
    },
    chooseAccount: function chooseAccount(item) {
      this.showModal = false;
      this.$emit('choose', item);
    }
  }
};

/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  common: [{
    nm: 'CN',
    num: '86',
    cnm: '中国大陆'
  }, {
    nm: 'TW',
    num: '886',
    cnm: '中国台湾'
  }, {
    nm: 'HK',
    num: '852',
    cnm: '中国香港'
  }, {
    nm: 'MO',
    num: '853',
    cnm: '中国澳门'
  }, {
    nm: 'MY',
    num: '60',
    cnm: '马来西亚'
  }, {
    nm: 'SG',
    num: '65',
    cnm: '新加坡'
  }, {
    nm: 'JP',
    num: '81',
    cnm: '日本'
  }, {
    nm: 'KR',
    num: '82',
    cnm: '韩国'
  }, {
    nm: 'US',
    num: '1',
    cnm: '美国'
  }, {
    nm: 'CA',
    num: '1',
    cnm: '加拿大'
  }, {
    nm: 'AU',
    num: '61',
    cnm: '澳大利亚'
  }, {
    nm: 'NZ',
    num: '64',
    cnm: '新西兰'
  }],
  other: [{
    nm: 'AL',
    num: '355',
    cnm: '阿尔巴尼亚'
  }, {
    nm: 'DZ',
    num: '213',
    cnm: '阿尔及利亚'
  }, {
    nm: 'AF',
    num: '93',
    cnm: '阿富汗'
  }, {
    nm: 'AR',
    num: '54',
    cnm: '阿根廷'
  }, {
    nm: 'AE',
    num: '971',
    cnm: '阿拉伯联合大公国'
  }, {
    nm: 'AW',
    num: '297',
    cnm: '阿鲁巴'
  }, {
    nm: 'OM',
    num: '968',
    cnm: '阿曼'
  }, {
    nm: 'AZ',
    num: '994',
    cnm: '阿塞拜疆'
  }, {
    nm: 'EG',
    num: '20',
    cnm: '埃及'
  }, {
    nm: 'ET',
    num: '251',
    cnm: '埃塞俄比亚'
  }, {
    nm: 'IE',
    num: '353',
    cnm: '爱尔兰'
  }, {
    nm: 'EE',
    num: '372',
    cnm: '爱沙尼亚'
  }, {
    nm: 'AD',
    num: '376',
    cnm: '安道尔'
  }, {
    nm: 'AO',
    num: '244',
    cnm: '安哥拉'
  }, {
    nm: 'AI',
    num: '1264',
    cnm: '安圭拉'
  }, {
    nm: 'AG',
    num: '1268',
    cnm: '安提瓜和巴布达'
  }, {
    nm: 'AT',
    num: '43',
    cnm: '奥地利'
  }, {
    nm: 'BB',
    num: '1246',
    cnm: '巴巴多斯'
  }, {
    nm: 'PG',
    num: '675',
    cnm: '巴布亚新几内亚'
  }, {
    nm: 'BS',
    num: '1242',
    cnm: '巴哈马'
  }, {
    nm: 'PK',
    num: '92',
    cnm: '巴基斯坦'
  }, {
    nm: 'PY',
    num: '595',
    cnm: '巴拉圭'
  }, {
    nm: 'PS',
    num: '970',
    cnm: '巴勒斯坦领土'
  }, {
    nm: 'BH',
    num: '973',
    cnm: '巴林'
  }, {
    nm: 'PA',
    num: '507',
    cnm: '巴拿马'
  }, {
    nm: 'BR',
    num: '55',
    cnm: '巴西'
  }, {
    nm: 'BY',
    num: '375',
    cnm: '白俄罗斯'
  }, {
    nm: 'BM',
    num: '1441',
    cnm: '百慕大'
  }, {
    nm: 'BG',
    num: '359',
    cnm: '保加利亚'
  }, {
    nm: 'BJ',
    num: '229',
    cnm: '贝宁'
  }, {
    nm: 'BE',
    num: '32',
    cnm: '比利时'
  }, {
    nm: 'IS',
    num: '354',
    cnm: '冰岛'
  }, {
    nm: 'PR',
    num: '1787',
    cnm: '波多黎各'
  }, {
    nm: 'PL',
    num: '48',
    cnm: '波兰'
  }, {
    nm: 'BA',
    num: '387',
    cnm: '波斯尼亚和黑塞哥维那'
  }, {
    nm: 'BO',
    num: '591',
    cnm: '玻利维亚'
  }, {
    nm: 'BZ',
    num: '501',
    cnm: '伯利兹'
  }, {
    nm: 'BW',
    num: '267',
    cnm: '博茨瓦纳'
  }, {
    nm: 'BT',
    num: '975',
    cnm: '不丹'
  }, {
    nm: 'BF',
    num: '226',
    cnm: '布基纳法索'
  }, {
    nm: 'BI',
    num: '257',
    cnm: '布隆迪'
  }, {
    nm: 'KP',
    num: '850',
    cnm: '朝鲜'
  }, {
    nm: 'GQ',
    num: '240',
    cnm: '赤道几内亚'
  }, {
    nm: 'DK',
    num: '45',
    cnm: '丹麦'
  }, {
    nm: 'DE',
    num: '49',
    cnm: '德国'
  }, {
    nm: 'TL',
    num: '670',
    cnm: '东帝汶'
  }, {
    nm: 'TG',
    num: '228',
    cnm: '多哥'
  }, {
    nm: 'DO',
    num: '1809',
    cnm: '多米尼加共和国'
  }, {
    nm: 'DM',
    num: '1767',
    cnm: '多米尼克'
  }, {
    nm: 'RU',
    num: '7',
    cnm: '俄罗斯'
  }, {
    nm: 'EC',
    num: '593',
    cnm: '厄瓜多尔'
  }, {
    nm: 'ER',
    num: '291',
    cnm: '厄立特里亚'
  }, {
    nm: 'FR',
    num: '33',
    cnm: '法国'
  }, {
    nm: 'FO',
    num: '298',
    cnm: '法罗群岛'
  }, {
    nm: 'PF',
    num: '689',
    cnm: '法属波利尼西亚'
  }, {
    nm: 'GF',
    num: '594',
    cnm: '法属圭亚那'
  }, {
    nm: 'PH',
    num: '63',
    cnm: '菲律宾'
  }, {
    nm: 'FJ',
    num: '679',
    cnm: '斐济'
  }, {
    nm: 'FI',
    num: '358',
    cnm: '芬兰'
  }, {
    nm: 'CV',
    num: '238',
    cnm: '佛得角'
  }, {
    nm: 'GM',
    num: '220',
    cnm: '冈比亚'
  }, {
    nm: 'CG',
    num: '242',
    cnm: '刚果共和国'
  }, {
    nm: 'CD',
    num: '243',
    cnm: '刚果民主共和国'
  }, {
    nm: 'CO',
    num: '57',
    cnm: '哥伦比亚'
  }, {
    nm: 'CR',
    num: '506',
    cnm: '哥斯达黎加'
  }, {
    nm: 'GD',
    num: '1473',
    cnm: '格林纳达'
  }, {
    nm: 'GL',
    num: '299',
    cnm: '格陵兰'
  }, {
    nm: 'GE',
    num: '995',
    cnm: '格鲁吉亚'
  }, {
    nm: 'CU',
    num: '53',
    cnm: '古巴'
  }, {
    nm: 'GP',
    num: '590',
    cnm: '瓜德罗普岛'
  }, {
    nm: 'GU',
    num: '1671',
    cnm: '关岛'
  }, {
    nm: 'GY',
    num: '592',
    cnm: '圭亚那'
  }, {
    nm: 'KZ',
    num: '7',
    cnm: '哈萨克斯坦'
  }, {
    nm: 'HT',
    num: '509',
    cnm: '海地'
  }, {
    nm: 'NL',
    num: '31',
    cnm: '荷兰'
  }, {
    nm: 'AN',
    num: '599',
    cnm: '荷属安的列斯群岛'
  }, {
    nm: 'ME',
    num: '382',
    cnm: '黑山'
  }, {
    nm: 'HN',
    num: '504',
    cnm: '洪都拉斯'
  }, {
    nm: 'DJ',
    num: '253',
    cnm: '吉布提'
  }, {
    nm: 'KG',
    num: '996',
    cnm: '吉尔吉斯斯坦'
  }, {
    nm: 'GN',
    num: '224',
    cnm: '几内亚'
  }, {
    nm: 'GW',
    num: '245',
    cnm: '几内亚比绍'
  }, {
    nm: 'GH',
    num: '233',
    cnm: '加纳'
  }, {
    nm: 'GA',
    num: '241',
    cnm: '加蓬'
  }, {
    nm: 'KH',
    num: '855',
    cnm: '柬埔寨'
  }, {
    nm: 'CZ',
    num: '420',
    cnm: '捷克'
  }, {
    nm: 'ZW',
    num: '263',
    cnm: '津巴布韦'
  }, {
    nm: 'CM',
    num: '237',
    cnm: '喀麦隆'
  }, {
    nm: 'QA',
    num: '974',
    cnm: '卡塔尔'
  }, {
    nm: 'KY',
    num: '1345',
    cnm: '开曼群岛'
  }, {
    nm: 'KM',
    num: '269',
    cnm: '科摩罗'
  }, {
    nm: 'CI',
    num: '225',
    cnm: '科特迪瓦'
  }, {
    nm: 'KW',
    num: '965',
    cnm: '科威特'
  }, {
    nm: 'HR',
    num: '385',
    cnm: '克罗地亚'
  }, {
    nm: 'KE',
    num: '254',
    cnm: '肯尼亚'
  }, {
    nm: 'CK',
    num: '682',
    cnm: '库克群岛'
  }, {
    nm: 'LV',
    num: '371',
    cnm: '拉脱维亚'
  }, {
    nm: 'LS',
    num: '266',
    cnm: '莱索托'
  }, {
    nm: 'LA',
    num: '856',
    cnm: '老挝'
  }, {
    nm: 'LB',
    num: '961',
    cnm: '黎巴嫩'
  }, {
    nm: 'LT',
    num: '370',
    cnm: '立陶宛'
  }, {
    nm: 'LR',
    num: '231',
    cnm: '利比里亚'
  }, {
    nm: 'LY',
    num: '218',
    cnm: '利比亚'
  }, {
    nm: 'LI',
    num: '423',
    cnm: '列支敦士登'
  }, {
    nm: 'RE',
    num: '262',
    cnm: '留尼旺岛'
  }, {
    nm: 'LU',
    num: '352',
    cnm: '卢森堡'
  }, {
    nm: 'RW',
    num: '250',
    cnm: '卢旺达'
  }, {
    nm: 'RO',
    num: '40',
    cnm: '罗马尼亚'
  }, {
    nm: 'Myanmar',
    num: '95',
    cnm: '缅甸'
  }, {
    nm: 'MG',
    num: '261',
    cnm: '马达加斯加'
  }, {
    nm: 'MV',
    num: '960',
    cnm: '马尔代夫'
  }, {
    nm: 'MT',
    num: '356',
    cnm: '马耳他'
  }, {
    nm: 'MW',
    num: '265',
    cnm: '马拉维'
  }, {
    nm: 'ML',
    num: '223',
    cnm: '马里'
  }, {
    nm: 'MK',
    num: '389',
    cnm: '马其顿'
  }, {
    nm: 'MQ',
    num: '596',
    cnm: '马提尼克'
  }, {
    nm: 'MU',
    num: '230',
    cnm: '毛里求斯'
  }, {
    nm: 'MR',
    num: '222',
    cnm: '毛里塔尼亚'
  }, {
    nm: 'MN',
    num: '976',
    cnm: '蒙古'
  }, {
    nm: 'MS',
    num: '1664',
    cnm: '蒙特塞拉特'
  }, {
    nm: 'BD',
    num: '880',
    cnm: '孟加拉国'
  }, {
    nm: 'PE',
    num: '51',
    cnm: '秘鲁'
  }, {
    nm: 'MD',
    num: '373',
    cnm: '摩尔多瓦'
  }, {
    nm: 'MA',
    num: '212',
    cnm: '摩洛哥'
  }, {
    nm: 'MC',
    num: '377',
    cnm: '摩纳哥'
  }, {
    nm: 'MZ',
    num: '258',
    cnm: '莫桑比克'
  }, {
    nm: 'MX',
    num: '52',
    cnm: '墨西哥'
  }, {
    nm: 'NA',
    num: '264',
    cnm: '纳米比亚'
  }, {
    nm: 'ZA',
    num: '27',
    cnm: '南非'
  }, {
    nm: 'SS',
    num: '211',
    cnm: '南苏丹'
  }, {
    nm: 'NP',
    num: '977',
    cnm: '尼泊尔'
  }, {
    nm: 'NI',
    num: '505',
    cnm: '尼加拉瓜'
  }, {
    nm: 'NE',
    num: '227',
    cnm: '尼日尔'
  }, {
    nm: 'NG',
    num: '234',
    cnm: '尼日利亚'
  }, {
    nm: 'NO',
    num: '47',
    cnm: '挪威'
  }, {
    nm: 'PT',
    num: '351',
    cnm: '葡萄牙'
  }, {
    nm: 'SE',
    num: '46',
    cnm: '瑞典'
  }, {
    nm: 'CH',
    num: '41',
    cnm: '瑞士'
  }, {
    nm: 'SV',
    num: '503',
    cnm: '萨尔瓦多'
  }, {
    nm: 'WS',
    num: '685',
    cnm: '萨摩亚'
  }, {
    nm: 'RS',
    num: '381',
    cnm: '塞尔维亚'
  }, {
    nm: 'SL',
    num: '232',
    cnm: '塞拉利昂'
  }, {
    nm: 'SN',
    num: '221',
    cnm: '塞内加尔'
  }, {
    nm: 'CY',
    num: '357',
    cnm: '塞浦路斯'
  }, {
    nm: 'SC',
    num: '248',
    cnm: '塞舌尔'
  }, {
    nm: 'SA',
    num: '966',
    cnm: '沙特阿拉伯'
  }, {
    nm: 'ST',
    num: '239',
    cnm: '圣多美和普林西比'
  }, {
    nm: 'KN',
    num: '1869',
    cnm: '圣基茨和尼维斯'
  }, {
    nm: 'LC',
    num: '1758',
    cnm: '圣卢西亚'
  }, {
    nm: 'SM',
    num: '378',
    cnm: '圣马力诺'
  }, {
    nm: 'PM',
    num: '508',
    cnm: '圣皮埃尔和密克隆群岛'
  }, {
    nm: 'VC',
    num: '1784',
    cnm: '圣文森特和格林纳丁斯'
  }, {
    nm: 'LK',
    num: '94',
    cnm: '斯里兰卡'
  }, {
    nm: 'SK',
    num: '421',
    cnm: '斯洛伐克'
  }, {
    nm: 'SI',
    num: '386',
    cnm: '斯洛文尼亚'
  }, {
    nm: 'SZ',
    num: '268',
    cnm: '斯威士兰'
  }, {
    nm: 'SD',
    num: '249',
    cnm: '苏丹'
  }, {
    nm: 'SR',
    num: '597',
    cnm: '苏里南'
  }, {
    nm: 'SO',
    num: '252',
    cnm: '索马里'
  }, {
    nm: 'TJ',
    num: '992',
    cnm: '塔吉克斯坦'
  }, {
    nm: 'TH',
    num: '66',
    cnm: '泰国'
  }, {
    nm: 'TZ',
    num: '255',
    cnm: '坦桑尼亚'
  }, {
    nm: 'TO',
    num: '676',
    cnm: '汤加'
  }, {
    nm: 'TC',
    num: '1649',
    cnm: '特克斯和凯科斯群岛'
  }, {
    nm: 'TT',
    num: '1868',
    cnm: '特里尼达和多巴哥'
  }, {
    nm: 'TN',
    num: '216',
    cnm: '突尼斯'
  }, {
    nm: 'TR',
    num: '90',
    cnm: '土耳其'
  }, {
    nm: 'TM',
    num: '993',
    cnm: '土库曼斯坦'
  }, {
    nm: 'VU',
    num: '678',
    cnm: '瓦努阿图'
  }, {
    nm: 'GT',
    num: '502',
    cnm: '危地马拉'
  }, {
    nm: 'VE',
    num: '58',
    cnm: '委内瑞拉'
  }, {
    nm: 'BN',
    num: '673',
    cnm: '文莱'
  }, {
    nm: 'UG',
    num: '256',
    cnm: '乌干达'
  }, {
    nm: 'UA',
    num: '380',
    cnm: '乌克兰'
  }, {
    nm: 'UY',
    num: '598',
    cnm: '乌拉圭'
  }, {
    nm: 'UZ',
    num: '998',
    cnm: '乌兹别克斯坦'
  }, {
    nm: 'ES',
    num: '34',
    cnm: '西班牙'
  }, {
    nm: 'GR',
    num: '30',
    cnm: '希腊'
  }, {
    nm: 'NC',
    num: '687',
    cnm: '新喀里多尼亚'
  }, {
    nm: 'HU',
    num: '36',
    cnm: '匈牙利'
  }, {
    nm: 'SY',
    num: '963',
    cnm: '叙利亚'
  }, {
    nm: 'JM',
    num: '1876',
    cnm: '牙买加'
  }, {
    nm: 'AM',
    num: '374',
    cnm: '亚美尼亚'
  }, {
    nm: 'YE',
    num: '967',
    cnm: '也门'
  }, {
    nm: 'IQ',
    num: '964',
    cnm: '伊拉克'
  }, {
    nm: 'IR',
    num: '98',
    cnm: '伊朗'
  }, {
    nm: 'IL',
    num: '972',
    cnm: '以色列'
  }, {
    nm: 'IT',
    num: '39',
    cnm: '意大利'
  }, {
    nm: 'IN',
    num: '91',
    cnm: '印度'
  }, {
    nm: 'ID',
    num: '62',
    cnm: '印度尼西亚'
  }, {
    nm: 'UK',
    num: '44',
    cnm: '英国'
  }, {
    nm: 'VG',
    num: '1340',
    cnm: '英属维尔京群岛'
  }, {
    nm: 'JO',
    num: '962',
    cnm: '约旦'
  }, {
    nm: 'VN',
    num: '84',
    cnm: '越南'
  }, {
    nm: 'ZM',
    num: '260',
    cnm: '赞比亚'
  }, {
    nm: 'JE',
    num: '44',
    cnm: '泽西岛'
  }, {
    nm: 'TD',
    num: '235',
    cnm: '乍得'
  }, {
    nm: 'GI',
    num: '350',
    cnm: '直布罗陀'
  }, {
    nm: 'CL',
    num: '56',
    cnm: '智利'
  }, {
    nm: 'CF',
    num: '236',
    cnm: '中非共和国'
  }]
};

/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var AICAPCONF = {
  customStyles: {
    gap: "10px"
  },
  wmServerConfig: {
    configServer: "webzjac.reg.163.com",
    apiServer: "webzjac.reg.163.com",
    staticServer: "acstatic-dun.126.net"
  },
  apiServer: ["webzjcaptcha.reg.163.com", "c.dun.163yun.com"]
};

exports.AICAPCONF = AICAPCONF;

/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var cookeiOperations = {
    setCookie: function setCookie(name, value, ext) {
        var Days = 30;
        var exp = new Date(),
            expTime,
            cookieStr;

        if (ext && ext.expires) {
            expTime = ext.expires;
        } else {
            expTime = Days * 24 * 60 * 60 * 1000;
        }
        exp.setTime(exp.getTime() + expTime);
        cookieStr = name + "=" + escape(value) + ";expires=" + exp.toGMTString();
        if (exp.path) {
            cookieStr = cookieStr + ";path=" + exp.path;
        }
        document.cookie = cookieStr;
    },
    getCookie: function getCookie(name) {
        var reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
        var arr = document.cookie.match(reg);

        if (arr) return unescape(arr[2]);else return null;
    },
    delCookie: function delCookie(name) {
        var exp = new Date();
        exp.setTime(exp.getTime() - 1);
        document.cookie = name + "=" + "" + ";expires=" + exp.toGMTString();
    },
    setSessionCookie: function setSessionCookie(name, value) {
        document.cookie = name + "=" + escape(value) + ";path=/";
    },
    clearRedCookie: function clearRedCookie(_key) {
        var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
        keys.forEach(function (key) {
            if (key.indexOf("aq_red_") === 0 && key.indexOf(_key) > 0) {
                document.cookie = key + "=0;expires=" + new Date(0).toUTCString();
            }
        });
    },
    getRedCookieName: function getRedCookieName(id, page, key) {
        var arr = ["aq_red_", id, "_", key, "_", page];
        return arr.join("");
    },
    clearRedCookieAll: function clearRedCookieAll() {
        var _this = this;

        var arr = ["_index", "_safeMobile"];
        arr.forEach(function (item) {
            _this.clearRedCookie(item);
        });
    }
};

module.exports = cookeiOperations;

/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


!function (h) {
  var l,
      c = "<svg><symbol id=\"icon-ic-right\" viewBox=\"0 0 1024 1024\"><path d=\"M887.904744 298.20852c-12.863647-12.063755-33.151673-11.487488-45.215428 1.408843L415.935493 753.983819 182.815858 524.287381c-12.607338-12.416396-32.8644-12.287381-45.280796 0.319957-12.416396 12.576374-12.256417 32.8644 0.352641 45.248112l256.479935 252.671415c0.096331 0.096331 0.223626 0.127295 0.319957 0.223626s0.127295 0.223626 0.223626 0.319957c2.016073 1.919742 4.448434 3.008628 6.784464 4.288456 1.152533 0.672598 2.143368 1.663432 3.359548 2.143368 3.775837 1.47249 7.775299 2.239699 11.743798 2.239699 4.192125 0 8.384249-0.832576 12.287381-2.496009 1.312512-0.543583 2.33603-1.663432 3.552211-2.368714 2.399677-1.408843 4.895686-2.59234 6.944443-4.67206 0.096331-0.096331 0.127295-0.25631 0.223626-0.352641 0.063647-0.096331 0.192662-0.127295 0.287273-0.223626L889.277463 343.420508C901.439269 330.591265 900.768391 310.335923 887.904744 298.20852z\" fill=\"#fff\" width=10 height=10  ></path></symbol><symbol id=\"icon-ic-lock\" viewBox=\"0 0 1024 1024\"><path d=\"M809.6 416.64h-53.76V308.48c0-135.68-108.096-243.84-243.2-243.84-135.04 0-243.2 108.16-243.2 243.84v108.16h-53.76c-29.44 0-53.76 24.32-53.76 53.76v433.28c0 29.44 24.32 53.76 53.76 53.76h593.92c30.08 0 54.4-24.32 54.4-53.76V470.4c0-29.44-24.32-53.76-54.4-53.76z m-135.04 0H350.72V308.48c0-89.6 72.96-162.56 161.92-162.56a162.56 162.56 0 0 1 161.92 162.56v108.16z\" p-id=\"755\" fill=\"#999\" width=15 height=15  ></path></symbol><symbol id=\"icon-ic-clear\" viewBox=\"0 0 1024 1024\"><path d=\"M512 39.385C250.092 39.385 39.385 250.092 39.385 512S250.092 984.615 512 984.615 984.615 773.908 984.615 512 773.908 39.385 512 39.385z m96.492 488.369l153.6 153.6c7.877 7.877 7.877 19.692 0 27.57l-55.138 55.138c-7.877 7.876-19.692 7.876-27.57 0l-153.6-153.6c-7.876-7.877-19.692-7.877-27.569 0l-153.6 153.6c-7.877 7.876-19.692 7.876-27.569 0l-55.138-55.139c-7.877-7.877-7.877-19.692 0-27.57l153.6-153.6c7.877-7.876 7.877-19.691 0-27.568l-155.57-155.57c-7.876-7.877-7.876-19.692 0-27.569l55.139-55.138c7.877-7.877 19.692-7.877 27.57 0l155.568 155.569c7.877 7.877 19.693 7.877 27.57 0l153.6-153.6c7.877-7.877 19.692-7.877 27.569 0l55.138 55.138c7.877 7.877 7.877 19.693 0 27.57l-153.6 153.6c-5.907 7.877-5.907 19.692 0 27.569z\"  ></path></symbol><symbol id=\"icon-ic-search\" viewBox=\"0 0 1024 1024\"><path d=\"M771.165 751.895l176.687 176.687-65.816 65.815-181.992-181.9a418.91 418.91 0 1 1 71.028-60.602z m-305.71 39.378a325.818 325.818 0 1 0 0-651.637 325.818 325.818 0 0 0 0 651.637z\" fill=\"#BBBBBB\" ></path></symbol>\n      <symbol id=\"icon-ic-close\" viewBox=\"0 0 1024 1024\"><path d=\"M512 2.62144C230.67761778 2.62144 2.62144 230.67761778 2.62144 512c0 281.32010667 228.05617778 509.37856 509.37856 509.37856S1021.37856 793.32238222 1021.37856 512 793.32238222 2.62144 512 2.62144z m225.83978667 683.76234667c14.21198222 14.21198222 14.21084445 37.23946667-0.00227556 51.45031111-7.10769778 7.10769778-16.41813333 10.66211555-25.72743111 10.66211555s-18.61859555-3.55100445-25.72515555-10.65642666L512 563.45372445 337.6128 737.83978667c-7.10656 7.10656-16.41813333 10.65642667-25.72743111 10.65642666s-18.62087111-3.55555555-25.72743111-10.66097778c-14.21198222-14.21312-14.21198222-37.23946667 0-51.45144888L460.544 512 286.15907555 337.6128c-14.21198222-14.21198222-14.21084445-37.23946667 0.00227556-51.45031111s37.23946667-14.21767111 51.45144889-0.00568889L512 460.54286222l174.38606222-174.38606222c14.21198222-14.21198222 37.23946667-14.20743111 51.45031111 0.00455111s14.21539555 37.23946667 0.00341334 51.45144889L563.456 512l174.38378667 174.38378667z\"  ></path></symbol><symbol id=\"icon-ic-closeEye\" viewBox=\"0 0 1024 1024\"><path d=\"M941.677 391.71c9.338-14.006 6.225-32.681-6.225-43.575-14.006-10.894-32.681-7.781-43.575 6.225-1.557 1.556-174.3 205.426-379.728 205.426-199.2 0-379.727-205.426-381.283-206.982-10.895-12.45-31.125-14.006-43.576-3.113-12.45 10.894-14.006 31.125-3.113 43.576 3.113 4.668 40.463 46.687 99.6 93.375l-79.37 82.482c-12.45 12.45-10.893 32.681 1.557 43.575 3.113 6.225 10.894 9.338 18.676 9.338 7.78 0 15.562-3.113 21.787-9.338l85.594-88.706c40.463 28.013 88.707 54.47 141.62 73.144l-32.682 110.495c-4.668 17.118 4.67 34.237 21.788 38.906h9.337c14.006 0 26.457-9.338 29.569-23.344l32.681-110.495c24.9 4.669 51.357 7.782 77.813 7.782s52.913-3.113 77.814-7.782l32.68 108.939c3.114 14.006 17.12 23.343 29.57 23.343 3.113 0 6.225 0 7.782-1.556 17.118-4.67 26.456-21.787 21.788-38.906L649.099 595.58c52.914-18.676 101.157-45.132 141.62-73.144l84.038 87.15c6.225 6.225 14.006 9.338 21.787 9.338 7.781 0 15.563-3.113 21.787-9.337 12.45-12.451 12.45-31.125 1.557-43.576l-79.37-82.481c63.808-46.689 101.16-91.82 101.16-91.82z\"  ></path></symbol><symbol id=\"icon-ic-openEye\" viewBox=\"0 0 1024 1024\"><path d=\"M512 192C229.216 192 0 512 0 512s229.216 320 512 320 512-320 512-320-229.216-320-512-320z m0 512c-106.016 0-192-85.984-192-192s85.984-192 192-192 192 85.984 192 192-85.984 192-192 192z m0-320c-70.688 0-128 57.312-128 128s57.312 128 128 128 128-57.312 128-128-57.312-128-128-128z\"  ></path></symbol><symbol id=\"icon-ic-loading\" viewBox=\"0 0 1024 1024\"><path d=\"M514 71c16.569 0 30 13.431 30 30v133c0 16.569-13.431 30-30 30-16.569 0-30-13.431-30-30V101c0-16.569 13.431-30 30-30z m0 689c16.569 0 30 13.431 30 30v133c0 16.569-13.431 30-30 30-16.569 0-30-13.431-30-30V790c0-16.569 13.431-30 30-30zM202.166 200.166c11.716-11.716 30.71-11.716 42.426 0l94.046 94.045c11.715 11.716 11.715 30.71 0 42.427-11.716 11.715-30.711 11.715-42.427 0l-94.045-94.046c-11.716-11.715-11.716-30.71 0-42.426z m487.196 487.196c11.716-11.715 30.711-11.715 42.427 0l94.045 94.046c11.716 11.715 11.716 30.71 0 42.426-11.716 11.716-30.71 11.716-42.426 0l-94.046-94.045c-11.715-11.716-11.715-30.71 0-42.427zM73 512c0-16.569 13.431-30 30-30h133c16.569 0 30 13.431 30 30 0 16.569-13.431 30-30 30H103c-16.569 0-30-13.431-30-30z m689 0c0-16.569 13.431-30 30-30h133c16.569 0 30 13.431 30 30 0 16.569-13.431 30-30 30H792c-16.569 0-30-13.431-30-30zM202.166 823.834c-11.716-11.716-11.716-30.71 0-42.426l94.045-94.046c11.716-11.715 30.71-11.715 42.427 0 11.715 11.716 11.715 30.711 0 42.427l-94.046 94.045c-11.715 11.716-30.71 11.716-42.426 0z m487.196-487.196c-11.715-11.716-11.715-30.711 0-42.427l94.046-94.045c11.715-11.716 30.71-11.716 42.426 0 11.716 11.716 11.716 30.71 0 42.426l-94.045 94.046c-11.716 11.715-30.71 11.715-42.427 0z\" fill=\"#ffffff\" ></path></symbol><symbol id=\"icon-ic-loading-defalut\" viewBox=\"0 0 1024 1024\"><path d=\"M514 71c16.569 0 30 13.431 30 30v133c0 16.569-13.431 30-30 30-16.569 0-30-13.431-30-30V101c0-16.569 13.431-30 30-30z m0 689c16.569 0 30 13.431 30 30v133c0 16.569-13.431 30-30 30-16.569 0-30-13.431-30-30V790c0-16.569 13.431-30 30-30zM202.166 200.166c11.716-11.716 30.71-11.716 42.426 0l94.046 94.045c11.715 11.716 11.715 30.71 0 42.427-11.716 11.715-30.711 11.715-42.427 0l-94.045-94.046c-11.716-11.715-11.716-30.71 0-42.426z m487.196 487.196c11.716-11.715 30.711-11.715 42.427 0l94.045 94.046c11.716 11.715 11.716 30.71 0 42.426-11.716 11.716-30.71 11.716-42.426 0l-94.046-94.045c-11.715-11.716-11.715-30.71 0-42.427zM73 512c0-16.569 13.431-30 30-30h133c16.569 0 30 13.431 30 30 0 16.569-13.431 30-30 30H103c-16.569 0-30-13.431-30-30z m689 0c0-16.569 13.431-30 30-30h133c16.569 0 30 13.431 30 30 0 16.569-13.431 30-30 30H792c-16.569 0-30-13.431-30-30zM202.166 823.834c-11.716-11.716-11.716-30.71 0-42.426l94.045-94.046c11.716-11.715 30.71-11.715 42.427 0 11.715 11.716 11.715 30.711 0 42.427l-94.046 94.045c-11.715 11.716-30.71 11.716-42.426 0z m487.196-487.196c-11.715-11.716-11.715-30.711 0-42.427l94.046-94.045c11.715-11.716 30.71-11.716 42.426 0 11.716 11.716 11.716 30.71 0 42.426l-94.045 94.046c-11.716 11.715-30.71 11.715-42.427 0z\" fill=\"rgba(71,144,255,0.5)\" ></path></symbol><symbol id=\"icon-ic-close1\" viewBox=\"0 0 1024 1024\"><path d=\"M548.25 475.75l398.233 398.336-72.397 72.397L475.75 548.147 77.517 946.483 5.12 874.086 403.456 475.75 5.12 77.517 77.517 5.12l398.336 398.336L873.984 5.12l72.397 72.397-398.336 398.336z\" ></path></symbol><symbol id=\"icon-ic-arrow\" viewBox=\"0 0 1024 1024\"><path d=\"M118.153846 201.688615V846.769231a59.076923 59.076923 0 0 1-118.153846 0v-787.692308A59.076923 59.076923 0 0 1 59.076923 0h787.692308a59.076923 59.076923 0 0 1 0 118.153846H201.688615l785.329231 785.329231a59.076923 59.076923 0 0 1-83.574154 83.495385L118.153846 201.728z\" fill=\"#D0D4DA\" p-id=\"3532\"></path></symbol><symbol id=\"icon-ic-question\" viewBox=\"0 0 1024 1024\"><path d=\"M512 962A450 450 0 1 1 512 62a450 450 0 0 1 0 900z m0-64.28571416A385.71428584 385.71428584 0 1 0 512 126.28571416a385.71428584 385.71428584 0 0 0 0 771.42857168z m12.72857168-143.35714336a51.94285752 51.94285752 0 1 1 0-103.95 51.94285752 51.94285752 0 0 1 0 103.88571504z m0-450c86.01428584 0 155.76428584 44.22857168 155.76428584 124.58571504 0 0-2.12142833 49.95-44.55 83.05714248-0.38571416 1.02857168-41.14285752 29.95714248-66.85714336 62.74285752-0.19285752 22.69285752-19.92857167 41.14285752-44.35714249 41.14285664-24.62142833 0-44.55-18.64285752-44.55-41.59285664 0 0.12857168-7.77857167-21.53571416 44.48571417-62.29285752 22.5-20.12142832 68.85-39.6 66.79285664-83.05714248 0-34.45714248-29.89285752-62.35714248-66.79285664-62.35714336-36.83571416 0-66.72857168 27.9-66.72857168 62.35714336 0 22.88571416-19.92857167 41.52857168-44.48571416 41.5285708-24.62142833 0-44.55-18.64285752-44.55-41.5285708 0-2.95714248 0.32142832-5.78571416 0.96428584-8.55 4.95-74.63571416 72-116.1 154.8-116.1z\" p-id=\"1667\"></path></symbol></svg>",
      a = (l = document.getElementsByTagName("script"))[l.length - 1].getAttribute("data-injectcss");
  if (a && !h.__iconfont__svg__cssinject__) {
    h.__iconfont__svg__cssinject__ = !0;
    try {
      document.write("<style>.svgfont {display: inline-block;width: 1em;height: 1em;fill: currentColor;vertical-align: -0.1em;font-size:16px;}</style>");
    } catch (l) {}
  }
  !function (l) {
    if (document.addEventListener) {
      if (~["complete", "loaded", "interactive"].indexOf(document.readyState)) setTimeout(l, 0);else {
        var a = function a() {
          document.removeEventListener("DOMContentLoaded", a, !1), l();
        };
        document.addEventListener("DOMContentLoaded", a, !1);
      }
    } else document.attachEvent && (c = l, t = h.document, i = !1, e = function e() {
      i || (i = !0, c());
    }, (_o = function o() {
      try {
        t.documentElement.doScroll("left");
      } catch (l) {
        return void setTimeout(_o, 50);
      }
      e();
    })(), t.onreadystatechange = function () {
      "complete" === t.readyState && (t.onreadystatechange = null, e());
    });
    var c, t, i, e, _o;
  }(function () {
    var l, a;
    (l = document.createElement("div")).innerHTML = c, c = null, (a = l.getElementsByTagName("svg")[0]) && (a.setAttribute("aria-hidden", "true"), a.style.position = "absolute", a.style.width = 0, a.style.height = 0, a.style.overflow = "hidden", function (l, a) {
      a.firstChild ? function (l, a) {
        a.parentNode.insertBefore(l, a);
      }(l, a.firstChild) : a.appendChild(l);
    }(a, document.body));
  });
}(window);

/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _fromCodePoint = __webpack_require__(211);

var _fromCodePoint2 = _interopRequireDefault(_fromCodePoint);

var _from = __webpack_require__(209);

var _from2 = _interopRequireDefault(_from);

var _defineProperty = __webpack_require__(210);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _typeof2 = __webpack_require__(215);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

!function (r, n) {
  "object" == ( false ? "undefined" : (0, _typeof3.default)(exports)) && "object" == ( false ? "undefined" : (0, _typeof3.default)(module)) ? module.exports = n() :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (n),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" == (typeof exports === "undefined" ? "undefined" : (0, _typeof3.default)(exports)) ? exports.sm4 = n() : r.sm4 = n();
}("undefined" != typeof self ? self : undefined, function () {
  return function (r) {
    function n(e) {
      if (t[e]) return t[e].exports;var o = t[e] = { i: e, l: !1, exports: {} };return r[e].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }var t = {};return n.m = r, n.c = t, n.d = function (r, t, e) {
      n.o(r, t) || (0, _defineProperty2.default)(r, t, { configurable: !1, enumerable: !0, get: e });
    }, n.n = function (r) {
      var t = r && r.__esModule ? function () {
        return r.default;
      } : function () {
        return r;
      };return n.d(t, "a", t), t;
    }, n.o = function (r, n) {
      return Object.prototype.hasOwnProperty.call(r, n);
    }, n.p = "", n(n.s = 7);
  }({ 7: function _(r, n, t) {
      "use strict";
      function e(r) {
        if (Array.isArray(r)) {
          for (var n = 0, t = Array(r.length); n < r.length; n++) {
            t[n] = r[n];
          }return t;
        }return (0, _from2.default)(r);
      }function o(r) {
        for (var n = [], t = 0, e = r.length; t < e; t += 2) {
          n.push(parseInt(r.substr(t, 2), 16));
        }return n;
      }function i(r) {
        return r.map(function (r) {
          return r = r.toString(16), 1 === r.length ? "0" + r : r;
        }).join("");
      }function u(r) {
        for (var n = [], t = 0, e = r.length; t < e; t++) {
          var o = r.codePointAt(t);if (o <= 127) n.push(o);else if (o <= 2047) n.push(192 | o >>> 6), n.push(128 | 63 & o);else if (o <= 55295 || o >= 57344 && o <= 65535) n.push(224 | o >>> 12), n.push(128 | o >>> 6 & 63), n.push(128 | 63 & o);else {
            if (!(o >= 65536 && o <= 1114111)) throw n.push(o), new Error("input is not supported");t++, n.push(240 | o >>> 18 & 28), n.push(128 | o >>> 12 & 63), n.push(128 | o >>> 6 & 63), n.push(128 | 63 & o);
          }
        }return n;
      }function f(r) {
        for (var n = [], t = 0, e = r.length; t < e; t++) {
          r[t] >= 240 && r[t] <= 247 ? (n.push((0, _fromCodePoint2.default)(((7 & r[t]) << 18) + ((63 & r[t + 1]) << 12) + ((63 & r[t + 2]) << 6) + (63 & r[t + 3]))), t += 3) : r[t] >= 224 && r[t] <= 239 ? (n.push((0, _fromCodePoint2.default)(((15 & r[t]) << 12) + ((63 & r[t + 1]) << 6) + (63 & r[t + 2]))), t += 2) : r[t] >= 192 && r[t] <= 223 ? (n.push((0, _fromCodePoint2.default)(((31 & r[t]) << 6) + (63 & r[t + 1]))), t++) : n.push((0, _fromCodePoint2.default)(r[t]));
        }return n.join("");
      }function s(r, n) {
        return r << n | r >>> 32 - n;
      }function c(r) {
        return (255 & m[r >>> 24 & 255]) << 24 | (255 & m[r >>> 16 & 255]) << 16 | (255 & m[r >>> 8 & 255]) << 8 | 255 & m[255 & r];
      }function p(r) {
        return r ^ s(r, 2) ^ s(r, 10) ^ s(r, 18) ^ s(r, 24);
      }function a(r) {
        return r ^ s(r, 13) ^ s(r, 23);
      }function h(r, n, t) {
        for (var e = new Array(4), o = new Array(4), i = 0; i < 4; i++) {
          o[0] = 255 & r[4 * i], o[1] = 255 & r[4 * i + 1], o[2] = 255 & r[4 * i + 2], o[3] = 255 & r[4 * i + 3], e[i] = o[0] << 24 | o[1] << 16 | o[2] << 8 | o[3];
        }for (var u, f = 0; f < 32; f += 4) {
          u = e[1] ^ e[2] ^ e[3] ^ t[f + 0], e[0] ^= p(c(u)), u = e[2] ^ e[3] ^ e[0] ^ t[f + 1], e[1] ^= p(c(u)), u = e[3] ^ e[0] ^ e[1] ^ t[f + 2], e[2] ^= p(c(u)), u = e[0] ^ e[1] ^ e[2] ^ t[f + 3], e[3] ^= p(c(u));
        }for (var s = 0; s < 16; s += 4) {
          n[s] = e[3 - s / 4] >>> 24 & 255, n[s + 1] = e[3 - s / 4] >>> 16 & 255, n[s + 2] = e[3 - s / 4] >>> 8 & 255, n[s + 3] = 255 & e[3 - s / 4];
        }
      }function l(r, n, t) {
        for (var e = new Array(4), o = new Array(4), i = 0; i < 4; i++) {
          o[0] = 255 & r[0 + 4 * i], o[1] = 255 & r[1 + 4 * i], o[2] = 255 & r[2 + 4 * i], o[3] = 255 & r[3 + 4 * i], e[i] = o[0] << 24 | o[1] << 16 | o[2] << 8 | o[3];
        }e[0] ^= 2746333894, e[1] ^= 1453994832, e[2] ^= 1736282519, e[3] ^= 2993693404;for (var u, f = 0; f < 32; f += 4) {
          u = e[1] ^ e[2] ^ e[3] ^ w[f + 0], n[f + 0] = e[0] ^= a(c(u)), u = e[2] ^ e[3] ^ e[0] ^ w[f + 1], n[f + 1] = e[1] ^= a(c(u)), u = e[3] ^ e[0] ^ e[1] ^ w[f + 2], n[f + 2] = e[2] ^= a(c(u)), u = e[0] ^ e[1] ^ e[2] ^ w[f + 3], n[f + 3] = e[3] ^= a(c(u));
        }if (t === d) for (var s, p = 0; p < 16; p++) {
          s = n[p], n[p] = n[31 - p], n[31 - p] = s;
        }
      }function v(r, n, t) {
        var s = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {},
            c = s.padding,
            p = void 0 === c ? "pkcs#5" : c,
            a = s.mode,
            v = s.iv,
            m = void 0 === v ? [] : v,
            w = s.output,
            b = void 0 === w ? "string" : w;if ("cbc" === a && ("string" == typeof m && (m = o(m)), 16 !== m.length)) throw new Error("iv is invalid");if ("string" == typeof n && (n = o(n)), 16 !== n.length) throw new Error("key is invalid");if (r = "string" == typeof r ? t !== d ? u(r) : o(r) : [].concat(e(r)), "pkcs#5" === p && t !== d) for (var A = y - r.length % y, x = 0; x < A; x++) {
          r.push(A);
        }var j = new Array(g);l(n, j, t);for (var P = [], S = m, k = r.length, C = 0; k >= y;) {
          var E = r.slice(C, C + 16),
              O = new Array(16);if ("cbc" === a) for (var _ = 0; _ < y; _++) {
            t !== d && (E[_] ^= S[_]);
          }h(E, O, j);for (var I = 0; I < y; I++) {
            "cbc" === a && t === d && (O[I] ^= S[I]), P[C + I] = O[I];
          }"cbc" === a && (S = t !== d ? O : E), k -= y, C += y;
        }if ("pkcs#5" === p && t === d) {
          var M = P[P.length - 1];P.splice(P.length - M, M);
        }return "array" !== b ? t !== d ? i(P) : f(P) : P;
      }var d = 0,
          g = 32,
          y = 16,
          m = [214, 144, 233, 254, 204, 225, 61, 183, 22, 182, 20, 194, 40, 251, 44, 5, 43, 103, 154, 118, 42, 190, 4, 195, 170, 68, 19, 38, 73, 134, 6, 153, 156, 66, 80, 244, 145, 239, 152, 122, 51, 84, 11, 67, 237, 207, 172, 98, 228, 179, 28, 169, 201, 8, 232, 149, 128, 223, 148, 250, 117, 143, 63, 166, 71, 7, 167, 252, 243, 115, 23, 186, 131, 89, 60, 25, 230, 133, 79, 168, 104, 107, 129, 178, 113, 100, 218, 139, 248, 235, 15, 75, 112, 86, 157, 53, 30, 36, 14, 94, 99, 88, 209, 162, 37, 34, 124, 59, 1, 33, 120, 135, 212, 0, 70, 87, 159, 211, 39, 82, 76, 54, 2, 231, 160, 196, 200, 158, 234, 191, 138, 210, 64, 199, 56, 181, 163, 247, 242, 206, 249, 97, 21, 161, 224, 174, 93, 164, 155, 52, 26, 85, 173, 147, 50, 48, 245, 140, 177, 227, 29, 246, 226, 46, 130, 102, 202, 96, 192, 41, 35, 171, 13, 83, 78, 111, 213, 219, 55, 69, 222, 253, 142, 47, 3, 255, 106, 114, 109, 108, 91, 81, 141, 27, 175, 146, 187, 221, 188, 127, 17, 217, 92, 65, 31, 16, 90, 216, 10, 193, 49, 136, 165, 205, 123, 189, 45, 116, 208, 18, 184, 229, 180, 176, 137, 105, 151, 74, 12, 150, 119, 126, 101, 185, 241, 9, 197, 110, 198, 132, 24, 240, 125, 236, 58, 220, 77, 32, 121, 238, 95, 62, 215, 203, 57, 72],
          w = [462357, 472066609, 943670861, 1415275113, 1886879365, 2358483617, 2830087869, 3301692121, 3773296373, 4228057617, 404694573, 876298825, 1347903077, 1819507329, 2291111581, 2762715833, 3234320085, 3705924337, 4177462797, 337322537, 808926789, 1280531041, 1752135293, 2223739545, 2695343797, 3166948049, 3638552301, 4110090761, 269950501, 741554753, 1213159005, 1684763257];r.exports = { encrypt: function encrypt(r, n, t) {
          return v(r, n, 1, t);
        }, decrypt: function decrypt(r, n, t) {
          return v(r, n, 0, t);
        } };
    } });
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(531)(module)))

/***/ }),

/***/ 31:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'fail5': '验证失败次数过多，请稍后再试',
  'httpcode-1': '网络异常，请稍后再试',
  'httpcode-400': '网络异常，请稍后再试',
  'httpcode-404': '网络异常，请稍后再试',
  'httpcode-500': '系统繁忙，请稍后再试',
  'httpcode-502': '系统繁忙，请稍后再试',
  'httpcode-503': '系统繁忙，请稍后再试',
  'httpcode-4xx': '网络异常，请稍后再试',
  'httpcode-5xx': '系统繁忙，请稍后再试',
  'httpcode-429': '操作过于频繁，请稍后再试',
  '-1': '请求错误，请稍后再试',
  '415': '请获取短信验证码',
  '108': '请输入图片验证码',
  '109': '请先拖动滑块进行安全验证',
  '110': '请先进行验证',
  '401': '操作超时，请刷新页面重试',
  '409': '您登录过于频繁,请稍后再试',
  '410': '超过IP限制，请稍候再试',
  '420': '账号不存在',
  '433': '系统繁忙，请刷新页面重试',
  '434': '您验证错误次数过多，请稍后再试',
  '435': '验证码错误次数过多，请明天再试',
  '436': '您验证错误次数过多，请稍后再试',
  '437': '验证码错误次数过多，请明天再试',
  '438': '已开启登录保护，请使用网页端登录',
  '500': '系统繁忙，请稍后再试',
  '502': '系统异常，请稍后再试',
  '503': '服务器繁忙，请稍候再试',
  '504': '次数超限，请稍候再试',
  '505': '次数超限，请稍候再试',
  '601': '请求失败，请稍后再试',
  '455': {
    type: 'confirm',
    opt: {
      confirmCnt: '该账号无法使用，请重新注册其他账号',
      confirmTxt: '查看帮助',
      closeTxt: '取消',
      confirm: function confirm() {
        window.open('https://hc.reg.163.com/iTerm/doc.html?id=561');
      }
    }
  },
  '452': {
    type: 'confirm',
    opt: {
      confirmTitel: '账号正在注销中',
      confirmCnt: '账号正在注销中，如需使用，请先撤销注销',
      confirmTxt: '撤销注销',
      closeTxt: '取消',
      confirm: function confirm() {
        window.open('https://id.163.com/mail/logoutQuery.html');
      }
    }
  },
  '453': '该账号已经注销，请更换其他账号',
  '454': {
    type: 'confirm',
    opt: {
      confirmTitel: '绑定安全手机',
      confirmCnt: '如需使用该账号，请先绑定安全手机',
      confirmTxt: '绑定安全手机',
      closeTxt: '取消'
    }
  },
  '422': {
    type: 'confirm',
    opt: {
      confirmCnt: '该账号已被锁定，请前往账号安全中心申请解锁',
      confirmTxt: '账号安全中心',
      closeTxt: '取消',
      confirm: function confirm() {
        location.href = 'https://id.163.com/mail/unlock.html';
      }
    }
  },
  '40110': '账号格式错误'
};

/***/ }),

/***/ 39:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(89);

var _stringify2 = _interopRequireDefault(_stringify);

var _reqwest = __webpack_require__(476);

var _reqwest2 = _interopRequireDefault(_reqwest);

var _util = __webpack_require__(12);

var _util2 = _interopRequireDefault(_util);

var _constant = __webpack_require__(88);

var _constant2 = _interopRequireDefault(_constant);

var _codemapper = __webpack_require__(31);

var _codemapper2 = _interopRequireDefault(_codemapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var APIURL = "";

var SMAPIMAP = {
  '/ini': '/dl/zj/mail/ini',
  '/vfcp': '/dl/zj/mail/vfcp',
  '/vftcp': '/dl/zj/mail/vftcp',
  '/vfccp': '/dl/zj/mail/vfccp',
  '/vfscp': '/dl/zj/mail/vfscp',
  '/gt': '/dl/zj/mail/gt',
  '/l': '/dl/zj/mail/l',
  '/powGetP': '/dl/zj/mail/powGetP'
};
var f = function f() {};
var DEFAULTTIME = 10000;
var CROSS = false;
var WITHCRED = false;
var CHANNEL = '0';

var pd = _constant2.default.product;
var pkid = _constant2.default.promark;
var opd = _util2.default.getUrlSearch('product');
var reqProxy = function reqProxy(options) {
  var _host = '/dl';
  var error = options.error || f;
  var success = options.success || f;
  var complete = options.complete || f;
  var method = options.method || 'POST';
  var contentType = options.contentType || 'application/json';
  var data = options.data || {};
  var _url = _host + options.url || '';

  if (document.referrer) {
    data.topURL = document.referrer.slice(0, 200);
  }
  window.$RTID = _util2.default.getRtid();

  data.pd = pd;
  data.pkid = pkid;
  data.opd = opd;
  data.rtid = window.$RTID;
  data.channel = CHANNEL;
  if (window.$NEEDV6 && options.url === '/l') {
    data.v6 = 1;
  }
  if (_util2.default.getSmState() && SMAPIMAP[options.url]) {
    method = 'POST';
    contentType = 'application/json';
    data = (0, _stringify2.default)(data);
    data = _util2.default.doSm4(data);
    _url = SMAPIMAP[options.url];
  }
  if (method.toUpperCase() === 'POST' && contentType === 'application/json') {
    data = (0, _stringify2.default)(data);
  }

  var utid = _util2.default.getUtid();

  if (options.url === '/ini') {
    _util2.default._doFlLog(utid, window.$RTID);
  }

  var ajax = (0, _reqwest2.default)({
    timeout: options.timeout || DEFAULTTIME,
    url: _url,
    method: method,
    crossOrigin: options.crossOrigin || CROSS,
    withCredentials: options.withCredentials || WITHCRED,
    contentType: contentType,
    data: data,
    complete: complete,
    type: options.type || 'json'
  }).then(function (_res) {
    if (_res.ret === '200' || _res.ret === '201') {
      success(_res);
    } else {
      error(_res);
    }
  }).fail(function (res) {
    var code = 'httpcode-1';
    var status = void 0;
    if (res && res.status) {
      status = res.status + '';
      if (['400', '404', '500', '502', '503', '429'].indexOf(status) > -1) {
        code = 'httpcode-' + status;
      } else {
        if (status.indexOf('4') === 0) {
          code = 'httpcode-4xx';
        }
        if (status.indexOf('5') === 0) {
          code = 'httpcode-5xx';
        }
      }
    }
    res.ret = code;
    if (options.url === '/powGetP') {} else {
      window.showError(_codemapper2.default[code]);
    }
    error(res);
  }).always(function (_res) {});
  return ajax;
};

exports.default = reqProxy;

/***/ }),

/***/ 456:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 457:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 458:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 459:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 460:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 461:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 462:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 463:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 464:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 465:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 466:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 467:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 468:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 469:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 470:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 471:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 477:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(468)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(178),
  /* template */
  __webpack_require__(523),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 478:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(463)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(179),
  /* template */
  __webpack_require__(511),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 479:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(462)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(180),
  /* template */
  __webpack_require__(510),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 480:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(460)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(181),
  /* template */
  __webpack_require__(508),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(182),
  /* template */
  __webpack_require__(514),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(183),
  /* template */
  __webpack_require__(516),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 483:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(184),
  /* template */
  __webpack_require__(506),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 484:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(467)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(185),
  /* template */
  __webpack_require__(519),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 485:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(186),
  /* template */
  __webpack_require__(515),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 486:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(469)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(187),
  /* template */
  __webpack_require__(524),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 487:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(188),
  /* template */
  __webpack_require__(522),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 488:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(464)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(189),
  /* template */
  __webpack_require__(513),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 489:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(466)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(190),
  /* template */
  __webpack_require__(518),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 490:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(461)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(191),
  /* template */
  __webpack_require__(509),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 491:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(465)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(192),
  /* template */
  __webpack_require__(517),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 492:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(193),
  /* template */
  __webpack_require__(520),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 493:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(194),
  /* template */
  __webpack_require__(505),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 494:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(195),
  /* template */
  __webpack_require__(512),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 495:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(196),
  /* template */
  __webpack_require__(521),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 496:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(458)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(197),
  /* template */
  __webpack_require__(504),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 497:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(470)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(198),
  /* template */
  __webpack_require__(525),
  /* scopeId */
  "data-v-e6d70de0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 498:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(471)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(199),
  /* template */
  __webpack_require__(526),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 499:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(459)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(200),
  /* template */
  __webpack_require__(507),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 500:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(456)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(201),
  /* template */
  __webpack_require__(502),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 501:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(457)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(202),
  /* template */
  __webpack_require__(503),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 502:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}

/***/ }),

/***/ 503:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "account-wrapper",
    style: (_vm.showModal ? 'display:block' : 'display:none')
  }, [_c('div', {
    staticClass: "m-mask confirm-ant-show-mask"
  }), _vm._v(" "), _c('div', {
    staticClass: "account-content"
  }, [_c('div', {
    staticClass: "account-title"
  }, [_c('div', [_vm._v("请选择您要登录的账号")]), _vm._v(" "), _c('i', {
    staticClass: "i-icon i-icon-close",
    on: {
      "click": _vm.closeModal
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "account-info"
  }, [_vm._l((_vm.account), function(item) {
    return _c('div', {
      on: {
        "click": function($event) {
          _vm.chooseAccount(item)
        }
      }
    }, [_vm._v("\n        " + _vm._s(item) + "\n      ")])
  }), _vm._v(" "), _c('div', {
    staticClass: "account-another",
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("\n        使用其他账号\n      ")])], 2)])])
},staticRenderFns: []}

/***/ }),

/***/ 504:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "g-bd"
  }, [_c('div', {
    staticClass: "m-tlt"
  }, [_vm._v("登录前请先验证密保卡")]), _vm._v(" "), _c('form', {
    ref: "form",
    staticClass: "m-form"
  }, [_c('form-item', {
    ref: "ppcValidate"
  }, [_c('ul', {
    staticClass: "m-ppc",
    attrs: {
      "id": "ppc-holder"
    }
  }, _vm._l((_vm.cards), function(c, index) {
    return _c('li', {
      ref: "cards",
      refInFor: true
    }, [_c('div', {
      staticClass: "ppc-up"
    }, [_c('div', {
      staticClass: "up-tlt",
      class: 'tlt' + (index + 1)
    }, [_vm._v(_vm._s(c))])]), _vm._v(" "), _c('div', {
      staticClass: "ppc-input"
    }, [_c('input', {
      attrs: {
        "type": "text",
        "maxlength": "3",
        "autocomplete": "off",
        "spellcheck": "false"
      },
      on: {
        "input": function($event) {
          _vm.clearError(index)
        }
      }
    })])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "m-btns g-pd"
  }, [_c('urs-button', {
    ref: "submitBtn",
    attrs: {
      "enableTip": "确定"
    },
    on: {
      "click": _vm.onSubmit
    }
  })], 1)], 1)]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-ft g-pd clearfix c-main"
  }, [_c('a', {
    staticClass: "f-right",
    attrs: {
      "href": "https://gj.reg.163.com/faq/p4.html?ct=21"
    }
  }, [_vm._v("密保卡无法使用？")])])
}]}

/***/ }),

/***/ 505:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "g-bd"
  }, [_c('div', {
    staticClass: "m-tlt"
  }, [_vm._v("登录前请使用任意手机进行安全验证")]), _vm._v(" "), _c('Form', {
    ref: "form",
    staticClass: "m-form iptsBox"
  }, [_c('form-item', {
    staticClass: "m-ipt ipt-h"
  }, [_c('urs-mbinput', {
    ref: "mbInput",
    attrs: {
      "newUp": _vm.newUp,
      "placeholder": "请输入手机号"
    }
  })], 1), _vm._v(" "), (!_vm.newUp) ? _c('form-item', {
    staticClass: "m-ipt ipt-f"
  }, [_c('urs-input', {
    ref: "smsInput",
    attrs: {
      "placeholder": "请输入短信验证码",
      "size": "small",
      "validate": _vm.validateSms
    }
  }, [_c('urs-button', {
    ref: "smsBtn",
    staticClass: "u-btn-sms",
    attrs: {
      "enableTip": "获取验证码",
      "count": _vm.smsCount
    },
    on: {
      "click": _vm.onGetSms
    },
    slot: "button"
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showUp !== '') ? _c('div', {
    staticClass: "m-tlt del-bottom c-main",
    domProps: {
      "innerHTML": _vm._s(_vm.showUp)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "m-btns g-pd"
  }, [_c('urs-button', {
    ref: "submitBtn",
    attrs: {
      "enableTip": "确定"
    },
    on: {
      "click": _vm.onSubmit
    }
  })], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 506:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "form-item-content"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "form-item-tip"
  }, [_vm._v(_vm._s(_vm.validateMessage))])])
},staticRenderFns: []}

/***/ }),

/***/ 507:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-bd"
  }, [_c('div', {
    class: [("w-exception-" + (_vm.mode.mode)), 'w-exception']
  }, [_c('i', {
    staticClass: "bConfirm-close",
    on: {
      "click": function($event) {
        _vm.onClose()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "cnt"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mode.img0),
      expression: "mode.img0"
    }],
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": _vm.mode.img0
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mode.txt0),
      expression: "mode.txt0"
    }],
    class: ['note-txt0', _vm.mode.txt1 ? '' : 'note-center'],
    domProps: {
      "innerHTML": _vm._s(_vm.mode.txt0)
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mode.txt1),
      expression: "mode.txt1"
    }],
    staticClass: "note-txt1"
  }, [_c('bCheckbox', {
    attrs: {
      "label": _vm.mode.txt1,
      "name": _vm.mode.txt1
    },
    model: {
      value: (_vm.checkStatus),
      callback: function($$v) {
        _vm.checkStatus = $$v
      },
      expression: "checkStatus"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "btn-box"
  }, [(_vm.mode.btnTxt0) ? _c('div', {
    staticClass: "pop-btn",
    class: _vm.mode.btnTxt1 ? 'left' : 'center',
    on: {
      "click": _vm.modeClose
    }
  }, [_vm._v(_vm._s(_vm.mode.btnTxt0))]) : _vm._e(), _vm._v(" "), (_vm.mode.btnTxt1) ? _c('div', {
    staticClass: "pop-btn",
    class: [_vm.mode.btnTxt0 ? 'right' : 'center'],
    on: {
      "click": _vm.onConfirm
    }
  }, [_vm._v(_vm._s(_vm.mode.btnTxt1))]) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),

/***/ 508:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.confirmCnt !== '') ? _c('div', {
    staticClass: "m-confirm"
  }, [_c('div', {
    staticClass: "m-mask confirm-ant-show-mask"
  }), _vm._v(" "), _c('div', {
    staticClass: "m-pop confirm-ant-show-pop"
  }, [(_vm.confirmTitel) ? _c('div', {
    staticClass: "pop-tlt"
  }, [_vm._v(_vm._s(_vm.confirmTitel))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pop-info"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.confirmCnt)
    }
  })]), _vm._v(" "), (_vm.closeTxt) ? _c('div', {
    staticClass: "pop-btn left",
    on: {
      "click": _vm.onClose
    }
  }, [_vm._v(_vm._s(_vm.closeTxt))]) : _vm._e(), _vm._v(" "), (_vm.confirmTxt) ? _c('div', {
    staticClass: "pop-btn",
    class: [_vm.closeTxt ? 'right' : ''],
    on: {
      "click": _vm.onConfirm
    }
  }, [_vm._v(_vm._s(_vm.confirmTxt))]) : _vm._e()])]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 509:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.toastCnt !== '') ? _c('div', {
    staticClass: "com-toast"
  }, [_c('div', {
    staticClass: "b-t ant-show"
  }, [_c('p', {
    staticClass: "p-info"
  }, [_vm._v(_vm._s(_vm.toastCnt))])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 510:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-captcha",
    attrs: {
      "id": "captchaBox"
    }
  }, [(_vm.capType == 1) ? _c('div', [_c('urs-input', {
    ref: "capInput",
    attrs: {
      "size": "small",
      "placeholder": "请输入图片验证码"
    },
    on: {
      "input": _vm.imgcapInput
    }
  }, [_c('div', {
    staticClass: "u-img",
    on: {
      "click": function($event) {
        _vm.initCap()
      }
    },
    slot: "button"
  }, [_c('img', {
    staticClass: "cap-img",
    attrs: {
      "src": _vm.imgCapUrl,
      "alt": "点击获取"
    }
  })])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.capType == 4 || _vm.capType == 5),
      expression: "capType==4||capType==5"
    }],
    staticClass: "u-scap"
  }, [_c('div', {
    ref: "sCaptcha",
    staticClass: "Scaptcha",
    attrs: {
      "id": "Scaptcha"
    }
  })])])
},staticRenderFns: []}

/***/ }),

/***/ 511:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-btn c-main"
  }, [_c('button', {
    ref: "mybutton",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onClick($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.tip))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLoading),
      expression: "showLoading"
    }],
    staticClass: "btn_mask"
  }, [_c('div', {
    staticClass: "btn_loading"
  }, [_c('i', {
    class: _vm.loading_clazz
  })])])])
},staticRenderFns: []}

/***/ }),

/***/ 512:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "g-bd"
  }, [_c('div', {
    staticClass: "m-tlt"
  }, [_vm._v("登录前请先验证安全手机："), _c('span', [_vm._v(_vm._s(_vm.mb))])]), _vm._v(" "), _c('Form', {
    ref: "form",
    staticClass: "m-form"
  }, [_c('form-item', {
    ref: "smsValidate",
    staticClass: "m-ipt ipt-h"
  }, [_c('urs-input', {
    ref: "smsInput",
    attrs: {
      "placeholder": "请输入短信验证码",
      "size": "small",
      "validate": _vm.validateSms
    }
  }, [_c('urs-button', {
    ref: "smsBtn",
    staticClass: "u-btn-sms",
    attrs: {
      "enableTip": "获取验证码",
      "count": _vm.smsCount
    },
    on: {
      "click": _vm.onGetSms
    },
    slot: "button"
  })], 1)], 1), _vm._v(" "), (_vm.showUp !== '') ? _c('div', {
    staticClass: "m-tlt del-bottom c-main",
    domProps: {
      "innerHTML": _vm._s(_vm.showUp)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "m-btns g-pd"
  }, [_c('urs-button', {
    ref: "submitBtn",
    attrs: {
      "enableTip": "确定"
    },
    on: {
      "click": _vm.onSubmit
    }
  })], 1)], 1)], 1), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-ft g-pd clearfix c-main"
  }, [_c('a', {
    staticClass: "f-right",
    attrs: {
      "href": "https://gj.reg.163.com/faq/p4.html?ct=05"
    }
  }, [_vm._v("安全手机无法使用？")])])
}]}

/***/ }),

/***/ 513:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "smsup"
  }, [_c('div', {
    staticClass: "g-bd-2",
    attrs: {
      "id": "g-bd"
    }
  }, [_c('div', {
    staticClass: "m-info-new"
  }, [_c('p', {
    staticClass: "middle"
  }, [_vm._v("验证手机号：" + _vm._s(_vm.mobile)), (_vm.fromluo) ? _c('span', {
    staticClass: "change",
    on: {
      "click": _vm.changeMobile
    }
  }, [_vm._v("切换手机号")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "note2"
  }, [_c('div', {
    staticClass: "tips middle"
  }, [_vm._v("为了确认您的身份，请用该手机发送短信：")]), _vm._v(" "), _c('div', {
    staticClass: "cnt-box f-cf"
  }, [_c('div', {
    staticClass: "middle2"
  }, [_c('p', {
    staticClass: "cnt1"
  }, [_vm._v("编辑短信："), _c('span', {
    staticClass: "u-light"
  }, [_vm._v(_vm._s(_vm.receiveCode1))])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "cnt2"
  }, [_vm._v("发送至："), _c('span', {
    staticClass: "u-light"
  }, [_vm._v(_vm._s(_vm.receiveCode3))])])])])]), _vm._v(" "), _c('p', {
    staticClass: "upsms-note3 middle"
  }, [_vm._v("系统不会进行短信回复，短信费用由运营商收取。")])]), _vm._v(" "), _c('div', {
    staticClass: "m-btn middle"
  }, [_c('div', {
    staticClass: "u-btn"
  }, [_c('div', {
    staticClass: "u-upload-note"
  }, [_c('a', {
    staticClass: "u-note-2",
    attrs: {
      "href": _vm.smscnt
    },
    on: {
      "click": _vm.gosms
    }
  }, [_vm._v("前往发送短信")])])])]), _vm._v(" "), _c('p', {
    staticClass: "upsms-note3 middle"
  }, [_vm._v("如果“前往发送短信”操作失败，请手动发送短信")]), _vm._v(" "), _c('div', {
    staticClass: "middle"
  }, [_c('div', {
    staticClass: "m-btn m-btn-2"
  }, [_c('urs-button', {
    ref: "submitBtn",
    attrs: {
      "enableTip": "我已发送短信，登录"
    },
    on: {
      "click": _vm.checkSmsUp
    }
  })], 1)])])])
},staticRenderFns: []}

/***/ }),

/***/ 514:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-loading no-absolute"
  }, [_c('i', {
    staticClass: "u-error-flag i-icon i-icon-g-error"
  }), _vm._v(" "), _c('p', {
    staticClass: "u-error-info"
  }, [_vm._v(_vm._s(_vm.showError))])])
},staticRenderFns: []}

/***/ }),

/***/ 515:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.options.youAd) ? _c('div', {
    staticClass: "g-hd hd-you"
  }, [_c('a', {
    attrs: {
      "href": _vm.options.youAd.url
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.initFlag),
      expression: "initFlag"
    }],
    staticClass: "u-logo",
    attrs: {
      "src": _vm.options.youAd.img
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "g-hd"
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.initFlag),
      expression: "initFlag"
    }],
    staticClass: "u-logo",
    style: (this.options.logoSize),
    attrs: {
      "src": this.options.proLogo,
      "alt": "网易邮箱账号"
    },
    on: {
      "error": _vm.onLogoError
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "g-bd"
  }, [_c('Form', {
    ref: "form",
    staticClass: "m-form iptsBox"
  }, [_c('form-item', {
    staticClass: "m-ipt ipt-h",
    attrs: {
      "prop": "account"
    }
  }, [_c('suggest', {
    ref: "account",
    attrs: {
      "placeholder": "用户名",
      "name": "account",
      "suffix": _vm.options.suffixDomains,
      "initialValue": _vm.initialValue
    },
    on: {
      "focus": _vm.onClearMsg
    }
  })], 1), _vm._v(" "), _c('form-item', {
    staticClass: "m-ipt ipt-pwd",
    class: [_vm.capType == 1 ? 'ipt-m' : 'ipt-f'],
    attrs: {
      "prop": "pwd"
    }
  }, [_c('urs-pwdinput', {
    ref: "pwd",
    attrs: {
      "placeholder": "密码",
      "needEye": _vm.options.needEye
    },
    on: {
      "focus": _vm.onClearMsg,
      "delete": _vm.onClearMsg
    }
  })], 1), _vm._v(" "), (_vm.capType != 0) ? _c('form-item', {
    staticClass: "m-ipt ipt-f ipt-cap",
    class: _vm.capclazz,
    attrs: {
      "prop": "capture"
    }
  }, [_c('urs-capture', {
    ref: "capture",
    attrs: {
      "capKey": _vm.options.capKey,
      "aiCapKey": _vm.aiCapKey,
      "capType": _vm.capType,
      "opd": _vm.opd,
      "mail": _vm.getFullMail,
      "aicapbtn": _vm.aiCapBtn,
      "autoVerify": _vm.autoVerify
    },
    on: {
      "autoVerify": _vm.doAutoVerify,
      "verify": _vm.verifyCapture,
      "doVerifyLoading": _vm.doVerifyLoading,
      "doAiClose": _vm.doAiClose,
      "doVerify": _vm.doVerify,
      "initSucc": function($event) {
        _vm.onCapInit(1)
      },
      "initError": function($event) {
        _vm.onCapInit(0)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.repairlink) ? _c('div', {
    staticClass: "m-repair-guide"
  }, [_c('div', {
    staticClass: "x-box"
  }, [_c('a', {
    staticClass: "x"
  })]), _vm._v("多次输入错误，是否申请修复密码 "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.repairlink
    }
  }, [_vm._v("修复")])]) : _vm._e(), _vm._v(" "), (_vm.options.needUnLogin !== 0) ? _c('div', {
    staticClass: "u-clauses g-pd"
  }, [_c('div', {
    staticClass: "u-tips c-main"
  }, [_c('span', {
    on: {
      "click": _vm.onCheckBox
    }
  }, [_c('input', {
    ref: "unlogin",
    class: [_vm.checked ? 'checked i-checkbox' : 'i-checkbox'],
    attrs: {
      "type": "checkbox",
      "name": "unlogin"
    }
  }), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checked),
      expression: "checked"
    }],
    staticClass: "i-check i-icon i-icon-check"
  })]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "unlogin"
    },
    on: {
      "click": _vm.onCheckBox
    }
  }, [_vm._v(_vm._s(_vm.unLoginTime) + "天免登录")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "m-btns g-pd"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorTip),
      expression: "errorTip"
    }],
    staticClass: "errorTip"
  }, [_vm._v(_vm._s(_vm.errorTip))]), _vm._v(" "), _c('urs-button', {
    ref: "submitBtn",
    attrs: {
      "enableTip": _vm.nextbtntxt
    },
    on: {
      "click": _vm.onLogin
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "g-ft g-pd clearfix c-main"
  }, [_c('a', {
    staticClass: "f-left",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.goFindPwd
    }
  }, [_vm._v("忘记密码")]), _vm._v(" "), _c('a', {
    staticClass: "f-right",
    attrs: {
      "href": _vm.zcUrl
    }
  }, [_vm._v("去注册")])]), _vm._v(" "), (_vm.options.showMailAd) ? _c('div', {
    staticClass: "g-mail-ad c-main"
  }, [(_vm.options.showMailAd) ? _c('a', {
    attrs: {
      "href": _vm.mailUrl
    }
  }, [_vm._v("电脑版邮箱登录")]) : _vm._e(), _c('br'), _vm._v(" "), (_vm.options.showMailAd) ? _c('a', {
    attrs: {
      "href": "https://mail.163.com/dashi/dlpro.html?from=mail30"
    }
  }, [_vm._v("官方邮箱APP，提醒更及时>>")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('pre-account', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.preAccount.length > 1),
      expression: "preAccount.length>1"
    }],
    attrs: {
      "account": _vm.preAccount
    },
    on: {
      "choose": _vm.fillAccount,
      "closeModal": _vm.closeModal
    }
  }), _vm._v(" "), _c('PowerCap', {
    ref: "powerCap",
    on: {
      "sucess": _vm.powerSuccess
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 516:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    ref: "form"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 517:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-ipt"
  }, [_c('div', {
    staticClass: "ipt_wrap",
    class: _vm.size
  }, [_c('input', {
    ref: "input",
    attrs: {
      "name": _vm.name,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled,
      "type": _vm.type,
      "maxlength": _vm.maxlength,
      "autocomplete": "off",
      "spellcheck": "false"
    },
    domProps: {
      "value": _vm.currentValue
    },
    on: {
      "input": _vm.onInput,
      "focus": _vm.onFocus,
      "blur": _vm.onBlur
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ipt_extend"
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    class: _vm.del_icon_clazz,
    on: {
      "click": _vm.onDelete
    }
  }, [_c('svg', {
    staticClass: "icon ",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": '#' + _vm.icontype
    }
  })])]), _vm._v(" "), _vm._t("icon-button")], 2), _vm._v(" "), _vm._t("button")], 2), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 518:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.showSuggest) ? _c('urs-input', {
    ref: "input",
    attrs: {
      "placeholder": "用户名",
      "name": _vm.name,
      "initialValue": _vm.preFilter(_vm.initialValue)
    },
    on: {
      "blur": _vm.onBlur,
      "focus": function($event) {
        _vm.onFocus(false)
      }
    }
  }, [_c('span', {
    staticClass: "suggest_single",
    slot: "icon-button"
  }, [_vm._v(_vm._s(_vm.singleSuffix))])]) : _vm._e(), _vm._v(" "), (_vm.showSuggest) ? _c('urs-input', {
    ref: "input",
    attrs: {
      "placeholder": _vm.placeholder,
      "name": _vm.name,
      "initialValue": _vm.initialValue
    },
    on: {
      "input": _vm.onShow,
      "focus": function($event) {
        _vm.onFocus(true)
      },
      "blur": _vm.onBlur,
      "delete": _vm.onDelete
    }
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.open),
      expression: "open"
    }],
    staticClass: "suggest_drop",
    on: {
      "mousedown": _vm.onSelect
    }
  }, _vm._l((_vm.items), function(item) {
    return _c('li', [_c('span', [_vm._v(_vm._s(item))])])
  }))]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 519:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "g-loading"
  }, [_vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-loading"
  }, [_c('i', {
    staticClass: "i-icon i-icon-loading"
  })])
}]}

/***/ }),

/***/ 520:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c(_vm.currentView, {
    tag: "component",
    attrs: {
      "options": _vm.options
    },
    on: {
      "changeToLogin": _vm.change,
      "changeModule": _vm.changeModule
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-hd"
  }, [_c('h1', [_vm._v("安全验证")])])
}]}

/***/ }),

/***/ 521:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "g-bd"
  }, [_c('div', {
    staticClass: "m-tlt"
  }, [_vm._v("登录前请先验证将军令动态密码")]), _vm._v(" "), _c('Form', {
    staticClass: "m-form"
  }, [_c('form-item', {
    ref: "optValidate",
    staticClass: "m-ipt ipt-h"
  }, [_c('urs-input', {
    ref: "optInput",
    attrs: {
      "placeholder": "请输入动态密码",
      "validate": _vm.validateOpt
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "m-btns g-pd"
  }, [_c('urs-button', {
    ref: "submitBtn",
    attrs: {
      "enableTip": "确定"
    },
    on: {
      "click": _vm.onSubmit
    }
  })], 1)], 1)], 1), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-ft g-pd clearfix c-main"
  }, [_c('a', {
    staticClass: "f-right",
    attrs: {
      "href": "https://gj.reg.163.com/faq/p2.html?ct=04"
    }
  }, [_vm._v("将军令无法使用？")])])
}]}

/***/ }),

/***/ 522:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('urs-input', {
    ref: "input",
    attrs: {
      "name": _vm.name,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled,
      "type": _vm.type,
      "del_icon_clazz": _vm.del_icon_clazz
    },
    on: {
      "focus": _vm.onFocus,
      "delete": _vm.onDelete
    }
  }, [(_vm.needEye) ? _c('i', {
    class: _vm.showPass ? _vm.eye_open_icon_clazz : _vm.eye_close_icon_clazz,
    on: {
      "click": _vm.onEye
    },
    slot: "icon-button"
  }, [_c('svg', {
    staticClass: "icon ",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": _vm.showPass ? _vm.eye_open_icontype : _vm.eye_close_icontype
    }
  })])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 523:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('login', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentView == 'login'),
      expression: "currentView=='login'"
    }],
    ref: "login",
    on: {
      "changeToVerify": _vm.changeToVerify,
      "changeToError": _vm.changeToError,
      "changeToMode": _vm.changeToMode
    }
  }), _vm._v(" "), (_vm.currentView == 'verify') ? _c('verify', {
    attrs: {
      "un": _vm.un,
      "ppdata": _vm.ppdata
    },
    on: {
      "changeToLogin": _vm.changeToLogin
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentView == 'error') ? _c('errorpage', {
    attrs: {
      "errMsg": _vm.errMsg
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentView === 'mode') ? _c('mode', {
    attrs: {
      "mode": _vm.modeData,
      "toUrl": _vm.toUrl
    },
    on: {
      "backLogin": _vm.changeToLogin
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 524:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('urs-input', {
    ref: "input",
    class: _vm.newUp ? _vm.newup_clazz : _vm.old_clazz,
    attrs: {
      "name": _vm.name,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled,
      "type": _vm.type,
      "del_icon_clazz": _vm.del_icon_clazz
    },
    on: {
      "focus": _vm.onFocus
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.newUp),
      expression: "!newUp"
    }],
    staticClass: "u-ic",
    on: {
      "click": _vm.onTogle
    },
    slot: "button"
  }, [_c('em', [_vm._v("+" + _vm._s(_vm.selected.code))]), _c('i', {
    staticClass: "btn"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.open),
      expression: "open"
    }],
    staticClass: "m-mask",
    on: {
      "click": _vm.onChooseC
    }
  }, [_c('div', {
    ref: "countryContainer",
    staticClass: "m-pop-ic"
  }, [_c('ul', {
    staticClass: "u-country"
  }, [_c('li', [_c('i', {
    staticClass: "tlt"
  }, [_vm._v("常用地区")])]), _vm._v(" "), _vm._l((_vm.common), function(o) {
    return _c('li', [_c('i', {
      attrs: {
        "data-code": o.num
      }
    }, [_c('em', {
      attrs: {
        "data-code": o.num
      }
    }, [_vm._v("+" + _vm._s(o.num))]), _vm._v(_vm._s(o.cnm))])])
  }), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "tlt"
  }, [_vm._v("其他地区")])]), _vm._v(" "), _vm._l((_vm.other), function(o) {
    return _c('li', [_c('i', {
      attrs: {
        "data-code": o.num
      }
    }, [_c('em', {
      attrs: {
        "data-code": o.num
      }
    }, [_vm._v("+" + _vm._s(o.num))]), _vm._v(_vm._s(o.cnm))])])
  })], 2)])])])
},staticRenderFns: []}

/***/ }),

/***/ 525:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "bcheckbox",
    on: {
      "click": _vm.change
    }
  }, [_c('span', {
    staticClass: "bcheckbox-default"
  }, [_c('span', {
    class: _vm.getClass
  })]), _vm._v(" "), _c('label', {
    staticClass: "checkbox-label",
    attrs: {
      "for": _vm.name
    }
  }, [_vm._v(_vm._s(_vm.label))])])
},staticRenderFns: []}

/***/ }),

/***/ 526:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "g-loading"
  }, [_vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-loading2"
  }, [_c('div', {
    staticClass: "spinner"
  }, [_c('div', {
    staticClass: "rect1"
  }), _vm._v(" "), _c('div', {
    staticClass: "rect2"
  }), _vm._v(" "), _c('div', {
    staticClass: "rect3"
  }), _vm._v(" "), _c('div', {
    staticClass: "rect4"
  }), _vm._v(" "), _c('div', {
    staticClass: "rect5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "u-jump-info"
  }, [_vm._v("请稍候，正在跳转...")])])
}]}

/***/ }),

/***/ 532:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 533:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(177);
module.exports = __webpack_require__(176);


/***/ }),

/***/ 88:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    capKey: '9bce764f222f26fd94eede1322c5cb6b',
    product: 'ursmaillogin',
    promark: 'dDiOfyc',
    pkht: 'id.163.com',
    needpp: 1,
    needEye: 1,
    suffixDomains: '@163.com,@126.com,@yeah.net,@188.com,@vip.163.com,@vip.126.com',
    logoSize: 'width:auto;height:40px',
    cookieDomains: '',

    needUnLogin: 0,

    defaultUnLogin: 0,

    showMailAd: 0
};

/***/ })

},[533]);


// WEBPACK FOOTER //
// static/js/app.7cf349ded550d8c67cd6.js